// noinspection JSUnusedGlobalSymbols
/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yml` */

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: any; output: any }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any }
  /** The day, does not include a time. */
  Date: { input: any; output: any }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: { input: any; output: any }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: { input: any; output: any }
}

export type Address = Node & {
  __typename?: 'Address'
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  postalCode: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  stateOrProvince: Scalars['String']['output']
  street1: Scalars['String']['output']
  street2?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads and enables pagination through a set of `UserAddress`. */
  userAddresses: UserAddressesConnection
}

export type AddressUserAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserAddressCondition>
  filter?: InputMaybe<UserAddressFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserAddressesOrderBy>>
}

/** The fields on `address` to look up the row to connect. */
export type AddressAddressesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `address` to look up the row to delete. */
export type AddressAddressesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A condition to be used against `Address` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AddressCondition = {
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `postalCode` field. */
  postalCode?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `stateOrProvince` field. */
  stateOrProvince?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `street1` field. */
  street1?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `street2` field. */
  street2?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `Address` object types. All fields are combined with a logical ‘and.’ */
export type AddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AddressFilter>>
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Negates the expression. */
  not?: InputMaybe<AddressFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AddressFilter>>
  /** Filter by the object’s `postalCode` field. */
  postalCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `stateOrProvince` field. */
  stateOrProvince?: InputMaybe<StringFilter>
  /** Filter by the object’s `street1` field. */
  street1?: InputMaybe<StringFilter>
  /** Filter by the object’s `street2` field. */
  street2?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `userAddresses` relation. */
  userAddresses?: InputMaybe<AddressToManyUserAddressFilter>
  /** Some related `userAddresses` exist. */
  userAddressesExist?: InputMaybe<Scalars['Boolean']['input']>
}

/** An input for mutations affecting `Address` */
export type AddressInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  postalCode: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  stateOrProvince: Scalars['String']['input']
  street1: Scalars['String']['input']
  street2?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userAddresses?: InputMaybe<UserAddressesAddressIdFkeyInverseInput>
}

/** The globally unique `ID` look up for the row to connect. */
export type AddressNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `address` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type AddressNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `address` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type AddressOnUserAddressForUserAddressesAddressIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userAddress` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userAddress` being updated. */
  patch: UserAddressPatch
}

/** The fields on `address` to look up the row to update. */
export type AddressOnUserAddressForUserAddressesAddressIdFkeyUsingAddressesPkeyUpdate = {
  /** An object where the defined keys will be set on the `address` being updated. */
  patch: UpdateAddressOnUserAddressForUserAddressesAddressIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `Address`. Fields that are set will be updated. */
export type AddressPatch = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  stateOrProvince?: InputMaybe<Scalars['String']['input']>
  street1?: InputMaybe<Scalars['String']['input']>
  street2?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userAddresses?: InputMaybe<UserAddressesAddressIdFkeyInverseInput>
}

/** A filter to be used against many `UserAddress` object types. All fields are combined with a logical ‘and.’ */
export type AddressToManyUserAddressFilter = {
  /** Every related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAddressFilter>
  /** No related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAddressFilter>
  /** Some related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAddressFilter>
}

/** A connection to a list of `Address` values. */
export type AddressesConnection = {
  __typename?: 'AddressesConnection'
  /** A list of edges which contains the `Address` and cursor to aid in pagination. */
  edges: Array<AddressesEdge>
  /** A list of `Address` objects. */
  nodes: Array<Address>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Address` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Address` edge in the connection. */
export type AddressesEdge = {
  __typename?: 'AddressesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Address` at the end of the edge. */
  node: Address
}

/** Methods to use when ordering `Address`. */
export enum AddressesOrderBy {
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PostalCodeAsc = 'POSTAL_CODE_ASC',
  PostalCodeDesc = 'POSTAL_CODE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateOrProvinceAsc = 'STATE_OR_PROVINCE_ASC',
  StateOrProvinceDesc = 'STATE_OR_PROVINCE_DESC',
  Street_1Asc = 'STREET_1_ASC',
  Street_1Desc = 'STREET_1_DESC',
  Street_2Asc = 'STREET_2_ASC',
  Street_2Desc = 'STREET_2_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserAddressesByAddressIdCountAsc = 'USER_ADDRESSES_BY_ADDRESS_ID__COUNT_ASC',
  UserAddressesByAddressIdCountDesc = 'USER_ADDRESSES_BY_ADDRESS_ID__COUNT_DESC'
}

export type Appointment = Node & {
  __typename?: 'Appointment'
  charmId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `Appointment`. */
  clinician?: Maybe<Clinician>
  clinicianId: Scalars['UUID']['output']
  createdAt: Scalars['Datetime']['output']
  endsAt?: Maybe<Scalars['Datetime']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  notes?: Maybe<Scalars['String']['output']>
  /** Reads a single `Patient` that is related to this `Appointment`. */
  patient?: Maybe<Patient>
  patientId: Scalars['UUID']['output']
  rowId: Scalars['UUID']['output']
  selectionMethod?: Maybe<AppointmentsSelectionMethod>
  /** Reads a single `Service` that is related to this `Appointment`. */
  service?: Maybe<Service>
  serviceId: Scalars['UUID']['output']
  startsAt: Scalars['Datetime']['output']
  status: AppointmentsStatus
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `UserChild` that is related to this `Appointment`. */
  userChild?: Maybe<UserChild>
  userChildId?: Maybe<Scalars['UUID']['output']>
}

/** The fields on `appointment` to look up the row to connect. */
export type AppointmentAppointmentsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `appointment` to look up the row to delete. */
export type AppointmentAppointmentsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

export type AppointmentAvailabilityType = {
  __typename?: 'AppointmentAvailabilityType'
  clinicianId?: Maybe<Scalars['UUID']['output']>
  endsAt?: Maybe<Scalars['Datetime']['output']>
  startsAt?: Maybe<Scalars['Datetime']['output']>
}

/** A filter to be used against `AppointmentAvailabilityType` object types. All fields are combined with a logical ‘and.’ */
export type AppointmentAvailabilityTypeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AppointmentAvailabilityTypeFilter>>
  /** Filter by the object’s `clinicianId` field. */
  clinicianId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>
  /** Negates the expression. */
  not?: InputMaybe<AppointmentAvailabilityTypeFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AppointmentAvailabilityTypeFilter>>
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>
}

/** A connection to a list of `AppointmentAvailabilityType` values. */
export type AppointmentAvailabilityTypesConnection = {
  __typename?: 'AppointmentAvailabilityTypesConnection'
  /** A list of edges which contains the `AppointmentAvailabilityType` and cursor to aid in pagination. */
  edges: Array<AppointmentAvailabilityTypesEdge>
  /** A list of `AppointmentAvailabilityType` objects. */
  nodes: Array<AppointmentAvailabilityType>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AppointmentAvailabilityType` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `AppointmentAvailabilityType` edge in the connection. */
export type AppointmentAvailabilityTypesEdge = {
  __typename?: 'AppointmentAvailabilityTypesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `AppointmentAvailabilityType` at the end of the edge. */
  node: AppointmentAvailabilityType
}

/**
 * A condition to be used against `Appointment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AppointmentCondition = {
  /** Checks for equality with the object’s `charmId` field. */
  charmId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `clinicianId` field. */
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `notes` field. */
  notes?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `patientId` field. */
  patientId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `selectionMethod` field. */
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  /** Checks for equality with the object’s `serviceId` field. */
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<AppointmentsStatus>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userChildId` field. */
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `Appointment` object types. All fields are combined with a logical ‘and.’ */
export type AppointmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AppointmentFilter>>
  /** Filter by the object’s `charmId` field. */
  charmId?: InputMaybe<StringFilter>
  /** Filter by the object’s `clinician` relation. */
  clinician?: InputMaybe<ClinicianFilter>
  /** Filter by the object’s `clinicianId` field. */
  clinicianId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>
  /** Negates the expression. */
  not?: InputMaybe<AppointmentFilter>
  /** Filter by the object’s `notes` field. */
  notes?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AppointmentFilter>>
  /** Filter by the object’s `patient` relation. */
  patient?: InputMaybe<PatientFilter>
  /** Filter by the object’s `patientId` field. */
  patientId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `selectionMethod` field. */
  selectionMethod?: InputMaybe<AppointmentsSelectionMethodFilter>
  /** Filter by the object’s `service` relation. */
  service?: InputMaybe<ServiceFilter>
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<AppointmentsStatusFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `userChild` relation. */
  userChild?: InputMaybe<UserChildFilter>
  /** A related `userChild` exists. */
  userChildExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userChildId` field. */
  userChildId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `Appointment` */
export type AppointmentInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt: Scalars['Datetime']['input']
  status: AppointmentsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type AppointmentNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `appointment` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type AppointmentNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `appointment` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type AppointmentOnAppointmentForAppointmentsClinicianIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `clinician` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: ClinicianPatch
}

/** The fields on `appointment` to look up the row to update. */
export type AppointmentOnAppointmentForAppointmentsClinicianIdFkeyUsingAppointmentsPkeyUpdate = {
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: UpdateAppointmentOnAppointmentForAppointmentsClinicianIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type AppointmentOnAppointmentForAppointmentsPatientIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: PatientPatch
}

/** The fields on `appointment` to look up the row to update. */
export type AppointmentOnAppointmentForAppointmentsPatientIdFkeyUsingAppointmentsPkeyUpdate = {
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: UpdateAppointmentOnAppointmentForAppointmentsPatientIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type AppointmentOnAppointmentForAppointmentsServiceIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `service` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `service` being updated. */
  patch: ServicePatch
}

/** The fields on `appointment` to look up the row to update. */
export type AppointmentOnAppointmentForAppointmentsServiceIdFkeyUsingAppointmentsPkeyUpdate = {
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: UpdateAppointmentOnAppointmentForAppointmentsServiceIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type AppointmentOnAppointmentForAppointmentsUserChildIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userChild` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userChild` being updated. */
  patch: UserChildPatch
}

/** The fields on `appointment` to look up the row to update. */
export type AppointmentOnAppointmentForAppointmentsUserChildIdFkeyUsingAppointmentsPkeyUpdate = {
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: UpdateAppointmentOnAppointmentForAppointmentsUserChildIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `Appointment`. Fields that are set will be updated. */
export type AppointmentPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  status?: InputMaybe<AppointmentsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** The `appointment` to be created by this mutation. */
export type AppointmentsClinicianIdFkeyAppointmentsCreateInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt: Scalars['Datetime']['input']
  status: AppointmentsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** The `clinician` to be created by this mutation. */
export type AppointmentsClinicianIdFkeyCliniciansCreateInput = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `clinician` in the `AppointmentInput` mutation. */
export type AppointmentsClinicianIdFkeyInput = {
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectById?: InputMaybe<ClinicianNodeIdConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ClinicianCliniciansPkeyConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ClinicianCliniciansSlugKeyConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectBySlugPublic?: InputMaybe<ClinicianClinicianSlugPublicConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectByUserId?: InputMaybe<ClinicianCliniciansUniqueUserIdConnect>
  /** A `ClinicianInput` object that will be created and connected to this object. */
  create?: InputMaybe<AppointmentsClinicianIdFkeyCliniciansCreateInput>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteById?: InputMaybe<ClinicianNodeIdDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ClinicianCliniciansPkeyDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ClinicianCliniciansSlugKeyDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteBySlugPublic?: InputMaybe<ClinicianClinicianSlugPublicDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<ClinicianCliniciansUniqueUserIdDelete>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateById?: InputMaybe<AppointmentOnAppointmentForAppointmentsClinicianIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingCliniciansPkeyUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingCliniciansSlugKeyUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateBySlugPublic?: InputMaybe<ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingClinicianSlugPublicUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateByUserId?: InputMaybe<ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingCliniciansUniqueUserIdUpdate>
}

/** Input for the nested mutation of `appointment` in the `ClinicianInput` mutation. */
export type AppointmentsClinicianIdFkeyInverseInput = {
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AppointmentNodeIdConnect>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyConnect>>
  /** A `AppointmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AppointmentsClinicianIdFkeyAppointmentsCreateInput>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AppointmentNodeIdDelete>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyDelete>>
  /** Flag indicating whether all other `appointment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ClinicianOnAppointmentForAppointmentsClinicianIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<AppointmentOnAppointmentForAppointmentsClinicianIdFkeyUsingAppointmentsPkeyUpdate>>
}

/** A connection to a list of `Appointment` values. */
export type AppointmentsConnection = {
  __typename?: 'AppointmentsConnection'
  /** A list of edges which contains the `Appointment` and cursor to aid in pagination. */
  edges: Array<AppointmentsEdge>
  /** A list of `Appointment` objects. */
  nodes: Array<Appointment>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Appointment` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Appointment` edge in the connection. */
export type AppointmentsEdge = {
  __typename?: 'AppointmentsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Appointment` at the end of the edge. */
  node: Appointment
}

/** Methods to use when ordering `Appointment`. */
export enum AppointmentsOrderBy {
  CharmIdAsc = 'CHARM_ID_ASC',
  CharmIdDesc = 'CHARM_ID_DESC',
  ClinicianByClinicianIdCharmIdAsc = 'CLINICIAN_BY_CLINICIAN_ID__CHARM_ID_ASC',
  ClinicianByClinicianIdCharmIdDesc = 'CLINICIAN_BY_CLINICIAN_ID__CHARM_ID_DESC',
  ClinicianByClinicianIdCreatedAtAsc = 'CLINICIAN_BY_CLINICIAN_ID__CREATED_AT_ASC',
  ClinicianByClinicianIdCreatedAtDesc = 'CLINICIAN_BY_CLINICIAN_ID__CREATED_AT_DESC',
  ClinicianByClinicianIdEmployeeTypeAsc = 'CLINICIAN_BY_CLINICIAN_ID__EMPLOYEE_TYPE_ASC',
  ClinicianByClinicianIdEmployeeTypeDesc = 'CLINICIAN_BY_CLINICIAN_ID__EMPLOYEE_TYPE_DESC',
  ClinicianByClinicianIdIdAsc = 'CLINICIAN_BY_CLINICIAN_ID__ID_ASC',
  ClinicianByClinicianIdIdDesc = 'CLINICIAN_BY_CLINICIAN_ID__ID_DESC',
  ClinicianByClinicianIdIntroductionAsc = 'CLINICIAN_BY_CLINICIAN_ID__INTRODUCTION_ASC',
  ClinicianByClinicianIdIntroductionDesc = 'CLINICIAN_BY_CLINICIAN_ID__INTRODUCTION_DESC',
  ClinicianByClinicianIdSlugAsc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_ASC',
  ClinicianByClinicianIdSlugDesc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_DESC',
  ClinicianByClinicianIdSlugPublicAsc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_PUBLIC_ASC',
  ClinicianByClinicianIdSlugPublicDesc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_PUBLIC_DESC',
  ClinicianByClinicianIdUpdatedAtAsc = 'CLINICIAN_BY_CLINICIAN_ID__UPDATED_AT_ASC',
  ClinicianByClinicianIdUpdatedAtDesc = 'CLINICIAN_BY_CLINICIAN_ID__UPDATED_AT_DESC',
  ClinicianByClinicianIdUserIdAsc = 'CLINICIAN_BY_CLINICIAN_ID__USER_ID_ASC',
  ClinicianByClinicianIdUserIdDesc = 'CLINICIAN_BY_CLINICIAN_ID__USER_ID_DESC',
  ClinicianIdAsc = 'CLINICIAN_ID_ASC',
  ClinicianIdDesc = 'CLINICIAN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NotesAsc = 'NOTES_ASC',
  NotesDesc = 'NOTES_DESC',
  PatientByPatientIdCharmIdAsc = 'PATIENT_BY_PATIENT_ID__CHARM_ID_ASC',
  PatientByPatientIdCharmIdDesc = 'PATIENT_BY_PATIENT_ID__CHARM_ID_DESC',
  PatientByPatientIdCharmRecordIdAsc = 'PATIENT_BY_PATIENT_ID__CHARM_RECORD_ID_ASC',
  PatientByPatientIdCharmRecordIdDesc = 'PATIENT_BY_PATIENT_ID__CHARM_RECORD_ID_DESC',
  PatientByPatientIdCreatedAtAsc = 'PATIENT_BY_PATIENT_ID__CREATED_AT_ASC',
  PatientByPatientIdCreatedAtDesc = 'PATIENT_BY_PATIENT_ID__CREATED_AT_DESC',
  PatientByPatientIdIdAsc = 'PATIENT_BY_PATIENT_ID__ID_ASC',
  PatientByPatientIdIdDesc = 'PATIENT_BY_PATIENT_ID__ID_DESC',
  PatientByPatientIdSlugAsc = 'PATIENT_BY_PATIENT_ID__SLUG_ASC',
  PatientByPatientIdSlugDesc = 'PATIENT_BY_PATIENT_ID__SLUG_DESC',
  PatientByPatientIdUpdatedAtAsc = 'PATIENT_BY_PATIENT_ID__UPDATED_AT_ASC',
  PatientByPatientIdUpdatedAtDesc = 'PATIENT_BY_PATIENT_ID__UPDATED_AT_DESC',
  PatientByPatientIdUserIdAsc = 'PATIENT_BY_PATIENT_ID__USER_ID_ASC',
  PatientByPatientIdUserIdDesc = 'PATIENT_BY_PATIENT_ID__USER_ID_DESC',
  PatientByPatientIdZohoIdAsc = 'PATIENT_BY_PATIENT_ID__ZOHO_ID_ASC',
  PatientByPatientIdZohoIdDesc = 'PATIENT_BY_PATIENT_ID__ZOHO_ID_DESC',
  PatientIdAsc = 'PATIENT_ID_ASC',
  PatientIdDesc = 'PATIENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SelectionMethodAsc = 'SELECTION_METHOD_ASC',
  SelectionMethodDesc = 'SELECTION_METHOD_DESC',
  ServiceByServiceIdCharmServiceIdAsc = 'SERVICE_BY_SERVICE_ID__CHARM_SERVICE_ID_ASC',
  ServiceByServiceIdCharmServiceIdDesc = 'SERVICE_BY_SERVICE_ID__CHARM_SERVICE_ID_DESC',
  ServiceByServiceIdCreatedAtAsc = 'SERVICE_BY_SERVICE_ID__CREATED_AT_ASC',
  ServiceByServiceIdCreatedAtDesc = 'SERVICE_BY_SERVICE_ID__CREATED_AT_DESC',
  ServiceByServiceIdDurationAsc = 'SERVICE_BY_SERVICE_ID__DURATION_ASC',
  ServiceByServiceIdDurationDesc = 'SERVICE_BY_SERVICE_ID__DURATION_DESC',
  ServiceByServiceIdIdAsc = 'SERVICE_BY_SERVICE_ID__ID_ASC',
  ServiceByServiceIdIdDesc = 'SERVICE_BY_SERVICE_ID__ID_DESC',
  ServiceByServiceIdIsActiveAsc = 'SERVICE_BY_SERVICE_ID__IS_ACTIVE_ASC',
  ServiceByServiceIdIsActiveDesc = 'SERVICE_BY_SERVICE_ID__IS_ACTIVE_DESC',
  ServiceByServiceIdNameAsc = 'SERVICE_BY_SERVICE_ID__NAME_ASC',
  ServiceByServiceIdNameDesc = 'SERVICE_BY_SERVICE_ID__NAME_DESC',
  ServiceByServiceIdPriceAsc = 'SERVICE_BY_SERVICE_ID__PRICE_ASC',
  ServiceByServiceIdPriceDesc = 'SERVICE_BY_SERVICE_ID__PRICE_DESC',
  ServiceByServiceIdSlugAsc = 'SERVICE_BY_SERVICE_ID__SLUG_ASC',
  ServiceByServiceIdSlugDesc = 'SERVICE_BY_SERVICE_ID__SLUG_DESC',
  ServiceByServiceIdUpdatedAtAsc = 'SERVICE_BY_SERVICE_ID__UPDATED_AT_ASC',
  ServiceByServiceIdUpdatedAtDesc = 'SERVICE_BY_SERVICE_ID__UPDATED_AT_DESC',
  ServiceIdAsc = 'SERVICE_ID_ASC',
  ServiceIdDesc = 'SERVICE_ID_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserChildByUserChildIdBirthdateAtAsc = 'USER_CHILD_BY_USER_CHILD_ID__BIRTHDATE_AT_ASC',
  UserChildByUserChildIdBirthdateAtDesc = 'USER_CHILD_BY_USER_CHILD_ID__BIRTHDATE_AT_DESC',
  UserChildByUserChildIdCreatedAtAsc = 'USER_CHILD_BY_USER_CHILD_ID__CREATED_AT_ASC',
  UserChildByUserChildIdCreatedAtDesc = 'USER_CHILD_BY_USER_CHILD_ID__CREATED_AT_DESC',
  UserChildByUserChildIdDueAtAsc = 'USER_CHILD_BY_USER_CHILD_ID__DUE_AT_ASC',
  UserChildByUserChildIdDueAtDesc = 'USER_CHILD_BY_USER_CHILD_ID__DUE_AT_DESC',
  UserChildByUserChildIdIdAsc = 'USER_CHILD_BY_USER_CHILD_ID__ID_ASC',
  UserChildByUserChildIdIdDesc = 'USER_CHILD_BY_USER_CHILD_ID__ID_DESC',
  UserChildByUserChildIdNameAsc = 'USER_CHILD_BY_USER_CHILD_ID__NAME_ASC',
  UserChildByUserChildIdNameDesc = 'USER_CHILD_BY_USER_CHILD_ID__NAME_DESC',
  UserChildByUserChildIdUpdatedAtAsc = 'USER_CHILD_BY_USER_CHILD_ID__UPDATED_AT_ASC',
  UserChildByUserChildIdUpdatedAtDesc = 'USER_CHILD_BY_USER_CHILD_ID__UPDATED_AT_DESC',
  UserChildByUserChildIdUserIdAsc = 'USER_CHILD_BY_USER_CHILD_ID__USER_ID_ASC',
  UserChildByUserChildIdUserIdDesc = 'USER_CHILD_BY_USER_CHILD_ID__USER_ID_DESC',
  UserChildIdAsc = 'USER_CHILD_ID_ASC',
  UserChildIdDesc = 'USER_CHILD_ID_DESC'
}

/** The `appointment` to be created by this mutation. */
export type AppointmentsPatientIdFkeyAppointmentsCreateInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt: Scalars['Datetime']['input']
  status: AppointmentsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `patient` in the `AppointmentInput` mutation. */
export type AppointmentsPatientIdFkeyInput = {
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByCharmRecordId?: InputMaybe<PatientPatientsUniqueCharmRecordIdConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectById?: InputMaybe<PatientNodeIdConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByRowId?: InputMaybe<PatientPatientsPkeyConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectBySlug?: InputMaybe<PatientPatientsSlugKeyConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PatientPatientsUniqueUserIdConnect>
  /** A `PatientInput` object that will be created and connected to this object. */
  create?: InputMaybe<AppointmentsPatientIdFkeyPatientsCreateInput>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteByCharmRecordId?: InputMaybe<PatientPatientsUniqueCharmRecordIdDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteById?: InputMaybe<PatientNodeIdDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<PatientPatientsPkeyDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<PatientPatientsSlugKeyDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<PatientPatientsUniqueUserIdDelete>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByCharmRecordId?: InputMaybe<PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsUniqueCharmRecordIdUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateById?: InputMaybe<AppointmentOnAppointmentForAppointmentsPatientIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByRowId?: InputMaybe<PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsPkeyUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateBySlug?: InputMaybe<PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsSlugKeyUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsUniqueUserIdUpdate>
}

/** Input for the nested mutation of `appointment` in the `PatientInput` mutation. */
export type AppointmentsPatientIdFkeyInverseInput = {
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AppointmentNodeIdConnect>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyConnect>>
  /** A `AppointmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AppointmentsPatientIdFkeyAppointmentsCreateInput>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AppointmentNodeIdDelete>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyDelete>>
  /** Flag indicating whether all other `appointment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PatientOnAppointmentForAppointmentsPatientIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<AppointmentOnAppointmentForAppointmentsPatientIdFkeyUsingAppointmentsPkeyUpdate>>
}

/** The `patient` to be created by this mutation. */
export type AppointmentsPatientIdFkeyPatientsCreateInput = {
  appointments?: InputMaybe<AppointmentsPatientIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<PatientsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

export enum AppointmentsSelectionMethod {
  Clinician = 'CLINICIAN',
  Time = 'TIME'
}

/** A filter to be used against AppointmentsSelectionMethod fields. All fields are combined with a logical ‘and.’ */
export type AppointmentsSelectionMethodFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AppointmentsSelectionMethod>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AppointmentsSelectionMethod>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AppointmentsSelectionMethod>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AppointmentsSelectionMethod>
  /** Included in the specified list. */
  in?: InputMaybe<Array<AppointmentsSelectionMethod>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<AppointmentsSelectionMethod>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AppointmentsSelectionMethod>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AppointmentsSelectionMethod>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AppointmentsSelectionMethod>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AppointmentsSelectionMethod>>
}

/** The `appointment` to be created by this mutation. */
export type AppointmentsServiceIdFkeyAppointmentsCreateInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  startsAt: Scalars['Datetime']['input']
  status: AppointmentsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `service` in the `AppointmentInput` mutation. */
export type AppointmentsServiceIdFkeyInput = {
  /** The primary key(s) for `service` for the far side of the relationship. */
  connectById?: InputMaybe<ServiceNodeIdConnect>
  /** The primary key(s) for `service` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ServiceServicesPkeyConnect>
  /** The primary key(s) for `service` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ServiceServicesSlugKeyConnect>
  /** A `ServiceInput` object that will be created and connected to this object. */
  create?: InputMaybe<AppointmentsServiceIdFkeyServicesCreateInput>
  /** The primary key(s) for `service` for the far side of the relationship. */
  deleteById?: InputMaybe<ServiceNodeIdDelete>
  /** The primary key(s) for `service` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ServiceServicesPkeyDelete>
  /** The primary key(s) for `service` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ServiceServicesSlugKeyDelete>
  /** The primary key(s) and patch data for `service` for the far side of the relationship. */
  updateById?: InputMaybe<AppointmentOnAppointmentForAppointmentsServiceIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `service` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ServiceOnAppointmentForAppointmentsServiceIdFkeyUsingServicesPkeyUpdate>
  /** The primary key(s) and patch data for `service` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ServiceOnAppointmentForAppointmentsServiceIdFkeyUsingServicesSlugKeyUpdate>
}

/** Input for the nested mutation of `appointment` in the `ServiceInput` mutation. */
export type AppointmentsServiceIdFkeyInverseInput = {
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AppointmentNodeIdConnect>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyConnect>>
  /** A `AppointmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AppointmentsServiceIdFkeyAppointmentsCreateInput>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AppointmentNodeIdDelete>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyDelete>>
  /** Flag indicating whether all other `appointment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ServiceOnAppointmentForAppointmentsServiceIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<AppointmentOnAppointmentForAppointmentsServiceIdFkeyUsingAppointmentsPkeyUpdate>>
}

/** The `service` to be created by this mutation. */
export type AppointmentsServiceIdFkeyServicesCreateInput = {
  appointments?: InputMaybe<AppointmentsServiceIdFkeyInverseInput>
  charmServiceId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  duration: IntervalInput
  isActive: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  price: Scalars['BigFloat']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export enum AppointmentsStatus {
  CheckedIn = 'CHECKED_IN',
  Confirmed = 'CONFIRMED',
  Consulted = 'CONSULTED',
  LateCancellationEmergencyMedicalFireEtc = 'LATE_CANCELLATION_EMERGENCY_MEDICAL_FIRE_ETC_',
  LateCancellationNoShowNoChargeCignaMom = 'LATE_CANCELLATION_NO_SHOW_NO_CHARGE_CIGNA_MOM',
  LateCancellationNoShowNoChargeMedicaid = 'LATE_CANCELLATION_NO_SHOW_NO_CHARGE_MEDICAID',
  LateCancellationNoShowNoChargeRescheduled = 'LATE_CANCELLATION_NO_SHOW_NO_CHARGE_RESCHEDULED',
  LateCancellationNoShowPleaseCharge = 'LATE_CANCELLATION_NO_SHOW_PLEASE_CHARGE',
  NoShowCharge = 'NO_SHOW_CHARGE',
  NoShowNoCharge = 'NO_SHOW_NO_CHARGE',
  Unconfirmed = 'UNCONFIRMED',
  '2HrLateCancelCharge' = '_2_HR_LATE_CANCEL_CHARGE',
  '2HrLateCancelNoCharge' = '_2_HR_LATE_CANCEL_NO_CHARGE'
}

/** A filter to be used against AppointmentsStatus fields. All fields are combined with a logical ‘and.’ */
export type AppointmentsStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AppointmentsStatus>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AppointmentsStatus>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AppointmentsStatus>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AppointmentsStatus>
  /** Included in the specified list. */
  in?: InputMaybe<Array<AppointmentsStatus>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<AppointmentsStatus>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AppointmentsStatus>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AppointmentsStatus>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AppointmentsStatus>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AppointmentsStatus>>
}

/** The `appointment` to be created by this mutation. */
export type AppointmentsUserChildIdFkeyAppointmentsCreateInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt: Scalars['Datetime']['input']
  status: AppointmentsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
}

/** Input for the nested mutation of `userChild` in the `AppointmentInput` mutation. */
export type AppointmentsUserChildIdFkeyInput = {
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  connectById?: InputMaybe<UserChildNodeIdConnect>
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserChildUserChildrenPkeyConnect>
  /** A `UserChildInput` object that will be created and connected to this object. */
  create?: InputMaybe<AppointmentsUserChildIdFkeyUserChildrenCreateInput>
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  deleteById?: InputMaybe<UserChildNodeIdDelete>
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserChildUserChildrenPkeyDelete>
  /** The primary key(s) and patch data for `userChild` for the far side of the relationship. */
  updateById?: InputMaybe<AppointmentOnAppointmentForAppointmentsUserChildIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `userChild` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserChildOnAppointmentForAppointmentsUserChildIdFkeyUsingUserChildrenPkeyUpdate>
}

/** Input for the nested mutation of `appointment` in the `UserChildInput` mutation. */
export type AppointmentsUserChildIdFkeyInverseInput = {
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AppointmentNodeIdConnect>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyConnect>>
  /** A `AppointmentInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<AppointmentsUserChildIdFkeyAppointmentsCreateInput>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AppointmentNodeIdDelete>>
  /** The primary key(s) for `appointment` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<AppointmentAppointmentsPkeyDelete>>
  /** Flag indicating whether all other `appointment` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserChildOnAppointmentForAppointmentsUserChildIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `appointment` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<AppointmentOnAppointmentForAppointmentsUserChildIdFkeyUsingAppointmentsPkeyUpdate>>
}

/** The `userChild` to be created by this mutation. */
export type AppointmentsUserChildIdFkeyUserChildrenCreateInput = {
  appointments?: InputMaybe<AppointmentsUserChildIdFkeyInverseInput>
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  dueAt?: InputMaybe<Scalars['Date']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserChildrenUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>
}

export type Clinician = Node & {
  __typename?: 'Clinician'
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection
  charmId?: Maybe<Scalars['String']['output']>
  /** Reads and enables pagination through a set of `ClinicianAvailability`. */
  clinicianAvailabilities: ClinicianAvailabilitiesConnection
  createdAt: Scalars['Datetime']['output']
  employeeType?: Maybe<EmployeeType>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  introduction?: Maybe<Scalars['String']['output']>
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  slugPublic?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `Clinician`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

export type ClinicianAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AppointmentCondition>
  filter?: InputMaybe<AppointmentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

export type ClinicianClinicianAvailabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ClinicianAvailabilityCondition>
  filter?: InputMaybe<ClinicianAvailabilityFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ClinicianAvailabilitiesOrderBy>>
}

/** The `clinicianAvailability` to be created by this mutation. */
export type ClinicianAvailabilitiesClinicianIdFkeyClinicianAvailabilitiesCreateInput = {
  clinician?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  googleCalendarEventId?: InputMaybe<Scalars['String']['input']>
  isExclusive: Scalars['Boolean']['input']
  recurDuration?: InputMaybe<IntervalInput>
  recurEvery?: InputMaybe<IntervalInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  startsAt: Scalars['Datetime']['input']
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The `clinician` to be created by this mutation. */
export type ClinicianAvailabilitiesClinicianIdFkeyCliniciansCreateInput = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `clinician` in the `ClinicianAvailabilityInput` mutation. */
export type ClinicianAvailabilitiesClinicianIdFkeyInput = {
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectById?: InputMaybe<ClinicianNodeIdConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ClinicianCliniciansPkeyConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ClinicianCliniciansSlugKeyConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectBySlugPublic?: InputMaybe<ClinicianClinicianSlugPublicConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectByUserId?: InputMaybe<ClinicianCliniciansUniqueUserIdConnect>
  /** A `ClinicianInput` object that will be created and connected to this object. */
  create?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyCliniciansCreateInput>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteById?: InputMaybe<ClinicianNodeIdDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ClinicianCliniciansPkeyDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ClinicianCliniciansSlugKeyDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteBySlugPublic?: InputMaybe<ClinicianClinicianSlugPublicDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<ClinicianCliniciansUniqueUserIdDelete>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateById?: InputMaybe<ClinicianAvailabilityOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingCliniciansPkeyUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingCliniciansSlugKeyUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateBySlugPublic?: InputMaybe<ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingClinicianSlugPublicUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateByUserId?: InputMaybe<ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingCliniciansUniqueUserIdUpdate>
}

/** Input for the nested mutation of `clinicianAvailability` in the `ClinicianInput` mutation. */
export type ClinicianAvailabilitiesClinicianIdFkeyInverseInput = {
  /** The primary key(s) for `clinicianAvailability` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ClinicianAvailabilityNodeIdConnect>>
  /** The primary key(s) for `clinicianAvailability` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<ClinicianAvailabilityClinicianAvailabilitiesPkeyConnect>>
  /** A `ClinicianAvailabilityInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ClinicianAvailabilitiesClinicianIdFkeyClinicianAvailabilitiesCreateInput>>
  /** The primary key(s) for `clinicianAvailability` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ClinicianAvailabilityNodeIdDelete>>
  /** The primary key(s) for `clinicianAvailability` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<ClinicianAvailabilityClinicianAvailabilitiesPkeyDelete>>
  /** Flag indicating whether all other `clinicianAvailability` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `clinicianAvailability` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `clinicianAvailability` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<ClinicianAvailabilityOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingClinicianAvailabilitiesPkeyUpdate>
  >
}

/** A connection to a list of `ClinicianAvailability` values. */
export type ClinicianAvailabilitiesConnection = {
  __typename?: 'ClinicianAvailabilitiesConnection'
  /** A list of edges which contains the `ClinicianAvailability` and cursor to aid in pagination. */
  edges: Array<ClinicianAvailabilitiesEdge>
  /** A list of `ClinicianAvailability` objects. */
  nodes: Array<ClinicianAvailability>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `ClinicianAvailability` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `ClinicianAvailability` edge in the connection. */
export type ClinicianAvailabilitiesEdge = {
  __typename?: 'ClinicianAvailabilitiesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `ClinicianAvailability` at the end of the edge. */
  node: ClinicianAvailability
}

/** Methods to use when ordering `ClinicianAvailability`. */
export enum ClinicianAvailabilitiesOrderBy {
  ClinicianByClinicianIdCharmIdAsc = 'CLINICIAN_BY_CLINICIAN_ID__CHARM_ID_ASC',
  ClinicianByClinicianIdCharmIdDesc = 'CLINICIAN_BY_CLINICIAN_ID__CHARM_ID_DESC',
  ClinicianByClinicianIdCreatedAtAsc = 'CLINICIAN_BY_CLINICIAN_ID__CREATED_AT_ASC',
  ClinicianByClinicianIdCreatedAtDesc = 'CLINICIAN_BY_CLINICIAN_ID__CREATED_AT_DESC',
  ClinicianByClinicianIdEmployeeTypeAsc = 'CLINICIAN_BY_CLINICIAN_ID__EMPLOYEE_TYPE_ASC',
  ClinicianByClinicianIdEmployeeTypeDesc = 'CLINICIAN_BY_CLINICIAN_ID__EMPLOYEE_TYPE_DESC',
  ClinicianByClinicianIdIdAsc = 'CLINICIAN_BY_CLINICIAN_ID__ID_ASC',
  ClinicianByClinicianIdIdDesc = 'CLINICIAN_BY_CLINICIAN_ID__ID_DESC',
  ClinicianByClinicianIdIntroductionAsc = 'CLINICIAN_BY_CLINICIAN_ID__INTRODUCTION_ASC',
  ClinicianByClinicianIdIntroductionDesc = 'CLINICIAN_BY_CLINICIAN_ID__INTRODUCTION_DESC',
  ClinicianByClinicianIdSlugAsc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_ASC',
  ClinicianByClinicianIdSlugDesc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_DESC',
  ClinicianByClinicianIdSlugPublicAsc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_PUBLIC_ASC',
  ClinicianByClinicianIdSlugPublicDesc = 'CLINICIAN_BY_CLINICIAN_ID__SLUG_PUBLIC_DESC',
  ClinicianByClinicianIdUpdatedAtAsc = 'CLINICIAN_BY_CLINICIAN_ID__UPDATED_AT_ASC',
  ClinicianByClinicianIdUpdatedAtDesc = 'CLINICIAN_BY_CLINICIAN_ID__UPDATED_AT_DESC',
  ClinicianByClinicianIdUserIdAsc = 'CLINICIAN_BY_CLINICIAN_ID__USER_ID_ASC',
  ClinicianByClinicianIdUserIdDesc = 'CLINICIAN_BY_CLINICIAN_ID__USER_ID_DESC',
  ClinicianIdAsc = 'CLINICIAN_ID_ASC',
  ClinicianIdDesc = 'CLINICIAN_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndsAtAsc = 'ENDS_AT_ASC',
  EndsAtDesc = 'ENDS_AT_DESC',
  GoogleCalendarEventIdAsc = 'GOOGLE_CALENDAR_EVENT_ID_ASC',
  GoogleCalendarEventIdDesc = 'GOOGLE_CALENDAR_EVENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsExclusiveAsc = 'IS_EXCLUSIVE_ASC',
  IsExclusiveDesc = 'IS_EXCLUSIVE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RecurDurationAsc = 'RECUR_DURATION_ASC',
  RecurDurationDesc = 'RECUR_DURATION_DESC',
  RecurEveryAsc = 'RECUR_EVERY_ASC',
  RecurEveryDesc = 'RECUR_EVERY_DESC',
  StartsAtAsc = 'STARTS_AT_ASC',
  StartsAtDesc = 'STARTS_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type ClinicianAvailability = Node & {
  __typename?: 'ClinicianAvailability'
  /** Reads a single `Clinician` that is related to this `ClinicianAvailability`. */
  clinician?: Maybe<Clinician>
  clinicianId: Scalars['UUID']['output']
  createdAt: Scalars['Datetime']['output']
  endsAt?: Maybe<Scalars['Datetime']['output']>
  googleCalendarEventId?: Maybe<Scalars['String']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isExclusive: Scalars['Boolean']['output']
  recurDuration?: Maybe<Interval>
  recurEvery?: Maybe<Interval>
  rowId: Scalars['UUID']['output']
  startsAt: Scalars['Datetime']['output']
  updatedAt: Scalars['Datetime']['output']
}

/** The fields on `clinicianAvailability` to look up the row to connect. */
export type ClinicianAvailabilityClinicianAvailabilitiesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `clinicianAvailability` to look up the row to delete. */
export type ClinicianAvailabilityClinicianAvailabilitiesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/**
 * A condition to be used against `ClinicianAvailability` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ClinicianAvailabilityCondition = {
  /** Checks for equality with the object’s `clinicianId` field. */
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `endsAt` field. */
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `googleCalendarEventId` field. */
  googleCalendarEventId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `isExclusive` field. */
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `recurDuration` field. */
  recurDuration?: InputMaybe<IntervalInput>
  /** Checks for equality with the object’s `recurEvery` field. */
  recurEvery?: InputMaybe<IntervalInput>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `startsAt` field. */
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `ClinicianAvailability` object types. All fields are combined with a logical ‘and.’ */
export type ClinicianAvailabilityFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClinicianAvailabilityFilter>>
  /** Filter by the object’s `clinician` relation. */
  clinician?: InputMaybe<ClinicianFilter>
  /** Filter by the object’s `clinicianId` field. */
  clinicianId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `endsAt` field. */
  endsAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `googleCalendarEventId` field. */
  googleCalendarEventId?: InputMaybe<StringFilter>
  /** Filter by the object’s `isExclusive` field. */
  isExclusive?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<ClinicianAvailabilityFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClinicianAvailabilityFilter>>
  /** Filter by the object’s `recurDuration` field. */
  recurDuration?: InputMaybe<IntervalFilter>
  /** Filter by the object’s `recurEvery` field. */
  recurEvery?: InputMaybe<IntervalFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `startsAt` field. */
  startsAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `ClinicianAvailability` */
export type ClinicianAvailabilityInput = {
  clinician?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  googleCalendarEventId?: InputMaybe<Scalars['String']['input']>
  isExclusive: Scalars['Boolean']['input']
  recurDuration?: InputMaybe<IntervalInput>
  recurEvery?: InputMaybe<IntervalInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  startsAt: Scalars['Datetime']['input']
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type ClinicianAvailabilityNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `clinicianAvailability` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type ClinicianAvailabilityNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `clinicianAvailability` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ClinicianAvailabilityOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `clinician` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: ClinicianPatch
}

/** The fields on `clinicianAvailability` to look up the row to update. */
export type ClinicianAvailabilityOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingClinicianAvailabilitiesPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `clinicianAvailability` being updated. */
    patch: UpdateClinicianAvailabilityOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** Represents an update to a `ClinicianAvailability`. Fields that are set will be updated. */
export type ClinicianAvailabilityPatch = {
  clinician?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  googleCalendarEventId?: InputMaybe<Scalars['String']['input']>
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>
  recurDuration?: InputMaybe<IntervalInput>
  recurEvery?: InputMaybe<IntervalInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The fields on `clinician` to look up the row to connect. */
export type ClinicianClinicianSlugPublicConnect = {
  slugPublic: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to delete. */
export type ClinicianClinicianSlugPublicDelete = {
  slugPublic: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to connect. */
export type ClinicianCliniciansPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `clinician` to look up the row to delete. */
export type ClinicianCliniciansPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `clinician` to look up the row to connect. */
export type ClinicianCliniciansSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to delete. */
export type ClinicianCliniciansSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to connect. */
export type ClinicianCliniciansUniqueUserIdConnect = {
  userId: Scalars['UUID']['input']
}

/** The fields on `clinician` to look up the row to delete. */
export type ClinicianCliniciansUniqueUserIdDelete = {
  userId: Scalars['UUID']['input']
}

/**
 * A condition to be used against `Clinician` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ClinicianCondition = {
  /** Checks for equality with the object’s `charmId` field. */
  charmId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `employeeType` field. */
  employeeType?: InputMaybe<EmployeeType>
  /** Checks for equality with the object’s `introduction` field. */
  introduction?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `slugPublic` field. */
  slugPublic?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `Clinician` object types. All fields are combined with a logical ‘and.’ */
export type ClinicianFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClinicianFilter>>
  /** Filter by the object’s `appointments` relation. */
  appointments?: InputMaybe<ClinicianToManyAppointmentFilter>
  /** Some related `appointments` exist. */
  appointmentsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `charmId` field. */
  charmId?: InputMaybe<StringFilter>
  /** Filter by the object’s `clinicianAvailabilities` relation. */
  clinicianAvailabilities?: InputMaybe<ClinicianToManyClinicianAvailabilityFilter>
  /** Some related `clinicianAvailabilities` exist. */
  clinicianAvailabilitiesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `employeeType` field. */
  employeeType?: InputMaybe<EmployeeTypeFilter>
  /** Filter by the object’s `introduction` field. */
  introduction?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<ClinicianFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClinicianFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `slugPublic` field. */
  slugPublic?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `Clinician` */
export type ClinicianInput = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type ClinicianNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `clinician` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type ClinicianNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `clinician` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ClinicianOnAppointmentForAppointmentsClinicianIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `appointment` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: AppointmentPatch
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingClinicianSlugPublicUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnAppointmentForAppointmentsClinicianIdFkeyPatch
  slugPublic: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingCliniciansPkeyUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnAppointmentForAppointmentsClinicianIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingCliniciansSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnAppointmentForAppointmentsClinicianIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnAppointmentForAppointmentsClinicianIdFkeyUsingCliniciansUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnAppointmentForAppointmentsClinicianIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `clinicianAvailability` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `clinicianAvailability` being updated. */
  patch: ClinicianAvailabilityPatch
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingClinicianSlugPublicUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch
  slugPublic: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingCliniciansPkeyUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingCliniciansSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyUsingCliniciansUniqueUserIdUpdate =
  {
    /** An object where the defined keys will be set on the `clinician` being updated. */
    patch: UpdateClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch
    userId: Scalars['UUID']['input']
  }

/** The globally unique `ID` look up for the row to update. */
export type ClinicianOnClinicianForCliniciansUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianForCliniciansUserIdFkeyUsingClinicianSlugPublicUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianForCliniciansUserIdFkeyPatch
  slugPublic: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianForCliniciansUserIdFkeyUsingCliniciansPkeyUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianForCliniciansUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianForCliniciansUserIdFkeyUsingCliniciansSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianForCliniciansUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `clinician` to look up the row to update. */
export type ClinicianOnClinicianForCliniciansUserIdFkeyUsingCliniciansUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: UpdateClinicianOnClinicianForCliniciansUserIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** Represents an update to a `Clinician`. Fields that are set will be updated. */
export type ClinicianPatch = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against many `Appointment` object types. All fields are combined with a logical ‘and.’ */
export type ClinicianToManyAppointmentFilter = {
  /** Every related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AppointmentFilter>
  /** No related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AppointmentFilter>
  /** Some related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AppointmentFilter>
}

/** A filter to be used against many `ClinicianAvailability` object types. All fields are combined with a logical ‘and.’ */
export type ClinicianToManyClinicianAvailabilityFilter = {
  /** Every related `ClinicianAvailability` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ClinicianAvailabilityFilter>
  /** No related `ClinicianAvailability` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ClinicianAvailabilityFilter>
  /** Some related `ClinicianAvailability` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ClinicianAvailabilityFilter>
}

/** A connection to a list of `Clinician` values. */
export type CliniciansConnection = {
  __typename?: 'CliniciansConnection'
  /** A list of edges which contains the `Clinician` and cursor to aid in pagination. */
  edges: Array<CliniciansEdge>
  /** A list of `Clinician` objects. */
  nodes: Array<Clinician>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Clinician` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Clinician` edge in the connection. */
export type CliniciansEdge = {
  __typename?: 'CliniciansEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Clinician` at the end of the edge. */
  node: Clinician
}

/** Methods to use when ordering `Clinician`. */
export enum CliniciansOrderBy {
  AppointmentsByClinicianIdCountAsc = 'APPOINTMENTS_BY_CLINICIAN_ID__COUNT_ASC',
  AppointmentsByClinicianIdCountDesc = 'APPOINTMENTS_BY_CLINICIAN_ID__COUNT_DESC',
  CharmIdAsc = 'CHARM_ID_ASC',
  CharmIdDesc = 'CHARM_ID_DESC',
  ClinicianAvailabilitiesByClinicianIdCountAsc = 'CLINICIAN_AVAILABILITIES_BY_CLINICIAN_ID__COUNT_ASC',
  ClinicianAvailabilitiesByClinicianIdCountDesc = 'CLINICIAN_AVAILABILITIES_BY_CLINICIAN_ID__COUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmployeeTypeAsc = 'EMPLOYEE_TYPE_ASC',
  EmployeeTypeDesc = 'EMPLOYEE_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IntroductionAsc = 'INTRODUCTION_ASC',
  IntroductionDesc = 'INTRODUCTION_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SlugPublicAsc = 'SLUG_PUBLIC_ASC',
  SlugPublicDesc = 'SLUG_PUBLIC_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** The `clinician` to be created by this mutation. */
export type CliniciansUserIdFkeyCliniciansCreateInput = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
}

/** Input for the nested mutation of `user` in the `ClinicianInput` mutation. */
export type CliniciansUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<CliniciansUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<ClinicianOnClinicianForCliniciansUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnClinicianForCliniciansUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnClinicianForCliniciansUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `clinician` in the `UserInput` mutation. */
export type CliniciansUserIdFkeyInverseInput = {
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectById?: InputMaybe<ClinicianNodeIdConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ClinicianCliniciansPkeyConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ClinicianCliniciansSlugKeyConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectBySlugPublic?: InputMaybe<ClinicianClinicianSlugPublicConnect>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  connectByUserId?: InputMaybe<ClinicianCliniciansUniqueUserIdConnect>
  /** A `ClinicianInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<CliniciansUserIdFkeyCliniciansCreateInput>>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteById?: InputMaybe<ClinicianNodeIdDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ClinicianCliniciansPkeyDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ClinicianCliniciansSlugKeyDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteBySlugPublic?: InputMaybe<ClinicianClinicianSlugPublicDelete>
  /** The primary key(s) for `clinician` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<ClinicianCliniciansUniqueUserIdDelete>
  /** Flag indicating whether all other `clinician` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnClinicianForCliniciansUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ClinicianOnClinicianForCliniciansUserIdFkeyUsingCliniciansPkeyUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ClinicianOnClinicianForCliniciansUserIdFkeyUsingCliniciansSlugKeyUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateBySlugPublic?: InputMaybe<ClinicianOnClinicianForCliniciansUserIdFkeyUsingClinicianSlugPublicUpdate>
  /** The primary key(s) and patch data for `clinician` for the far side of the relationship. */
  updateByUserId?: InputMaybe<ClinicianOnClinicianForCliniciansUserIdFkeyUsingCliniciansUniqueUserIdUpdate>
}

/** The `user` to be created by this mutation. */
export type CliniciansUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** All input for the create `Address` mutation. */
export type CreateAddressInput = {
  /** The `Address` to be created by this mutation. */
  address: AddressInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `Address` mutation. */
export type CreateAddressPayload = {
  __typename?: 'CreateAddressPayload'
  /** The `Address` that was created by this mutation. */
  address?: Maybe<Address>
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** The output of our create `Address` mutation. */
export type CreateAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** All input for the create `Appointment` mutation. */
export type CreateAppointmentInput = {
  /** The `Appointment` to be created by this mutation. */
  appointment: AppointmentInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** The output of our create `Appointment` mutation. */
export type CreateAppointmentPayload = {
  __typename?: 'CreateAppointmentPayload'
  /** The `Appointment` that was created by this mutation. */
  appointment?: Maybe<Appointment>
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `Appointment`. */
  clinician?: Maybe<Clinician>
  /** Reads a single `Patient` that is related to this `Appointment`. */
  patient?: Maybe<Patient>
  /** Reads a single `Service` that is related to this `Appointment`. */
  service?: Maybe<Service>
  /** Reads a single `UserChild` that is related to this `Appointment`. */
  userChild?: Maybe<UserChild>
}

/** The output of our create `Appointment` mutation. */
export type CreateAppointmentPayloadAppointmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/** All input for the create `ClinicianAvailability` mutation. */
export type CreateClinicianAvailabilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `ClinicianAvailability` to be created by this mutation. */
  clinicianAvailability: ClinicianAvailabilityInput
}

/** The output of our create `ClinicianAvailability` mutation. */
export type CreateClinicianAvailabilityPayload = {
  __typename?: 'CreateClinicianAvailabilityPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `ClinicianAvailability`. */
  clinician?: Maybe<Clinician>
  /** The `ClinicianAvailability` that was created by this mutation. */
  clinicianAvailability?: Maybe<ClinicianAvailability>
  /** An edge for our `ClinicianAvailability`. May be used by Relay 1. */
  clinicianAvailabilityEdge?: Maybe<ClinicianAvailabilitiesEdge>
}

/** The output of our create `ClinicianAvailability` mutation. */
export type CreateClinicianAvailabilityPayloadClinicianAvailabilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ClinicianAvailabilitiesOrderBy>>
}

/** All input for the create `Clinician` mutation. */
export type CreateClinicianInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `Clinician` to be created by this mutation. */
  clinician: ClinicianInput
}

/** The output of our create `Clinician` mutation. */
export type CreateClinicianPayload = {
  __typename?: 'CreateClinicianPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Clinician` that was created by this mutation. */
  clinician?: Maybe<Clinician>
  /** An edge for our `Clinician`. May be used by Relay 1. */
  clinicianEdge?: Maybe<CliniciansEdge>
  /** Reads a single `User` that is related to this `Clinician`. */
  user?: Maybe<User>
}

/** The output of our create `Clinician` mutation. */
export type CreateClinicianPayloadClinicianEdgeArgs = {
  orderBy?: InputMaybe<Array<CliniciansOrderBy>>
}

/** All input for the create `InsuranceProvider` mutation. */
export type CreateInsuranceProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `InsuranceProvider` to be created by this mutation. */
  insuranceProvider: InsuranceProviderInput
}

/** The output of our create `InsuranceProvider` mutation. */
export type CreateInsuranceProviderPayload = {
  __typename?: 'CreateInsuranceProviderPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `InsuranceProvider` that was created by this mutation. */
  insuranceProvider?: Maybe<InsuranceProvider>
  /** An edge for our `InsuranceProvider`. May be used by Relay 1. */
  insuranceProviderEdge?: Maybe<InsuranceProvidersEdge>
}

/** The output of our create `InsuranceProvider` mutation. */
export type CreateInsuranceProviderPayloadInsuranceProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceProvidersOrderBy>>
}

/** All input for the create `Lead` mutation. */
export type CreateLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `Lead` to be created by this mutation. */
  lead: LeadInput
}

/** The output of our create `Lead` mutation. */
export type CreateLeadPayload = {
  __typename?: 'CreateLeadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Lead` that was created by this mutation. */
  lead?: Maybe<Lead>
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>
  /** Reads a single `ReferralPartner` that is related to this `Lead`. */
  referralPartner?: Maybe<ReferralPartner>
  /** Reads a single `ReferralPartnerSource` that is related to this `Lead`. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** Reads a single `User` that is related to this `Lead`. */
  user?: Maybe<User>
}

/** The output of our create `Lead` mutation. */
export type CreateLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>
}

/** All input for the create `Patient` mutation. */
export type CreatePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `Patient` to be created by this mutation. */
  patient: PatientInput
}

/** The output of our create `Patient` mutation. */
export type CreatePatientPayload = {
  __typename?: 'CreatePatientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Patient` that was created by this mutation. */
  patient?: Maybe<Patient>
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>
  /** Reads a single `User` that is related to this `Patient`. */
  user?: Maybe<User>
}

/** The output of our create `Patient` mutation. */
export type CreatePatientPayloadPatientEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>
}

/** All input for the create `Policy` mutation. */
export type CreatePolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `Policy` to be created by this mutation. */
  policy: PolicyInput
}

/** The output of our create `Policy` mutation. */
export type CreatePolicyPayload = {
  __typename?: 'CreatePolicyPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Policy` that was created by this mutation. */
  policy?: Maybe<Policy>
  /** An edge for our `Policy`. May be used by Relay 1. */
  policyEdge?: Maybe<PoliciesEdge>
}

/** The output of our create `Policy` mutation. */
export type CreatePolicyPayloadPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<PoliciesOrderBy>>
}

/** All input for the create `ReferralPartner` mutation. */
export type CreateReferralPartnerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `ReferralPartner` to be created by this mutation. */
  referralPartner: ReferralPartnerInput
}

/** The output of our create `ReferralPartner` mutation. */
export type CreateReferralPartnerPayload = {
  __typename?: 'CreateReferralPartnerPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `ReferralPartner` that was created by this mutation. */
  referralPartner?: Maybe<ReferralPartner>
  /** An edge for our `ReferralPartner`. May be used by Relay 1. */
  referralPartnerEdge?: Maybe<ReferralPartnersEdge>
}

/** The output of our create `ReferralPartner` mutation. */
export type CreateReferralPartnerPayloadReferralPartnerEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnersOrderBy>>
}

/** All input for the create `ReferralPartnerSource` mutation. */
export type CreateReferralPartnerSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `ReferralPartnerSource` to be created by this mutation. */
  referralPartnerSource: ReferralPartnerSourceInput
}

/** The output of our create `ReferralPartnerSource` mutation. */
export type CreateReferralPartnerSourcePayload = {
  __typename?: 'CreateReferralPartnerSourcePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerSource`. */
  referralPartner?: Maybe<ReferralPartner>
  /** The `ReferralPartnerSource` that was created by this mutation. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** An edge for our `ReferralPartnerSource`. May be used by Relay 1. */
  referralPartnerSourceEdge?: Maybe<ReferralPartnerSourcesEdge>
}

/** The output of our create `ReferralPartnerSource` mutation. */
export type CreateReferralPartnerSourcePayloadReferralPartnerSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnerSourcesOrderBy>>
}

/** All input for the create `ReferralPartnerUpload` mutation. */
export type CreateReferralPartnerUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `ReferralPartnerUpload` to be created by this mutation. */
  referralPartnerUpload: ReferralPartnerUploadInput
}

/** The output of our create `ReferralPartnerUpload` mutation. */
export type CreateReferralPartnerUploadPayload = {
  __typename?: 'CreateReferralPartnerUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerUpload`. */
  referralPartner?: Maybe<ReferralPartner>
  /** The `ReferralPartnerUpload` that was created by this mutation. */
  referralPartnerUpload?: Maybe<ReferralPartnerUpload>
  /** An edge for our `ReferralPartnerUpload`. May be used by Relay 1. */
  referralPartnerUploadEdge?: Maybe<ReferralPartnerUploadsEdge>
  /** Reads a single `Upload` that is related to this `ReferralPartnerUpload`. */
  upload?: Maybe<Upload>
}

/** The output of our create `ReferralPartnerUpload` mutation. */
export type CreateReferralPartnerUploadPayloadReferralPartnerUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnerUploadsOrderBy>>
}

/** All input for the create `Service` mutation. */
export type CreateServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `Service` to be created by this mutation. */
  service: ServiceInput
}

/** The output of our create `Service` mutation. */
export type CreateServicePayload = {
  __typename?: 'CreateServicePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Service` that was created by this mutation. */
  service?: Maybe<Service>
  /** An edge for our `Service`. May be used by Relay 1. */
  serviceEdge?: Maybe<ServicesEdge>
}

/** The output of our create `Service` mutation. */
export type CreateServicePayloadServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<ServicesOrderBy>>
}

/** All input for the create `SupportedLanguage` mutation. */
export type CreateSupportedLanguageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `SupportedLanguage` to be created by this mutation. */
  supportedLanguage: SupportedLanguageInput
}

/** The output of our create `SupportedLanguage` mutation. */
export type CreateSupportedLanguagePayload = {
  __typename?: 'CreateSupportedLanguagePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `SupportedLanguage` that was created by this mutation. */
  supportedLanguage?: Maybe<SupportedLanguage>
  /** An edge for our `SupportedLanguage`. May be used by Relay 1. */
  supportedLanguageEdge?: Maybe<SupportedLanguagesEdge>
}

/** The output of our create `SupportedLanguage` mutation. */
export type CreateSupportedLanguagePayloadSupportedLanguageEdgeArgs = {
  orderBy?: InputMaybe<Array<SupportedLanguagesOrderBy>>
}

/** All input for the create `Upload` mutation. */
export type CreateUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `Upload` to be created by this mutation. */
  upload: UploadInput
}

/** The output of our create `Upload` mutation. */
export type CreateUploadPayload = {
  __typename?: 'CreateUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Upload` that was created by this mutation. */
  upload?: Maybe<Upload>
  /** An edge for our `Upload`. May be used by Relay 1. */
  uploadEdge?: Maybe<UploadsEdge>
  /** Reads a single `User` that is related to this `Upload`. */
  uploader?: Maybe<User>
}

/** The output of our create `Upload` mutation. */
export type CreateUploadPayloadUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UploadsOrderBy>>
}

/** All input for the create `UserAddress` mutation. */
export type CreateUserAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserAddress` to be created by this mutation. */
  userAddress: UserAddressInput
}

/** The output of our create `UserAddress` mutation. */
export type CreateUserAddressPayload = {
  __typename?: 'CreateUserAddressPayload'
  /** Reads a single `Address` that is related to this `UserAddress`. */
  address?: Maybe<Address>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserAddress`. */
  user?: Maybe<User>
  /** The `UserAddress` that was created by this mutation. */
  userAddress?: Maybe<UserAddress>
  /** An edge for our `UserAddress`. May be used by Relay 1. */
  userAddressEdge?: Maybe<UserAddressesEdge>
}

/** The output of our create `UserAddress` mutation. */
export type CreateUserAddressPayloadUserAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserAddressesOrderBy>>
}

/** All input for the create `UserChild` mutation. */
export type CreateUserChildInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserChild` to be created by this mutation. */
  userChild: UserChildInput
}

/** The output of our create `UserChild` mutation. */
export type CreateUserChildPayload = {
  __typename?: 'CreateUserChildPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserChild`. */
  user?: Maybe<User>
  /** The `UserChild` that was created by this mutation. */
  userChild?: Maybe<UserChild>
  /** An edge for our `UserChild`. May be used by Relay 1. */
  userChildEdge?: Maybe<UserChildrenEdge>
}

/** The output of our create `UserChild` mutation. */
export type CreateUserChildPayloadUserChildEdgeArgs = {
  orderBy?: InputMaybe<Array<UserChildrenOrderBy>>
}

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `User` to be created by this mutation. */
  user: UserInput
}

/** All input for the create `UserInsurance` mutation. */
export type CreateUserInsuranceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserInsurance` to be created by this mutation. */
  userInsurance: UserInsuranceInput
}

/** The output of our create `UserInsurance` mutation. */
export type CreateUserInsurancePayload = {
  __typename?: 'CreateUserInsurancePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `InsuranceProvider` that is related to this `UserInsurance`. */
  insuranceProvider?: Maybe<InsuranceProvider>
  /** Reads a single `User` that is related to this `UserInsurance`. */
  user?: Maybe<User>
  /** The `UserInsurance` that was created by this mutation. */
  userInsurance?: Maybe<UserInsurance>
  /** An edge for our `UserInsurance`. May be used by Relay 1. */
  userInsuranceEdge?: Maybe<UserInsurancesEdge>
}

/** The output of our create `UserInsurance` mutation. */
export type CreateUserInsurancePayloadUserInsuranceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInsurancesOrderBy>>
}

/** All input for the create `UserInsuranceUpload` mutation. */
export type CreateUserInsuranceUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserInsuranceUpload` to be created by this mutation. */
  userInsuranceUpload: UserInsuranceUploadInput
}

/** The output of our create `UserInsuranceUpload` mutation. */
export type CreateUserInsuranceUploadPayload = {
  __typename?: 'CreateUserInsuranceUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Upload` that is related to this `UserInsuranceUpload`. */
  upload?: Maybe<Upload>
  /** Reads a single `UserInsurance` that is related to this `UserInsuranceUpload`. */
  userInsurance?: Maybe<UserInsurance>
  /** The `UserInsuranceUpload` that was created by this mutation. */
  userInsuranceUpload?: Maybe<UserInsuranceUpload>
  /** An edge for our `UserInsuranceUpload`. May be used by Relay 1. */
  userInsuranceUploadEdge?: Maybe<UserInsuranceUploadsEdge>
}

/** The output of our create `UserInsuranceUpload` mutation. */
export type CreateUserInsuranceUploadPayloadUserInsuranceUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInsuranceUploadsOrderBy>>
}

/** All input for the create `UserLanguage` mutation. */
export type CreateUserLanguageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserLanguage` to be created by this mutation. */
  userLanguage: UserLanguageInput
}

/** The output of our create `UserLanguage` mutation. */
export type CreateUserLanguagePayload = {
  __typename?: 'CreateUserLanguagePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserLanguage`. */
  user?: Maybe<User>
  /** The `UserLanguage` that was created by this mutation. */
  userLanguage?: Maybe<UserLanguage>
  /** An edge for our `UserLanguage`. May be used by Relay 1. */
  userLanguageEdge?: Maybe<UserLanguagesEdge>
}

/** The output of our create `UserLanguage` mutation. */
export type CreateUserLanguagePayloadUserLanguageEdgeArgs = {
  orderBy?: InputMaybe<Array<UserLanguagesOrderBy>>
}

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>
}

/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>
}

/** All input for the create `UserPaymentMethod` mutation. */
export type CreateUserPaymentMethodInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserPaymentMethod` to be created by this mutation. */
  userPaymentMethod: UserPaymentMethodInput
}

/** The output of our create `UserPaymentMethod` mutation. */
export type CreateUserPaymentMethodPayload = {
  __typename?: 'CreateUserPaymentMethodPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserPaymentMethod`. */
  user?: Maybe<User>
  /** The `UserPaymentMethod` that was created by this mutation. */
  userPaymentMethod?: Maybe<UserPaymentMethod>
  /** An edge for our `UserPaymentMethod`. May be used by Relay 1. */
  userPaymentMethodEdge?: Maybe<UserPaymentMethodsEdge>
}

/** The output of our create `UserPaymentMethod` mutation. */
export type CreateUserPaymentMethodPayloadUserPaymentMethodEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPaymentMethodsOrderBy>>
}

/** All input for the create `UserPaymentProvider` mutation. */
export type CreateUserPaymentProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserPaymentProvider` to be created by this mutation. */
  userPaymentProvider: UserPaymentProviderInput
}

/** The output of our create `UserPaymentProvider` mutation. */
export type CreateUserPaymentProviderPayload = {
  __typename?: 'CreateUserPaymentProviderPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserPaymentProvider`. */
  user?: Maybe<User>
  /** The `UserPaymentProvider` that was created by this mutation. */
  userPaymentProvider?: Maybe<UserPaymentProvider>
  /** An edge for our `UserPaymentProvider`. May be used by Relay 1. */
  userPaymentProviderEdge?: Maybe<UserPaymentProvidersEdge>
}

/** The output of our create `UserPaymentProvider` mutation. */
export type CreateUserPaymentProviderPayloadUserPaymentProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPaymentProvidersOrderBy>>
}

/** All input for the create `UserPhone` mutation. */
export type CreateUserPhoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserPhone` to be created by this mutation. */
  userPhone: UserPhoneInput
}

/** The output of our create `UserPhone` mutation. */
export type CreateUserPhonePayload = {
  __typename?: 'CreateUserPhonePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserPhone`. */
  user?: Maybe<User>
  /** The `UserPhone` that was created by this mutation. */
  userPhone?: Maybe<UserPhone>
  /** An edge for our `UserPhone`. May be used by Relay 1. */
  userPhoneEdge?: Maybe<UserPhonesEdge>
}

/** The output of our create `UserPhone` mutation. */
export type CreateUserPhonePayloadUserPhoneEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPhonesOrderBy>>
}

/** All input for the create `UserPolicy` mutation. */
export type CreateUserPolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserPolicy` to be created by this mutation. */
  userPolicy: UserPolicyInput
}

/** The output of our create `UserPolicy` mutation. */
export type CreateUserPolicyPayload = {
  __typename?: 'CreateUserPolicyPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Policy` that is related to this `UserPolicy`. */
  policy?: Maybe<Policy>
  /** Reads a single `User` that is related to this `UserPolicy`. */
  user?: Maybe<User>
  /** The `UserPolicy` that was created by this mutation. */
  userPolicy?: Maybe<UserPolicy>
  /** An edge for our `UserPolicy`. May be used by Relay 1. */
  userPolicyEdge?: Maybe<UserPoliciesEdge>
}

/** The output of our create `UserPolicy` mutation. */
export type CreateUserPolicyPayloadUserPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPoliciesOrderBy>>
}

/** All input for the create `UserUpload` mutation. */
export type CreateUserUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The `UserUpload` to be created by this mutation. */
  userUpload: UserUploadInput
}

/** The output of our create `UserUpload` mutation. */
export type CreateUserUploadPayload = {
  __typename?: 'CreateUserUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Upload` that is related to this `UserUpload`. */
  upload?: Maybe<Upload>
  /** Reads a single `User` that is related to this `UserUpload`. */
  user?: Maybe<User>
  /** The `UserUpload` that was created by this mutation. */
  userUpload?: Maybe<UserUpload>
  /** An edge for our `UserUpload`. May be used by Relay 1. */
  userUploadEdge?: Maybe<UserUploadsEdge>
}

/** The output of our create `UserUpload` mutation. */
export type CreateUserUploadPayloadUserUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UserUploadsOrderBy>>
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>
}

/** All input for the `deleteAddressById` mutation. */
export type DeleteAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Address` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteAddress` mutation. */
export type DeleteAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Address` mutation. */
export type DeleteAddressPayload = {
  __typename?: 'DeleteAddressPayload'
  /** The `Address` that was deleted by this mutation. */
  address?: Maybe<Address>
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedAddressId?: Maybe<Scalars['ID']['output']>
}

/** The output of our delete `Address` mutation. */
export type DeleteAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** All input for the `deleteAppointmentById` mutation. */
export type DeleteAppointmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Appointment` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteAppointment` mutation. */
export type DeleteAppointmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Appointment` mutation. */
export type DeleteAppointmentPayload = {
  __typename?: 'DeleteAppointmentPayload'
  /** The `Appointment` that was deleted by this mutation. */
  appointment?: Maybe<Appointment>
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `Appointment`. */
  clinician?: Maybe<Clinician>
  deletedAppointmentId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `Patient` that is related to this `Appointment`. */
  patient?: Maybe<Patient>
  /** Reads a single `Service` that is related to this `Appointment`. */
  service?: Maybe<Service>
  /** Reads a single `UserChild` that is related to this `Appointment`. */
  userChild?: Maybe<UserChild>
}

/** The output of our delete `Appointment` mutation. */
export type DeleteAppointmentPayloadAppointmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/** All input for the `deleteClinicianAvailabilityById` mutation. */
export type DeleteClinicianAvailabilityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ClinicianAvailability` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteClinicianAvailability` mutation. */
export type DeleteClinicianAvailabilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `ClinicianAvailability` mutation. */
export type DeleteClinicianAvailabilityPayload = {
  __typename?: 'DeleteClinicianAvailabilityPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `ClinicianAvailability`. */
  clinician?: Maybe<Clinician>
  /** The `ClinicianAvailability` that was deleted by this mutation. */
  clinicianAvailability?: Maybe<ClinicianAvailability>
  /** An edge for our `ClinicianAvailability`. May be used by Relay 1. */
  clinicianAvailabilityEdge?: Maybe<ClinicianAvailabilitiesEdge>
  deletedClinicianAvailabilityId?: Maybe<Scalars['ID']['output']>
}

/** The output of our delete `ClinicianAvailability` mutation. */
export type DeleteClinicianAvailabilityPayloadClinicianAvailabilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ClinicianAvailabilitiesOrderBy>>
}

/** All input for the `deleteClinicianById` mutation. */
export type DeleteClinicianByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Clinician` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteClinicianBySlug` mutation. */
export type DeleteClinicianBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteClinicianBySlugPublic` mutation. */
export type DeleteClinicianBySlugPublicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slugPublic: Scalars['String']['input']
}

/** All input for the `deleteClinicianByUserId` mutation. */
export type DeleteClinicianByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['UUID']['input']
}

/** All input for the `deleteClinician` mutation. */
export type DeleteClinicianInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Clinician` mutation. */
export type DeleteClinicianPayload = {
  __typename?: 'DeleteClinicianPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Clinician` that was deleted by this mutation. */
  clinician?: Maybe<Clinician>
  /** An edge for our `Clinician`. May be used by Relay 1. */
  clinicianEdge?: Maybe<CliniciansEdge>
  deletedClinicianId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `Clinician`. */
  user?: Maybe<User>
}

/** The output of our delete `Clinician` mutation. */
export type DeleteClinicianPayloadClinicianEdgeArgs = {
  orderBy?: InputMaybe<Array<CliniciansOrderBy>>
}

/** All input for the `deleteInsuranceProviderById` mutation. */
export type DeleteInsuranceProviderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `InsuranceProvider` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteInsuranceProviderBySlug` mutation. */
export type DeleteInsuranceProviderBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteInsuranceProvider` mutation. */
export type DeleteInsuranceProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `InsuranceProvider` mutation. */
export type DeleteInsuranceProviderPayload = {
  __typename?: 'DeleteInsuranceProviderPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedInsuranceProviderId?: Maybe<Scalars['ID']['output']>
  /** The `InsuranceProvider` that was deleted by this mutation. */
  insuranceProvider?: Maybe<InsuranceProvider>
  /** An edge for our `InsuranceProvider`. May be used by Relay 1. */
  insuranceProviderEdge?: Maybe<InsuranceProvidersEdge>
}

/** The output of our delete `InsuranceProvider` mutation. */
export type DeleteInsuranceProviderPayloadInsuranceProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceProvidersOrderBy>>
}

/** All input for the `deleteLeadById` mutation. */
export type DeleteLeadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Lead` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteLeadBySlug` mutation. */
export type DeleteLeadBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteLeadByUserId` mutation. */
export type DeleteLeadByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['UUID']['input']
}

/** All input for the `deleteLead` mutation. */
export type DeleteLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Lead` mutation. */
export type DeleteLeadPayload = {
  __typename?: 'DeleteLeadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedLeadId?: Maybe<Scalars['ID']['output']>
  /** The `Lead` that was deleted by this mutation. */
  lead?: Maybe<Lead>
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>
  /** Reads a single `ReferralPartner` that is related to this `Lead`. */
  referralPartner?: Maybe<ReferralPartner>
  /** Reads a single `ReferralPartnerSource` that is related to this `Lead`. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** Reads a single `User` that is related to this `Lead`. */
  user?: Maybe<User>
}

/** The output of our delete `Lead` mutation. */
export type DeleteLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>
}

/** All input for the `deletePatientByCharmRecordId` mutation. */
export type DeletePatientByCharmRecordIdInput = {
  charmRecordId: Scalars['String']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
}

/** All input for the `deletePatientById` mutation. */
export type DeletePatientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Patient` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deletePatientBySlug` mutation. */
export type DeletePatientBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deletePatientByUserId` mutation. */
export type DeletePatientByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  userId: Scalars['UUID']['input']
}

/** All input for the `deletePatient` mutation. */
export type DeletePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Patient` mutation. */
export type DeletePatientPayload = {
  __typename?: 'DeletePatientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedPatientId?: Maybe<Scalars['ID']['output']>
  /** The `Patient` that was deleted by this mutation. */
  patient?: Maybe<Patient>
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>
  /** Reads a single `User` that is related to this `Patient`. */
  user?: Maybe<User>
}

/** The output of our delete `Patient` mutation. */
export type DeletePatientPayloadPatientEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>
}

/** All input for the `deletePolicyById` mutation. */
export type DeletePolicyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Policy` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deletePolicyBySlug` mutation. */
export type DeletePolicyBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deletePolicy` mutation. */
export type DeletePolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Policy` mutation. */
export type DeletePolicyPayload = {
  __typename?: 'DeletePolicyPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedPolicyId?: Maybe<Scalars['ID']['output']>
  /** The `Policy` that was deleted by this mutation. */
  policy?: Maybe<Policy>
  /** An edge for our `Policy`. May be used by Relay 1. */
  policyEdge?: Maybe<PoliciesEdge>
}

/** The output of our delete `Policy` mutation. */
export type DeletePolicyPayloadPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<PoliciesOrderBy>>
}

/** All input for the `deleteReferralPartnerById` mutation. */
export type DeleteReferralPartnerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ReferralPartner` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteReferralPartnerBySlug` mutation. */
export type DeleteReferralPartnerBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteReferralPartnerBySlugPublic` mutation. */
export type DeleteReferralPartnerBySlugPublicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slugPublic: Scalars['String']['input']
}

/** All input for the `deleteReferralPartner` mutation. */
export type DeleteReferralPartnerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `ReferralPartner` mutation. */
export type DeleteReferralPartnerPayload = {
  __typename?: 'DeleteReferralPartnerPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedReferralPartnerId?: Maybe<Scalars['ID']['output']>
  /** The `ReferralPartner` that was deleted by this mutation. */
  referralPartner?: Maybe<ReferralPartner>
  /** An edge for our `ReferralPartner`. May be used by Relay 1. */
  referralPartnerEdge?: Maybe<ReferralPartnersEdge>
}

/** The output of our delete `ReferralPartner` mutation. */
export type DeleteReferralPartnerPayloadReferralPartnerEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnersOrderBy>>
}

/** All input for the `deleteReferralPartnerSourceById` mutation. */
export type DeleteReferralPartnerSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ReferralPartnerSource` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteReferralPartnerSource` mutation. */
export type DeleteReferralPartnerSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `ReferralPartnerSource` mutation. */
export type DeleteReferralPartnerSourcePayload = {
  __typename?: 'DeleteReferralPartnerSourcePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedReferralPartnerSourceId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerSource`. */
  referralPartner?: Maybe<ReferralPartner>
  /** The `ReferralPartnerSource` that was deleted by this mutation. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** An edge for our `ReferralPartnerSource`. May be used by Relay 1. */
  referralPartnerSourceEdge?: Maybe<ReferralPartnerSourcesEdge>
}

/** The output of our delete `ReferralPartnerSource` mutation. */
export type DeleteReferralPartnerSourcePayloadReferralPartnerSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnerSourcesOrderBy>>
}

/** All input for the `deleteReferralPartnerUploadById` mutation. */
export type DeleteReferralPartnerUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ReferralPartnerUpload` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteReferralPartnerUpload` mutation. */
export type DeleteReferralPartnerUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `ReferralPartnerUpload` mutation. */
export type DeleteReferralPartnerUploadPayload = {
  __typename?: 'DeleteReferralPartnerUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedReferralPartnerUploadId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerUpload`. */
  referralPartner?: Maybe<ReferralPartner>
  /** The `ReferralPartnerUpload` that was deleted by this mutation. */
  referralPartnerUpload?: Maybe<ReferralPartnerUpload>
  /** An edge for our `ReferralPartnerUpload`. May be used by Relay 1. */
  referralPartnerUploadEdge?: Maybe<ReferralPartnerUploadsEdge>
  /** Reads a single `Upload` that is related to this `ReferralPartnerUpload`. */
  upload?: Maybe<Upload>
}

/** The output of our delete `ReferralPartnerUpload` mutation. */
export type DeleteReferralPartnerUploadPayloadReferralPartnerUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnerUploadsOrderBy>>
}

/** All input for the `deleteServiceById` mutation. */
export type DeleteServiceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Service` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteServiceBySlug` mutation. */
export type DeleteServiceBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteService` mutation. */
export type DeleteServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Service` mutation. */
export type DeleteServicePayload = {
  __typename?: 'DeleteServicePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedServiceId?: Maybe<Scalars['ID']['output']>
  /** The `Service` that was deleted by this mutation. */
  service?: Maybe<Service>
  /** An edge for our `Service`. May be used by Relay 1. */
  serviceEdge?: Maybe<ServicesEdge>
}

/** The output of our delete `Service` mutation. */
export type DeleteServicePayloadServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<ServicesOrderBy>>
}

/** All input for the `deleteSupportedLanguageById` mutation. */
export type DeleteSupportedLanguageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `SupportedLanguage` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteSupportedLanguage` mutation. */
export type DeleteSupportedLanguageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['Int']['input']
}

/** The output of our delete `SupportedLanguage` mutation. */
export type DeleteSupportedLanguagePayload = {
  __typename?: 'DeleteSupportedLanguagePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedSupportedLanguageId?: Maybe<Scalars['ID']['output']>
  /** The `SupportedLanguage` that was deleted by this mutation. */
  supportedLanguage?: Maybe<SupportedLanguage>
  /** An edge for our `SupportedLanguage`. May be used by Relay 1. */
  supportedLanguageEdge?: Maybe<SupportedLanguagesEdge>
}

/** The output of our delete `SupportedLanguage` mutation. */
export type DeleteSupportedLanguagePayloadSupportedLanguageEdgeArgs = {
  orderBy?: InputMaybe<Array<SupportedLanguagesOrderBy>>
}

/** All input for the `deleteUploadById` mutation. */
export type DeleteUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Upload` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUploadBySlug` mutation. */
export type DeleteUploadBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteUpload` mutation. */
export type DeleteUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `Upload` mutation. */
export type DeleteUploadPayload = {
  __typename?: 'DeleteUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUploadId?: Maybe<Scalars['ID']['output']>
  /** The `Upload` that was deleted by this mutation. */
  upload?: Maybe<Upload>
  /** An edge for our `Upload`. May be used by Relay 1. */
  uploadEdge?: Maybe<UploadsEdge>
  /** Reads a single `User` that is related to this `Upload`. */
  uploader?: Maybe<User>
}

/** The output of our delete `Upload` mutation. */
export type DeleteUploadPayloadUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UploadsOrderBy>>
}

/** All input for the `deleteUserAddressById` mutation. */
export type DeleteUserAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserAddress` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserAddress` mutation. */
export type DeleteUserAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserAddress` mutation. */
export type DeleteUserAddressPayload = {
  __typename?: 'DeleteUserAddressPayload'
  /** Reads a single `Address` that is related to this `UserAddress`. */
  address?: Maybe<Address>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserAddressId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `UserAddress`. */
  user?: Maybe<User>
  /** The `UserAddress` that was deleted by this mutation. */
  userAddress?: Maybe<UserAddress>
  /** An edge for our `UserAddress`. May be used by Relay 1. */
  userAddressEdge?: Maybe<UserAddressesEdge>
}

/** The output of our delete `UserAddress` mutation. */
export type DeleteUserAddressPayloadUserAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserAddressesOrderBy>>
}

/** All input for the `deleteUserById` mutation. */
export type DeleteUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserBySlug` mutation. */
export type DeleteUserBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteUserChildById` mutation. */
export type DeleteUserChildByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserChild` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserChild` mutation. */
export type DeleteUserChildInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserChild` mutation. */
export type DeleteUserChildPayload = {
  __typename?: 'DeleteUserChildPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserChildId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `UserChild`. */
  user?: Maybe<User>
  /** The `UserChild` that was deleted by this mutation. */
  userChild?: Maybe<UserChild>
  /** An edge for our `UserChild`. May be used by Relay 1. */
  userChildEdge?: Maybe<UserChildrenEdge>
}

/** The output of our delete `UserChild` mutation. */
export type DeleteUserChildPayloadUserChildEdgeArgs = {
  orderBy?: InputMaybe<Array<UserChildrenOrderBy>>
}

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** All input for the `deleteUserInsuranceById` mutation. */
export type DeleteUserInsuranceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserInsurance` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserInsurance` mutation. */
export type DeleteUserInsuranceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserInsurance` mutation. */
export type DeleteUserInsurancePayload = {
  __typename?: 'DeleteUserInsurancePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserInsuranceId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `InsuranceProvider` that is related to this `UserInsurance`. */
  insuranceProvider?: Maybe<InsuranceProvider>
  /** Reads a single `User` that is related to this `UserInsurance`. */
  user?: Maybe<User>
  /** The `UserInsurance` that was deleted by this mutation. */
  userInsurance?: Maybe<UserInsurance>
  /** An edge for our `UserInsurance`. May be used by Relay 1. */
  userInsuranceEdge?: Maybe<UserInsurancesEdge>
}

/** The output of our delete `UserInsurance` mutation. */
export type DeleteUserInsurancePayloadUserInsuranceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInsurancesOrderBy>>
}

/** All input for the `deleteUserInsuranceUploadById` mutation. */
export type DeleteUserInsuranceUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserInsuranceUpload` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserInsuranceUpload` mutation. */
export type DeleteUserInsuranceUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserInsuranceUpload` mutation. */
export type DeleteUserInsuranceUploadPayload = {
  __typename?: 'DeleteUserInsuranceUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserInsuranceUploadId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `Upload` that is related to this `UserInsuranceUpload`. */
  upload?: Maybe<Upload>
  /** Reads a single `UserInsurance` that is related to this `UserInsuranceUpload`. */
  userInsurance?: Maybe<UserInsurance>
  /** The `UserInsuranceUpload` that was deleted by this mutation. */
  userInsuranceUpload?: Maybe<UserInsuranceUpload>
  /** An edge for our `UserInsuranceUpload`. May be used by Relay 1. */
  userInsuranceUploadEdge?: Maybe<UserInsuranceUploadsEdge>
}

/** The output of our delete `UserInsuranceUpload` mutation. */
export type DeleteUserInsuranceUploadPayloadUserInsuranceUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInsuranceUploadsOrderBy>>
}

/** All input for the `deleteUserLanguageById` mutation. */
export type DeleteUserLanguageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserLanguage` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserLanguage` mutation. */
export type DeleteUserLanguageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserLanguage` mutation. */
export type DeleteUserLanguagePayload = {
  __typename?: 'DeleteUserLanguagePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserLanguageId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `UserLanguage`. */
  user?: Maybe<User>
  /** The `UserLanguage` that was deleted by this mutation. */
  userLanguage?: Maybe<UserLanguage>
  /** An edge for our `UserLanguage`. May be used by Relay 1. */
  userLanguageEdge?: Maybe<UserLanguagesEdge>
}

/** The output of our delete `UserLanguage` mutation. */
export type DeleteUserLanguagePayloadUserLanguageEdgeArgs = {
  orderBy?: InputMaybe<Array<UserLanguagesOrderBy>>
}

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserId?: Maybe<Scalars['ID']['output']>
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>
}

/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>
}

/** All input for the `deleteUserPaymentMethodById` mutation. */
export type DeleteUserPaymentMethodByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPaymentMethod` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserPaymentMethodBySlug` mutation. */
export type DeleteUserPaymentMethodBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteUserPaymentMethod` mutation. */
export type DeleteUserPaymentMethodInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserPaymentMethod` mutation. */
export type DeleteUserPaymentMethodPayload = {
  __typename?: 'DeleteUserPaymentMethodPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserPaymentMethodId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `UserPaymentMethod`. */
  user?: Maybe<User>
  /** The `UserPaymentMethod` that was deleted by this mutation. */
  userPaymentMethod?: Maybe<UserPaymentMethod>
  /** An edge for our `UserPaymentMethod`. May be used by Relay 1. */
  userPaymentMethodEdge?: Maybe<UserPaymentMethodsEdge>
}

/** The output of our delete `UserPaymentMethod` mutation. */
export type DeleteUserPaymentMethodPayloadUserPaymentMethodEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPaymentMethodsOrderBy>>
}

/** All input for the `deleteUserPaymentProviderById` mutation. */
export type DeleteUserPaymentProviderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPaymentProvider` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserPaymentProviderBySlug` mutation. */
export type DeleteUserPaymentProviderBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  slug: Scalars['String']['input']
}

/** All input for the `deleteUserPaymentProvider` mutation. */
export type DeleteUserPaymentProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserPaymentProvider` mutation. */
export type DeleteUserPaymentProviderPayload = {
  __typename?: 'DeleteUserPaymentProviderPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserPaymentProviderId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `UserPaymentProvider`. */
  user?: Maybe<User>
  /** The `UserPaymentProvider` that was deleted by this mutation. */
  userPaymentProvider?: Maybe<UserPaymentProvider>
  /** An edge for our `UserPaymentProvider`. May be used by Relay 1. */
  userPaymentProviderEdge?: Maybe<UserPaymentProvidersEdge>
}

/** The output of our delete `UserPaymentProvider` mutation. */
export type DeleteUserPaymentProviderPayloadUserPaymentProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPaymentProvidersOrderBy>>
}

/** All input for the `deleteUserPhoneById` mutation. */
export type DeleteUserPhoneByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPhone` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserPhone` mutation. */
export type DeleteUserPhoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserPhone` mutation. */
export type DeleteUserPhonePayload = {
  __typename?: 'DeleteUserPhonePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserPhoneId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `User` that is related to this `UserPhone`. */
  user?: Maybe<User>
  /** The `UserPhone` that was deleted by this mutation. */
  userPhone?: Maybe<UserPhone>
  /** An edge for our `UserPhone`. May be used by Relay 1. */
  userPhoneEdge?: Maybe<UserPhonesEdge>
}

/** The output of our delete `UserPhone` mutation. */
export type DeleteUserPhonePayloadUserPhoneEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPhonesOrderBy>>
}

/** All input for the `deleteUserPolicyById` mutation. */
export type DeleteUserPolicyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPolicy` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserPolicy` mutation. */
export type DeleteUserPolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserPolicy` mutation. */
export type DeleteUserPolicyPayload = {
  __typename?: 'DeleteUserPolicyPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserPolicyId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `Policy` that is related to this `UserPolicy`. */
  policy?: Maybe<Policy>
  /** Reads a single `User` that is related to this `UserPolicy`. */
  user?: Maybe<User>
  /** The `UserPolicy` that was deleted by this mutation. */
  userPolicy?: Maybe<UserPolicy>
  /** An edge for our `UserPolicy`. May be used by Relay 1. */
  userPolicyEdge?: Maybe<UserPoliciesEdge>
}

/** The output of our delete `UserPolicy` mutation. */
export type DeleteUserPolicyPayloadUserPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPoliciesOrderBy>>
}

/** All input for the `deleteUserUploadById` mutation. */
export type DeleteUserUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserUpload` to be deleted. */
  id: Scalars['ID']['input']
}

/** All input for the `deleteUserUpload` mutation. */
export type DeleteUserUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  rowId: Scalars['UUID']['input']
}

/** The output of our delete `UserUpload` mutation. */
export type DeleteUserUploadPayload = {
  __typename?: 'DeleteUserUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  deletedUserUploadId?: Maybe<Scalars['ID']['output']>
  /** Reads a single `Upload` that is related to this `UserUpload`. */
  upload?: Maybe<Upload>
  /** Reads a single `User` that is related to this `UserUpload`. */
  user?: Maybe<User>
  /** The `UserUpload` that was deleted by this mutation. */
  userUpload?: Maybe<UserUpload>
  /** An edge for our `UserUpload`. May be used by Relay 1. */
  userUploadEdge?: Maybe<UserUploadsEdge>
}

/** The output of our delete `UserUpload` mutation. */
export type DeleteUserUploadPayloadUserUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UserUploadsOrderBy>>
}

export enum EmployeeType {
  Employee = 'EMPLOYEE',
  Generic = 'GENERIC',
  Prn = 'PRN'
}

/** A filter to be used against EmployeeType fields. All fields are combined with a logical ‘and.’ */
export type EmployeeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EmployeeType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EmployeeType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EmployeeType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EmployeeType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<EmployeeType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<EmployeeType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EmployeeType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EmployeeType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EmployeeType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EmployeeType>>
}

export type InsuranceProvider = Node & {
  __typename?: 'InsuranceProvider'
  charmId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  payerId?: Maybe<Scalars['String']['output']>
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads and enables pagination through a set of `UserInsurance`. */
  userInsurances: UserInsurancesConnection
}

export type InsuranceProviderUserInsurancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserInsuranceCondition>
  filter?: InputMaybe<UserInsuranceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserInsurancesOrderBy>>
}

/**
 * A condition to be used against `InsuranceProvider` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InsuranceProviderCondition = {
  /** Checks for equality with the object’s `charmId` field. */
  charmId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `payerId` field. */
  payerId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `InsuranceProvider` object types. All fields are combined with a logical ‘and.’ */
export type InsuranceProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InsuranceProviderFilter>>
  /** Filter by the object’s `charmId` field. */
  charmId?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<InsuranceProviderFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InsuranceProviderFilter>>
  /** Filter by the object’s `payerId` field. */
  payerId?: InputMaybe<StringFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `userInsurances` relation. */
  userInsurances?: InputMaybe<InsuranceProviderToManyUserInsuranceFilter>
  /** Some related `userInsurances` exist. */
  userInsurancesExist?: InputMaybe<Scalars['Boolean']['input']>
}

/** An input for mutations affecting `InsuranceProvider` */
export type InsuranceProviderInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  payerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userInsurances?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInverseInput>
}

/** The fields on `insuranceProvider` to look up the row to connect. */
export type InsuranceProviderInsuranceProvidersPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `insuranceProvider` to look up the row to delete. */
export type InsuranceProviderInsuranceProvidersPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `insuranceProvider` to look up the row to connect. */
export type InsuranceProviderInsuranceProvidersSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `insuranceProvider` to look up the row to delete. */
export type InsuranceProviderInsuranceProvidersSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to connect. */
export type InsuranceProviderNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `insuranceProvider` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type InsuranceProviderNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `insuranceProvider` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type InsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userInsurance` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userInsurance` being updated. */
  patch: UserInsurancePatch
}

/** The fields on `insuranceProvider` to look up the row to update. */
export type InsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyUsingInsuranceProvidersPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `insuranceProvider` being updated. */
    patch: UpdateInsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** The fields on `insuranceProvider` to look up the row to update. */
export type InsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyUsingInsuranceProvidersSlugKeyUpdate =
  {
    /** An object where the defined keys will be set on the `insuranceProvider` being updated. */
    patch: UpdateInsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyPatch
    slug: Scalars['String']['input']
  }

/** Represents an update to a `InsuranceProvider`. Fields that are set will be updated. */
export type InsuranceProviderPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  payerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userInsurances?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInverseInput>
}

/** A filter to be used against many `UserInsurance` object types. All fields are combined with a logical ‘and.’ */
export type InsuranceProviderToManyUserInsuranceFilter = {
  /** Every related `UserInsurance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserInsuranceFilter>
  /** No related `UserInsurance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserInsuranceFilter>
  /** Some related `UserInsurance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserInsuranceFilter>
}

/** A connection to a list of `InsuranceProvider` values. */
export type InsuranceProvidersConnection = {
  __typename?: 'InsuranceProvidersConnection'
  /** A list of edges which contains the `InsuranceProvider` and cursor to aid in pagination. */
  edges: Array<InsuranceProvidersEdge>
  /** A list of `InsuranceProvider` objects. */
  nodes: Array<InsuranceProvider>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `InsuranceProvider` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `InsuranceProvider` edge in the connection. */
export type InsuranceProvidersEdge = {
  __typename?: 'InsuranceProvidersEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `InsuranceProvider` at the end of the edge. */
  node: InsuranceProvider
}

/** Methods to use when ordering `InsuranceProvider`. */
export enum InsuranceProvidersOrderBy {
  CharmIdAsc = 'CHARM_ID_ASC',
  CharmIdDesc = 'CHARM_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PayerIdAsc = 'PAYER_ID_ASC',
  PayerIdDesc = 'PAYER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserInsurancesByInsuranceProviderIdCountAsc = 'USER_INSURANCES_BY_INSURANCE_PROVIDER_ID__COUNT_ASC',
  UserInsurancesByInsuranceProviderIdCountDesc = 'USER_INSURANCES_BY_INSURANCE_PROVIDER_ID__COUNT_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval'
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']['output']>
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']['output']>
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']['output']>
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']['output']>
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']['output']>
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']['output']>
}

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>
}

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>
}

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>
}

export type Lead = Node & {
  __typename?: 'Lead'
  convertedAt?: Maybe<Scalars['Datetime']['output']>
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  optInAt?: Maybe<Scalars['Datetime']['output']>
  optInMethod?: Maybe<Scalars['String']['output']>
  /** Reads a single `ReferralPartner` that is related to this `Lead`. */
  referralPartner?: Maybe<ReferralPartner>
  referralPartnerId?: Maybe<Scalars['UUID']['output']>
  /** Reads a single `ReferralPartnerSource` that is related to this `Lead`. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  referralPartnerSourceId?: Maybe<Scalars['UUID']['output']>
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  source: LeadsSource
  status: LeadsStatus
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `Lead`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
  zohoId?: Maybe<Scalars['String']['output']>
}

/** A condition to be used against `Lead` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LeadCondition = {
  /** Checks for equality with the object’s `convertedAt` field. */
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `optInAt` field. */
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `optInMethod` field. */
  optInMethod?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `referralPartnerId` field. */
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `referralPartnerSourceId` field. */
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<LeadsSource>
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<LeadsStatus>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `zohoId` field. */
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** A filter to be used against `Lead` object types. All fields are combined with a logical ‘and.’ */
export type LeadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LeadFilter>>
  /** Filter by the object’s `convertedAt` field. */
  convertedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Negates the expression. */
  not?: InputMaybe<LeadFilter>
  /** Filter by the object’s `optInAt` field. */
  optInAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `optInMethod` field. */
  optInMethod?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LeadFilter>>
  /** Filter by the object’s `referralPartner` relation. */
  referralPartner?: InputMaybe<ReferralPartnerFilter>
  /** A related `referralPartner` exists. */
  referralPartnerExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `referralPartnerId` field. */
  referralPartnerId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `referralPartnerSource` relation. */
  referralPartnerSource?: InputMaybe<ReferralPartnerSourceFilter>
  /** A related `referralPartnerSource` exists. */
  referralPartnerSourceExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `referralPartnerSourceId` field. */
  referralPartnerSourceId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `source` field. */
  source?: InputMaybe<LeadsSourceFilter>
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<LeadsStatusFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `zohoId` field. */
  zohoId?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `Lead` */
export type LeadInput = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source: LeadsSource
  status: LeadsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The fields on `lead` to look up the row to connect. */
export type LeadLeadsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `lead` to look up the row to delete. */
export type LeadLeadsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `lead` to look up the row to connect. */
export type LeadLeadsSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `lead` to look up the row to delete. */
export type LeadLeadsSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** The fields on `lead` to look up the row to connect. */
export type LeadLeadsUniqueUserIdConnect = {
  userId: Scalars['UUID']['input']
}

/** The fields on `lead` to look up the row to delete. */
export type LeadLeadsUniqueUserIdDelete = {
  userId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to connect. */
export type LeadNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `lead` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type LeadNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `lead` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type LeadOnLeadForLeadsReferralPartnerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartner` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartner` being updated. */
  patch: ReferralPartnerPatch
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsReferralPartnerIdFkeyUsingLeadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsReferralPartnerIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsReferralPartnerIdFkeyUsingLeadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsReferralPartnerIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsReferralPartnerIdFkeyUsingLeadsUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsReferralPartnerIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type LeadOnLeadForLeadsReferralPartnerSourceIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartnerSource` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartnerSource` being updated. */
  patch: ReferralPartnerSourcePatch
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsReferralPartnerSourceIdFkeyUsingLeadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsReferralPartnerSourceIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsReferralPartnerSourceIdFkeyUsingLeadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsReferralPartnerSourceIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsReferralPartnerSourceIdFkeyUsingLeadsUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsReferralPartnerSourceIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type LeadOnLeadForLeadsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsUserIdFkeyUsingLeadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsUserIdFkeyUsingLeadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `lead` to look up the row to update. */
export type LeadOnLeadForLeadsUserIdFkeyUsingLeadsUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: UpdateLeadOnLeadForLeadsUserIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** Represents an update to a `Lead`. Fields that are set will be updated. */
export type LeadPatch = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<LeadsSource>
  status?: InputMaybe<LeadsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** A connection to a list of `Lead` values. */
export type LeadsConnection = {
  __typename?: 'LeadsConnection'
  /** A list of edges which contains the `Lead` and cursor to aid in pagination. */
  edges: Array<LeadsEdge>
  /** A list of `Lead` objects. */
  nodes: Array<Lead>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Lead` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Lead` edge in the connection. */
export type LeadsEdge = {
  __typename?: 'LeadsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Lead` at the end of the edge. */
  node: Lead
}

/** Methods to use when ordering `Lead`. */
export enum LeadsOrderBy {
  ConvertedAtAsc = 'CONVERTED_AT_ASC',
  ConvertedAtDesc = 'CONVERTED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OptInAtAsc = 'OPT_IN_AT_ASC',
  OptInAtDesc = 'OPT_IN_AT_DESC',
  OptInMethodAsc = 'OPT_IN_METHOD_ASC',
  OptInMethodDesc = 'OPT_IN_METHOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralPartnerByReferralPartnerIdConfigAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CONFIG_ASC',
  ReferralPartnerByReferralPartnerIdConfigDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CONFIG_DESC',
  ReferralPartnerByReferralPartnerIdCreatedAtAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CREATED_AT_ASC',
  ReferralPartnerByReferralPartnerIdCreatedAtDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CREATED_AT_DESC',
  ReferralPartnerByReferralPartnerIdIdAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__ID_ASC',
  ReferralPartnerByReferralPartnerIdIdDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__ID_DESC',
  ReferralPartnerByReferralPartnerIdIsActiveAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__IS_ACTIVE_ASC',
  ReferralPartnerByReferralPartnerIdIsActiveDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__IS_ACTIVE_DESC',
  ReferralPartnerByReferralPartnerIdNameAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__NAME_ASC',
  ReferralPartnerByReferralPartnerIdNameDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__NAME_DESC',
  ReferralPartnerByReferralPartnerIdSlugAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_ASC',
  ReferralPartnerByReferralPartnerIdSlugDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_DESC',
  ReferralPartnerByReferralPartnerIdSlugPublicAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_PUBLIC_ASC',
  ReferralPartnerByReferralPartnerIdSlugPublicDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_PUBLIC_DESC',
  ReferralPartnerByReferralPartnerIdTypeAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__TYPE_ASC',
  ReferralPartnerByReferralPartnerIdTypeDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__TYPE_DESC',
  ReferralPartnerByReferralPartnerIdUpdatedAtAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__UPDATED_AT_ASC',
  ReferralPartnerByReferralPartnerIdUpdatedAtDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__UPDATED_AT_DESC',
  ReferralPartnerIdAsc = 'REFERRAL_PARTNER_ID_ASC',
  ReferralPartnerIdDesc = 'REFERRAL_PARTNER_ID_DESC',
  ReferralPartnerSourceByReferralPartnerSourceIdDescriptionAsc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__DESCRIPTION_ASC',
  ReferralPartnerSourceByReferralPartnerSourceIdDescriptionDesc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__DESCRIPTION_DESC',
  ReferralPartnerSourceByReferralPartnerSourceIdIdAsc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__ID_ASC',
  ReferralPartnerSourceByReferralPartnerSourceIdIdDesc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__ID_DESC',
  ReferralPartnerSourceByReferralPartnerSourceIdIsActiveAsc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__IS_ACTIVE_ASC',
  ReferralPartnerSourceByReferralPartnerSourceIdIsActiveDesc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__IS_ACTIVE_DESC',
  ReferralPartnerSourceByReferralPartnerSourceIdNameAsc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__NAME_ASC',
  ReferralPartnerSourceByReferralPartnerSourceIdNameDesc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__NAME_DESC',
  ReferralPartnerSourceByReferralPartnerSourceIdReferralPartnerIdAsc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__REFERRAL_PARTNER_ID_ASC',
  ReferralPartnerSourceByReferralPartnerSourceIdReferralPartnerIdDesc = 'REFERRAL_PARTNER_SOURCE_BY_REFERRAL_PARTNER_SOURCE_ID__REFERRAL_PARTNER_ID_DESC',
  ReferralPartnerSourceIdAsc = 'REFERRAL_PARTNER_SOURCE_ID_ASC',
  ReferralPartnerSourceIdDesc = 'REFERRAL_PARTNER_SOURCE_ID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ZohoIdAsc = 'ZOHO_ID_ASC',
  ZohoIdDesc = 'ZOHO_ID_DESC'
}

/** Input for the nested mutation of `referralPartner` in the `LeadInput` mutation. */
export type LeadsReferralPartnerIdFkeyInput = {
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectById?: InputMaybe<ReferralPartnerNodeIdConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ReferralPartnerReferralPartnerPkeyConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ReferralPartnerReferralPartnerUniqueSlugConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectBySlugPublic?: InputMaybe<ReferralPartnerReferralPartnerSlugPublicConnect>
  /** A `ReferralPartnerInput` object that will be created and connected to this object. */
  create?: InputMaybe<LeadsReferralPartnerIdFkeyReferralPartnersCreateInput>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteById?: InputMaybe<ReferralPartnerNodeIdDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ReferralPartnerReferralPartnerPkeyDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ReferralPartnerReferralPartnerUniqueSlugDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteBySlugPublic?: InputMaybe<ReferralPartnerReferralPartnerSlugPublicDelete>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateById?: InputMaybe<LeadOnLeadForLeadsReferralPartnerIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyUsingReferralPartnerPkeyUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyUsingReferralPartnerUniqueSlugUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateBySlugPublic?: InputMaybe<ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyUsingReferralPartnerSlugPublicUpdate>
}

/** Input for the nested mutation of `lead` in the `ReferralPartnerInput` mutation. */
export type LeadsReferralPartnerIdFkeyInverseInput = {
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LeadNodeIdConnect>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<LeadLeadsPkeyConnect>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectBySlug?: InputMaybe<Array<LeadLeadsSlugKeyConnect>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<LeadLeadsUniqueUserIdConnect>>
  /** A `LeadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LeadsReferralPartnerIdFkeyLeadsCreateInput>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LeadNodeIdDelete>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<LeadLeadsPkeyDelete>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<Array<LeadLeadsSlugKeyDelete>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<Array<LeadLeadsUniqueUserIdDelete>>
  /** Flag indicating whether all other `lead` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<LeadOnLeadForLeadsReferralPartnerIdFkeyUsingLeadsPkeyUpdate>>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateBySlug?: InputMaybe<Array<LeadOnLeadForLeadsReferralPartnerIdFkeyUsingLeadsSlugKeyUpdate>>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<LeadOnLeadForLeadsReferralPartnerIdFkeyUsingLeadsUniqueUserIdUpdate>>
}

/** The `lead` to be created by this mutation. */
export type LeadsReferralPartnerIdFkeyLeadsCreateInput = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source: LeadsSource
  status: LeadsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The `referralPartner` to be created by this mutation. */
export type LeadsReferralPartnerIdFkeyReferralPartnersCreateInput = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type: ReferralPartnerType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Input for the nested mutation of `referralPartnerSource` in the `LeadInput` mutation. */
export type LeadsReferralPartnerSourceIdFkeyInput = {
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  connectById?: InputMaybe<ReferralPartnerSourceNodeIdConnect>
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ReferralPartnerSourceReferralPartnerSourcesPkeyConnect>
  /** A `ReferralPartnerSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<LeadsReferralPartnerSourceIdFkeyReferralPartnerSourcesCreateInput>
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  deleteById?: InputMaybe<ReferralPartnerSourceNodeIdDelete>
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ReferralPartnerSourceReferralPartnerSourcesPkeyDelete>
  /** The primary key(s) and patch data for `referralPartnerSource` for the far side of the relationship. */
  updateById?: InputMaybe<LeadOnLeadForLeadsReferralPartnerSourceIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `referralPartnerSource` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ReferralPartnerSourceOnLeadForLeadsReferralPartnerSourceIdFkeyUsingReferralPartnerSourcesPkeyUpdate>
}

/** Input for the nested mutation of `lead` in the `ReferralPartnerSourceInput` mutation. */
export type LeadsReferralPartnerSourceIdFkeyInverseInput = {
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectById?: InputMaybe<Array<LeadNodeIdConnect>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<LeadLeadsPkeyConnect>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectBySlug?: InputMaybe<Array<LeadLeadsSlugKeyConnect>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectByUserId?: InputMaybe<Array<LeadLeadsUniqueUserIdConnect>>
  /** A `LeadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LeadsReferralPartnerSourceIdFkeyLeadsCreateInput>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<LeadNodeIdDelete>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<LeadLeadsPkeyDelete>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<Array<LeadLeadsSlugKeyDelete>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<Array<LeadLeadsUniqueUserIdDelete>>
  /** Flag indicating whether all other `lead` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ReferralPartnerSourceOnLeadForLeadsReferralPartnerSourceIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<LeadOnLeadForLeadsReferralPartnerSourceIdFkeyUsingLeadsPkeyUpdate>>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateBySlug?: InputMaybe<Array<LeadOnLeadForLeadsReferralPartnerSourceIdFkeyUsingLeadsSlugKeyUpdate>>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateByUserId?: InputMaybe<Array<LeadOnLeadForLeadsReferralPartnerSourceIdFkeyUsingLeadsUniqueUserIdUpdate>>
}

/** The `lead` to be created by this mutation. */
export type LeadsReferralPartnerSourceIdFkeyLeadsCreateInput = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source: LeadsSource
  status: LeadsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The `referralPartnerSource` to be created by this mutation. */
export type LeadsReferralPartnerSourceIdFkeyReferralPartnerSourcesCreateInput = {
  description: Scalars['String']['input']
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartner?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

export enum LeadsSource {
  BreastPumpOrder = 'BREAST_PUMP_ORDER',
  Friend = 'FRIEND',
  Health = 'HEALTH',
  HealthPlan = 'HEALTH_PLAN',
  Other = 'OTHER',
  ReferralPartner = 'REFERRAL_PARTNER',
  Search = 'SEARCH',
  Social = 'SOCIAL'
}

/** A filter to be used against LeadsSource fields. All fields are combined with a logical ‘and.’ */
export type LeadsSourceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LeadsSource>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LeadsSource>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LeadsSource>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LeadsSource>
  /** Included in the specified list. */
  in?: InputMaybe<Array<LeadsSource>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<LeadsSource>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LeadsSource>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LeadsSource>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LeadsSource>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LeadsSource>>
}

export enum LeadsStatus {
  Active = 'ACTIVE',
  Converted = 'CONVERTED',
  Inactive = 'INACTIVE',
  New = 'NEW'
}

/** A filter to be used against LeadsStatus fields. All fields are combined with a logical ‘and.’ */
export type LeadsStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LeadsStatus>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LeadsStatus>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LeadsStatus>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LeadsStatus>
  /** Included in the specified list. */
  in?: InputMaybe<Array<LeadsStatus>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<LeadsStatus>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LeadsStatus>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LeadsStatus>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LeadsStatus>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LeadsStatus>>
}

/** Input for the nested mutation of `user` in the `LeadInput` mutation. */
export type LeadsUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<LeadsUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<LeadOnLeadForLeadsUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnLeadForLeadsUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnLeadForLeadsUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `lead` in the `UserInput` mutation. */
export type LeadsUserIdFkeyInverseInput = {
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectById?: InputMaybe<LeadNodeIdConnect>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectByRowId?: InputMaybe<LeadLeadsPkeyConnect>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectBySlug?: InputMaybe<LeadLeadsSlugKeyConnect>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  connectByUserId?: InputMaybe<LeadLeadsUniqueUserIdConnect>
  /** A `LeadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<LeadsUserIdFkeyLeadsCreateInput>>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteById?: InputMaybe<LeadNodeIdDelete>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<LeadLeadsPkeyDelete>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<LeadLeadsSlugKeyDelete>
  /** The primary key(s) for `lead` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<LeadLeadsUniqueUserIdDelete>
  /** Flag indicating whether all other `lead` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnLeadForLeadsUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateByRowId?: InputMaybe<LeadOnLeadForLeadsUserIdFkeyUsingLeadsPkeyUpdate>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateBySlug?: InputMaybe<LeadOnLeadForLeadsUserIdFkeyUsingLeadsSlugKeyUpdate>
  /** The primary key(s) and patch data for `lead` for the far side of the relationship. */
  updateByUserId?: InputMaybe<LeadOnLeadForLeadsUserIdFkeyUsingLeadsUniqueUserIdUpdate>
}

/** The `lead` to be created by this mutation. */
export type LeadsUserIdFkeyLeadsCreateInput = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source: LeadsSource
  status: LeadsStatus
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The `user` to be created by this mutation. */
export type LeadsUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation'
  /** Creates a single `Address`. */
  createAddress?: Maybe<CreateAddressPayload>
  /** Creates a single `Appointment`. */
  createAppointment?: Maybe<CreateAppointmentPayload>
  /** Creates a single `Clinician`. */
  createClinician?: Maybe<CreateClinicianPayload>
  /** Creates a single `ClinicianAvailability`. */
  createClinicianAvailability?: Maybe<CreateClinicianAvailabilityPayload>
  /** Creates a single `InsuranceProvider`. */
  createInsuranceProvider?: Maybe<CreateInsuranceProviderPayload>
  /** Creates a single `Lead`. */
  createLead?: Maybe<CreateLeadPayload>
  /** Creates a single `Patient`. */
  createPatient?: Maybe<CreatePatientPayload>
  /** Creates a single `Policy`. */
  createPolicy?: Maybe<CreatePolicyPayload>
  /** Creates a single `ReferralPartner`. */
  createReferralPartner?: Maybe<CreateReferralPartnerPayload>
  /** Creates a single `ReferralPartnerSource`. */
  createReferralPartnerSource?: Maybe<CreateReferralPartnerSourcePayload>
  /** Creates a single `ReferralPartnerUpload`. */
  createReferralPartnerUpload?: Maybe<CreateReferralPartnerUploadPayload>
  /** Creates a single `Service`. */
  createService?: Maybe<CreateServicePayload>
  /** Creates a single `SupportedLanguage`. */
  createSupportedLanguage?: Maybe<CreateSupportedLanguagePayload>
  /** Creates a single `Upload`. */
  createUpload?: Maybe<CreateUploadPayload>
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>
  /** Creates a single `UserAddress`. */
  createUserAddress?: Maybe<CreateUserAddressPayload>
  /** Creates a single `UserChild`. */
  createUserChild?: Maybe<CreateUserChildPayload>
  /** Creates a single `UserInsurance`. */
  createUserInsurance?: Maybe<CreateUserInsurancePayload>
  /** Creates a single `UserInsuranceUpload`. */
  createUserInsuranceUpload?: Maybe<CreateUserInsuranceUploadPayload>
  /** Creates a single `UserLanguage`. */
  createUserLanguage?: Maybe<CreateUserLanguagePayload>
  /** Creates a single `UserPaymentMethod`. */
  createUserPaymentMethod?: Maybe<CreateUserPaymentMethodPayload>
  /** Creates a single `UserPaymentProvider`. */
  createUserPaymentProvider?: Maybe<CreateUserPaymentProviderPayload>
  /** Creates a single `UserPhone`. */
  createUserPhone?: Maybe<CreateUserPhonePayload>
  /** Creates a single `UserPolicy`. */
  createUserPolicy?: Maybe<CreateUserPolicyPayload>
  /** Creates a single `UserUpload`. */
  createUserUpload?: Maybe<CreateUserUploadPayload>
  /** Deletes a single `Address` using a unique key. */
  deleteAddress?: Maybe<DeleteAddressPayload>
  /** Deletes a single `Address` using its globally unique id. */
  deleteAddressById?: Maybe<DeleteAddressPayload>
  /** Deletes a single `Appointment` using a unique key. */
  deleteAppointment?: Maybe<DeleteAppointmentPayload>
  /** Deletes a single `Appointment` using its globally unique id. */
  deleteAppointmentById?: Maybe<DeleteAppointmentPayload>
  /** Deletes a single `Clinician` using a unique key. */
  deleteClinician?: Maybe<DeleteClinicianPayload>
  /** Deletes a single `ClinicianAvailability` using a unique key. */
  deleteClinicianAvailability?: Maybe<DeleteClinicianAvailabilityPayload>
  /** Deletes a single `ClinicianAvailability` using its globally unique id. */
  deleteClinicianAvailabilityById?: Maybe<DeleteClinicianAvailabilityPayload>
  /** Deletes a single `Clinician` using its globally unique id. */
  deleteClinicianById?: Maybe<DeleteClinicianPayload>
  /** Deletes a single `Clinician` using a unique key. */
  deleteClinicianBySlug?: Maybe<DeleteClinicianPayload>
  /** Deletes a single `Clinician` using a unique key. */
  deleteClinicianBySlugPublic?: Maybe<DeleteClinicianPayload>
  /** Deletes a single `Clinician` using a unique key. */
  deleteClinicianByUserId?: Maybe<DeleteClinicianPayload>
  /** Deletes a single `InsuranceProvider` using a unique key. */
  deleteInsuranceProvider?: Maybe<DeleteInsuranceProviderPayload>
  /** Deletes a single `InsuranceProvider` using its globally unique id. */
  deleteInsuranceProviderById?: Maybe<DeleteInsuranceProviderPayload>
  /** Deletes a single `InsuranceProvider` using a unique key. */
  deleteInsuranceProviderBySlug?: Maybe<DeleteInsuranceProviderPayload>
  /** Deletes a single `Lead` using a unique key. */
  deleteLead?: Maybe<DeleteLeadPayload>
  /** Deletes a single `Lead` using its globally unique id. */
  deleteLeadById?: Maybe<DeleteLeadPayload>
  /** Deletes a single `Lead` using a unique key. */
  deleteLeadBySlug?: Maybe<DeleteLeadPayload>
  /** Deletes a single `Lead` using a unique key. */
  deleteLeadByUserId?: Maybe<DeleteLeadPayload>
  /** Deletes a single `Patient` using a unique key. */
  deletePatient?: Maybe<DeletePatientPayload>
  /** Deletes a single `Patient` using a unique key. */
  deletePatientByCharmRecordId?: Maybe<DeletePatientPayload>
  /** Deletes a single `Patient` using its globally unique id. */
  deletePatientById?: Maybe<DeletePatientPayload>
  /** Deletes a single `Patient` using a unique key. */
  deletePatientBySlug?: Maybe<DeletePatientPayload>
  /** Deletes a single `Patient` using a unique key. */
  deletePatientByUserId?: Maybe<DeletePatientPayload>
  /** Deletes a single `Policy` using a unique key. */
  deletePolicy?: Maybe<DeletePolicyPayload>
  /** Deletes a single `Policy` using its globally unique id. */
  deletePolicyById?: Maybe<DeletePolicyPayload>
  /** Deletes a single `Policy` using a unique key. */
  deletePolicyBySlug?: Maybe<DeletePolicyPayload>
  /** Deletes a single `ReferralPartner` using a unique key. */
  deleteReferralPartner?: Maybe<DeleteReferralPartnerPayload>
  /** Deletes a single `ReferralPartner` using its globally unique id. */
  deleteReferralPartnerById?: Maybe<DeleteReferralPartnerPayload>
  /** Deletes a single `ReferralPartner` using a unique key. */
  deleteReferralPartnerBySlug?: Maybe<DeleteReferralPartnerPayload>
  /** Deletes a single `ReferralPartner` using a unique key. */
  deleteReferralPartnerBySlugPublic?: Maybe<DeleteReferralPartnerPayload>
  /** Deletes a single `ReferralPartnerSource` using a unique key. */
  deleteReferralPartnerSource?: Maybe<DeleteReferralPartnerSourcePayload>
  /** Deletes a single `ReferralPartnerSource` using its globally unique id. */
  deleteReferralPartnerSourceById?: Maybe<DeleteReferralPartnerSourcePayload>
  /** Deletes a single `ReferralPartnerUpload` using a unique key. */
  deleteReferralPartnerUpload?: Maybe<DeleteReferralPartnerUploadPayload>
  /** Deletes a single `ReferralPartnerUpload` using its globally unique id. */
  deleteReferralPartnerUploadById?: Maybe<DeleteReferralPartnerUploadPayload>
  /** Deletes a single `Service` using a unique key. */
  deleteService?: Maybe<DeleteServicePayload>
  /** Deletes a single `Service` using its globally unique id. */
  deleteServiceById?: Maybe<DeleteServicePayload>
  /** Deletes a single `Service` using a unique key. */
  deleteServiceBySlug?: Maybe<DeleteServicePayload>
  /** Deletes a single `SupportedLanguage` using a unique key. */
  deleteSupportedLanguage?: Maybe<DeleteSupportedLanguagePayload>
  /** Deletes a single `SupportedLanguage` using its globally unique id. */
  deleteSupportedLanguageById?: Maybe<DeleteSupportedLanguagePayload>
  /** Deletes a single `Upload` using a unique key. */
  deleteUpload?: Maybe<DeleteUploadPayload>
  /** Deletes a single `Upload` using its globally unique id. */
  deleteUploadById?: Maybe<DeleteUploadPayload>
  /** Deletes a single `Upload` using a unique key. */
  deleteUploadBySlug?: Maybe<DeleteUploadPayload>
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>
  /** Deletes a single `UserAddress` using a unique key. */
  deleteUserAddress?: Maybe<DeleteUserAddressPayload>
  /** Deletes a single `UserAddress` using its globally unique id. */
  deleteUserAddressById?: Maybe<DeleteUserAddressPayload>
  /** Deletes a single `User` using its globally unique id. */
  deleteUserById?: Maybe<DeleteUserPayload>
  /** Deletes a single `User` using a unique key. */
  deleteUserBySlug?: Maybe<DeleteUserPayload>
  /** Deletes a single `UserChild` using a unique key. */
  deleteUserChild?: Maybe<DeleteUserChildPayload>
  /** Deletes a single `UserChild` using its globally unique id. */
  deleteUserChildById?: Maybe<DeleteUserChildPayload>
  /** Deletes a single `UserInsurance` using a unique key. */
  deleteUserInsurance?: Maybe<DeleteUserInsurancePayload>
  /** Deletes a single `UserInsurance` using its globally unique id. */
  deleteUserInsuranceById?: Maybe<DeleteUserInsurancePayload>
  /** Deletes a single `UserInsuranceUpload` using a unique key. */
  deleteUserInsuranceUpload?: Maybe<DeleteUserInsuranceUploadPayload>
  /** Deletes a single `UserInsuranceUpload` using its globally unique id. */
  deleteUserInsuranceUploadById?: Maybe<DeleteUserInsuranceUploadPayload>
  /** Deletes a single `UserLanguage` using a unique key. */
  deleteUserLanguage?: Maybe<DeleteUserLanguagePayload>
  /** Deletes a single `UserLanguage` using its globally unique id. */
  deleteUserLanguageById?: Maybe<DeleteUserLanguagePayload>
  /** Deletes a single `UserPaymentMethod` using a unique key. */
  deleteUserPaymentMethod?: Maybe<DeleteUserPaymentMethodPayload>
  /** Deletes a single `UserPaymentMethod` using its globally unique id. */
  deleteUserPaymentMethodById?: Maybe<DeleteUserPaymentMethodPayload>
  /** Deletes a single `UserPaymentMethod` using a unique key. */
  deleteUserPaymentMethodBySlug?: Maybe<DeleteUserPaymentMethodPayload>
  /** Deletes a single `UserPaymentProvider` using a unique key. */
  deleteUserPaymentProvider?: Maybe<DeleteUserPaymentProviderPayload>
  /** Deletes a single `UserPaymentProvider` using its globally unique id. */
  deleteUserPaymentProviderById?: Maybe<DeleteUserPaymentProviderPayload>
  /** Deletes a single `UserPaymentProvider` using a unique key. */
  deleteUserPaymentProviderBySlug?: Maybe<DeleteUserPaymentProviderPayload>
  /** Deletes a single `UserPhone` using a unique key. */
  deleteUserPhone?: Maybe<DeleteUserPhonePayload>
  /** Deletes a single `UserPhone` using its globally unique id. */
  deleteUserPhoneById?: Maybe<DeleteUserPhonePayload>
  /** Deletes a single `UserPolicy` using a unique key. */
  deleteUserPolicy?: Maybe<DeleteUserPolicyPayload>
  /** Deletes a single `UserPolicy` using its globally unique id. */
  deleteUserPolicyById?: Maybe<DeleteUserPolicyPayload>
  /** Deletes a single `UserUpload` using a unique key. */
  deleteUserUpload?: Maybe<DeleteUserUploadPayload>
  /** Deletes a single `UserUpload` using its globally unique id. */
  deleteUserUploadById?: Maybe<DeleteUserUploadPayload>
  /** Updates a single `Address` using a unique key and a patch. */
  updateAddress?: Maybe<UpdateAddressPayload>
  /** Updates a single `Address` using its globally unique id and a patch. */
  updateAddressById?: Maybe<UpdateAddressPayload>
  /** Updates a single `Appointment` using a unique key and a patch. */
  updateAppointment?: Maybe<UpdateAppointmentPayload>
  /** Updates a single `Appointment` using its globally unique id and a patch. */
  updateAppointmentById?: Maybe<UpdateAppointmentPayload>
  /** Updates a single `Clinician` using a unique key and a patch. */
  updateClinician?: Maybe<UpdateClinicianPayload>
  /** Updates a single `ClinicianAvailability` using a unique key and a patch. */
  updateClinicianAvailability?: Maybe<UpdateClinicianAvailabilityPayload>
  /** Updates a single `ClinicianAvailability` using its globally unique id and a patch. */
  updateClinicianAvailabilityById?: Maybe<UpdateClinicianAvailabilityPayload>
  /** Updates a single `Clinician` using its globally unique id and a patch. */
  updateClinicianById?: Maybe<UpdateClinicianPayload>
  /** Updates a single `Clinician` using a unique key and a patch. */
  updateClinicianBySlug?: Maybe<UpdateClinicianPayload>
  /** Updates a single `Clinician` using a unique key and a patch. */
  updateClinicianBySlugPublic?: Maybe<UpdateClinicianPayload>
  /** Updates a single `Clinician` using a unique key and a patch. */
  updateClinicianByUserId?: Maybe<UpdateClinicianPayload>
  /** Updates a single `InsuranceProvider` using a unique key and a patch. */
  updateInsuranceProvider?: Maybe<UpdateInsuranceProviderPayload>
  /** Updates a single `InsuranceProvider` using its globally unique id and a patch. */
  updateInsuranceProviderById?: Maybe<UpdateInsuranceProviderPayload>
  /** Updates a single `InsuranceProvider` using a unique key and a patch. */
  updateInsuranceProviderBySlug?: Maybe<UpdateInsuranceProviderPayload>
  /** Updates a single `Lead` using a unique key and a patch. */
  updateLead?: Maybe<UpdateLeadPayload>
  /** Updates a single `Lead` using its globally unique id and a patch. */
  updateLeadById?: Maybe<UpdateLeadPayload>
  /** Updates a single `Lead` using a unique key and a patch. */
  updateLeadBySlug?: Maybe<UpdateLeadPayload>
  /** Updates a single `Lead` using a unique key and a patch. */
  updateLeadByUserId?: Maybe<UpdateLeadPayload>
  /** Updates a single `Patient` using a unique key and a patch. */
  updatePatient?: Maybe<UpdatePatientPayload>
  /** Updates a single `Patient` using a unique key and a patch. */
  updatePatientByCharmRecordId?: Maybe<UpdatePatientPayload>
  /** Updates a single `Patient` using its globally unique id and a patch. */
  updatePatientById?: Maybe<UpdatePatientPayload>
  /** Updates a single `Patient` using a unique key and a patch. */
  updatePatientBySlug?: Maybe<UpdatePatientPayload>
  /** Updates a single `Patient` using a unique key and a patch. */
  updatePatientByUserId?: Maybe<UpdatePatientPayload>
  /** Updates a single `Policy` using a unique key and a patch. */
  updatePolicy?: Maybe<UpdatePolicyPayload>
  /** Updates a single `Policy` using its globally unique id and a patch. */
  updatePolicyById?: Maybe<UpdatePolicyPayload>
  /** Updates a single `Policy` using a unique key and a patch. */
  updatePolicyBySlug?: Maybe<UpdatePolicyPayload>
  /** Updates a single `ReferralPartner` using a unique key and a patch. */
  updateReferralPartner?: Maybe<UpdateReferralPartnerPayload>
  /** Updates a single `ReferralPartner` using its globally unique id and a patch. */
  updateReferralPartnerById?: Maybe<UpdateReferralPartnerPayload>
  /** Updates a single `ReferralPartner` using a unique key and a patch. */
  updateReferralPartnerBySlug?: Maybe<UpdateReferralPartnerPayload>
  /** Updates a single `ReferralPartner` using a unique key and a patch. */
  updateReferralPartnerBySlugPublic?: Maybe<UpdateReferralPartnerPayload>
  /** Updates a single `ReferralPartnerSource` using a unique key and a patch. */
  updateReferralPartnerSource?: Maybe<UpdateReferralPartnerSourcePayload>
  /** Updates a single `ReferralPartnerSource` using its globally unique id and a patch. */
  updateReferralPartnerSourceById?: Maybe<UpdateReferralPartnerSourcePayload>
  /** Updates a single `ReferralPartnerUpload` using a unique key and a patch. */
  updateReferralPartnerUpload?: Maybe<UpdateReferralPartnerUploadPayload>
  /** Updates a single `ReferralPartnerUpload` using its globally unique id and a patch. */
  updateReferralPartnerUploadById?: Maybe<UpdateReferralPartnerUploadPayload>
  /** Updates a single `Service` using a unique key and a patch. */
  updateService?: Maybe<UpdateServicePayload>
  /** Updates a single `Service` using its globally unique id and a patch. */
  updateServiceById?: Maybe<UpdateServicePayload>
  /** Updates a single `Service` using a unique key and a patch. */
  updateServiceBySlug?: Maybe<UpdateServicePayload>
  /** Updates a single `SupportedLanguage` using a unique key and a patch. */
  updateSupportedLanguage?: Maybe<UpdateSupportedLanguagePayload>
  /** Updates a single `SupportedLanguage` using its globally unique id and a patch. */
  updateSupportedLanguageById?: Maybe<UpdateSupportedLanguagePayload>
  /** Updates a single `Upload` using a unique key and a patch. */
  updateUpload?: Maybe<UpdateUploadPayload>
  /** Updates a single `Upload` using its globally unique id and a patch. */
  updateUploadById?: Maybe<UpdateUploadPayload>
  /** Updates a single `Upload` using a unique key and a patch. */
  updateUploadBySlug?: Maybe<UpdateUploadPayload>
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>
  /** Updates a single `UserAddress` using a unique key and a patch. */
  updateUserAddress?: Maybe<UpdateUserAddressPayload>
  /** Updates a single `UserAddress` using its globally unique id and a patch. */
  updateUserAddressById?: Maybe<UpdateUserAddressPayload>
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserById?: Maybe<UpdateUserPayload>
  /** Updates a single `User` using a unique key and a patch. */
  updateUserBySlug?: Maybe<UpdateUserPayload>
  /** Updates a single `UserChild` using a unique key and a patch. */
  updateUserChild?: Maybe<UpdateUserChildPayload>
  /** Updates a single `UserChild` using its globally unique id and a patch. */
  updateUserChildById?: Maybe<UpdateUserChildPayload>
  /** Updates a single `UserInsurance` using a unique key and a patch. */
  updateUserInsurance?: Maybe<UpdateUserInsurancePayload>
  /** Updates a single `UserInsurance` using its globally unique id and a patch. */
  updateUserInsuranceById?: Maybe<UpdateUserInsurancePayload>
  /** Updates a single `UserInsuranceUpload` using a unique key and a patch. */
  updateUserInsuranceUpload?: Maybe<UpdateUserInsuranceUploadPayload>
  /** Updates a single `UserInsuranceUpload` using its globally unique id and a patch. */
  updateUserInsuranceUploadById?: Maybe<UpdateUserInsuranceUploadPayload>
  /** Updates a single `UserLanguage` using a unique key and a patch. */
  updateUserLanguage?: Maybe<UpdateUserLanguagePayload>
  /** Updates a single `UserLanguage` using its globally unique id and a patch. */
  updateUserLanguageById?: Maybe<UpdateUserLanguagePayload>
  updateUserPassword?: Maybe<UpdateUserPasswordPayload>
  /** Updates a single `UserPaymentMethod` using a unique key and a patch. */
  updateUserPaymentMethod?: Maybe<UpdateUserPaymentMethodPayload>
  /** Updates a single `UserPaymentMethod` using its globally unique id and a patch. */
  updateUserPaymentMethodById?: Maybe<UpdateUserPaymentMethodPayload>
  /** Updates a single `UserPaymentMethod` using a unique key and a patch. */
  updateUserPaymentMethodBySlug?: Maybe<UpdateUserPaymentMethodPayload>
  /** Updates a single `UserPaymentProvider` using a unique key and a patch. */
  updateUserPaymentProvider?: Maybe<UpdateUserPaymentProviderPayload>
  /** Updates a single `UserPaymentProvider` using its globally unique id and a patch. */
  updateUserPaymentProviderById?: Maybe<UpdateUserPaymentProviderPayload>
  /** Updates a single `UserPaymentProvider` using a unique key and a patch. */
  updateUserPaymentProviderBySlug?: Maybe<UpdateUserPaymentProviderPayload>
  /** Updates a single `UserPhone` using a unique key and a patch. */
  updateUserPhone?: Maybe<UpdateUserPhonePayload>
  /** Updates a single `UserPhone` using its globally unique id and a patch. */
  updateUserPhoneById?: Maybe<UpdateUserPhonePayload>
  /** Updates a single `UserPolicy` using a unique key and a patch. */
  updateUserPolicy?: Maybe<UpdateUserPolicyPayload>
  /** Updates a single `UserPolicy` using its globally unique id and a patch. */
  updateUserPolicyById?: Maybe<UpdateUserPolicyPayload>
  /** Updates a single `UserUpload` using a unique key and a patch. */
  updateUserUpload?: Maybe<UpdateUserUploadPayload>
  /** Updates a single `UserUpload` using its globally unique id and a patch. */
  updateUserUploadById?: Maybe<UpdateUserUploadPayload>
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAddressArgs = {
  input: CreateAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAppointmentArgs = {
  input: CreateAppointmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClinicianArgs = {
  input: CreateClinicianInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClinicianAvailabilityArgs = {
  input: CreateClinicianAvailabilityInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInsuranceProviderArgs = {
  input: CreateInsuranceProviderInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLeadArgs = {
  input: CreateLeadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePatientArgs = {
  input: CreatePatientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePolicyArgs = {
  input: CreatePolicyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReferralPartnerArgs = {
  input: CreateReferralPartnerInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReferralPartnerSourceArgs = {
  input: CreateReferralPartnerSourceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateReferralPartnerUploadArgs = {
  input: CreateReferralPartnerUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateServiceArgs = {
  input: CreateServiceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSupportedLanguageArgs = {
  input: CreateSupportedLanguageInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUploadArgs = {
  input: CreateUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserAddressArgs = {
  input: CreateUserAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserChildArgs = {
  input: CreateUserChildInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserInsuranceArgs = {
  input: CreateUserInsuranceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserInsuranceUploadArgs = {
  input: CreateUserInsuranceUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserLanguageArgs = {
  input: CreateUserLanguageInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserPaymentMethodArgs = {
  input: CreateUserPaymentMethodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserPaymentProviderArgs = {
  input: CreateUserPaymentProviderInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserPhoneArgs = {
  input: CreateUserPhoneInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserPolicyArgs = {
  input: CreateUserPolicyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserUploadArgs = {
  input: CreateUserUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAddressByIdArgs = {
  input: DeleteAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppointmentArgs = {
  input: DeleteAppointmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAppointmentByIdArgs = {
  input: DeleteAppointmentByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianArgs = {
  input: DeleteClinicianInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianAvailabilityArgs = {
  input: DeleteClinicianAvailabilityInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianAvailabilityByIdArgs = {
  input: DeleteClinicianAvailabilityByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianByIdArgs = {
  input: DeleteClinicianByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianBySlugArgs = {
  input: DeleteClinicianBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianBySlugPublicArgs = {
  input: DeleteClinicianBySlugPublicInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClinicianByUserIdArgs = {
  input: DeleteClinicianByUserIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInsuranceProviderArgs = {
  input: DeleteInsuranceProviderInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInsuranceProviderByIdArgs = {
  input: DeleteInsuranceProviderByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInsuranceProviderBySlugArgs = {
  input: DeleteInsuranceProviderBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadArgs = {
  input: DeleteLeadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadByIdArgs = {
  input: DeleteLeadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadBySlugArgs = {
  input: DeleteLeadBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLeadByUserIdArgs = {
  input: DeleteLeadByUserIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePatientArgs = {
  input: DeletePatientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePatientByCharmRecordIdArgs = {
  input: DeletePatientByCharmRecordIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePatientByIdArgs = {
  input: DeletePatientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePatientBySlugArgs = {
  input: DeletePatientBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePatientByUserIdArgs = {
  input: DeletePatientByUserIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePolicyArgs = {
  input: DeletePolicyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePolicyByIdArgs = {
  input: DeletePolicyByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePolicyBySlugArgs = {
  input: DeletePolicyBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerArgs = {
  input: DeleteReferralPartnerInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerByIdArgs = {
  input: DeleteReferralPartnerByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerBySlugArgs = {
  input: DeleteReferralPartnerBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerBySlugPublicArgs = {
  input: DeleteReferralPartnerBySlugPublicInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerSourceArgs = {
  input: DeleteReferralPartnerSourceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerSourceByIdArgs = {
  input: DeleteReferralPartnerSourceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerUploadArgs = {
  input: DeleteReferralPartnerUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteReferralPartnerUploadByIdArgs = {
  input: DeleteReferralPartnerUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceArgs = {
  input: DeleteServiceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceByIdArgs = {
  input: DeleteServiceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceBySlugArgs = {
  input: DeleteServiceBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSupportedLanguageArgs = {
  input: DeleteSupportedLanguageInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSupportedLanguageByIdArgs = {
  input: DeleteSupportedLanguageByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUploadArgs = {
  input: DeleteUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUploadByIdArgs = {
  input: DeleteUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUploadBySlugArgs = {
  input: DeleteUploadBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserAddressArgs = {
  input: DeleteUserAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserAddressByIdArgs = {
  input: DeleteUserAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByIdArgs = {
  input: DeleteUserByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserBySlugArgs = {
  input: DeleteUserBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserChildArgs = {
  input: DeleteUserChildInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserChildByIdArgs = {
  input: DeleteUserChildByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserInsuranceArgs = {
  input: DeleteUserInsuranceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserInsuranceByIdArgs = {
  input: DeleteUserInsuranceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserInsuranceUploadArgs = {
  input: DeleteUserInsuranceUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserInsuranceUploadByIdArgs = {
  input: DeleteUserInsuranceUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserLanguageArgs = {
  input: DeleteUserLanguageInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserLanguageByIdArgs = {
  input: DeleteUserLanguageByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPaymentMethodArgs = {
  input: DeleteUserPaymentMethodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPaymentMethodByIdArgs = {
  input: DeleteUserPaymentMethodByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPaymentMethodBySlugArgs = {
  input: DeleteUserPaymentMethodBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPaymentProviderArgs = {
  input: DeleteUserPaymentProviderInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPaymentProviderByIdArgs = {
  input: DeleteUserPaymentProviderByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPaymentProviderBySlugArgs = {
  input: DeleteUserPaymentProviderBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPhoneArgs = {
  input: DeleteUserPhoneInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPhoneByIdArgs = {
  input: DeleteUserPhoneByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPolicyArgs = {
  input: DeleteUserPolicyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserPolicyByIdArgs = {
  input: DeleteUserPolicyByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserUploadArgs = {
  input: DeleteUserUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserUploadByIdArgs = {
  input: DeleteUserUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAddressByIdArgs = {
  input: UpdateAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentArgs = {
  input: UpdateAppointmentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppointmentByIdArgs = {
  input: UpdateAppointmentByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianArgs = {
  input: UpdateClinicianInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianAvailabilityArgs = {
  input: UpdateClinicianAvailabilityInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianAvailabilityByIdArgs = {
  input: UpdateClinicianAvailabilityByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianByIdArgs = {
  input: UpdateClinicianByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianBySlugArgs = {
  input: UpdateClinicianBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianBySlugPublicArgs = {
  input: UpdateClinicianBySlugPublicInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClinicianByUserIdArgs = {
  input: UpdateClinicianByUserIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsuranceProviderArgs = {
  input: UpdateInsuranceProviderInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsuranceProviderByIdArgs = {
  input: UpdateInsuranceProviderByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsuranceProviderBySlugArgs = {
  input: UpdateInsuranceProviderBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadByIdArgs = {
  input: UpdateLeadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadBySlugArgs = {
  input: UpdateLeadBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLeadByUserIdArgs = {
  input: UpdateLeadByUserIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientByCharmRecordIdArgs = {
  input: UpdatePatientByCharmRecordIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientByIdArgs = {
  input: UpdatePatientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientBySlugArgs = {
  input: UpdatePatientBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePatientByUserIdArgs = {
  input: UpdatePatientByUserIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePolicyArgs = {
  input: UpdatePolicyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePolicyByIdArgs = {
  input: UpdatePolicyByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePolicyBySlugArgs = {
  input: UpdatePolicyBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerArgs = {
  input: UpdateReferralPartnerInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerByIdArgs = {
  input: UpdateReferralPartnerByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerBySlugArgs = {
  input: UpdateReferralPartnerBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerBySlugPublicArgs = {
  input: UpdateReferralPartnerBySlugPublicInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerSourceArgs = {
  input: UpdateReferralPartnerSourceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerSourceByIdArgs = {
  input: UpdateReferralPartnerSourceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerUploadArgs = {
  input: UpdateReferralPartnerUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateReferralPartnerUploadByIdArgs = {
  input: UpdateReferralPartnerUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceByIdArgs = {
  input: UpdateServiceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceBySlugArgs = {
  input: UpdateServiceBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSupportedLanguageArgs = {
  input: UpdateSupportedLanguageInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSupportedLanguageByIdArgs = {
  input: UpdateSupportedLanguageByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUploadArgs = {
  input: UpdateUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUploadByIdArgs = {
  input: UpdateUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUploadBySlugArgs = {
  input: UpdateUploadBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserAddressArgs = {
  input: UpdateUserAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserAddressByIdArgs = {
  input: UpdateUserAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdArgs = {
  input: UpdateUserByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserBySlugArgs = {
  input: UpdateUserBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserChildArgs = {
  input: UpdateUserChildInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserChildByIdArgs = {
  input: UpdateUserChildByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserInsuranceArgs = {
  input: UpdateUserInsuranceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserInsuranceByIdArgs = {
  input: UpdateUserInsuranceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserInsuranceUploadArgs = {
  input: UpdateUserInsuranceUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserInsuranceUploadByIdArgs = {
  input: UpdateUserInsuranceUploadByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserLanguageArgs = {
  input: UpdateUserLanguageInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserLanguageByIdArgs = {
  input: UpdateUserLanguageByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPaymentMethodArgs = {
  input: UpdateUserPaymentMethodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPaymentMethodByIdArgs = {
  input: UpdateUserPaymentMethodByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPaymentMethodBySlugArgs = {
  input: UpdateUserPaymentMethodBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPaymentProviderArgs = {
  input: UpdateUserPaymentProviderInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPaymentProviderByIdArgs = {
  input: UpdateUserPaymentProviderByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPaymentProviderBySlugArgs = {
  input: UpdateUserPaymentProviderBySlugInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPhoneArgs = {
  input: UpdateUserPhoneInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPhoneByIdArgs = {
  input: UpdateUserPhoneByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPolicyArgs = {
  input: UpdateUserPolicyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserPolicyByIdArgs = {
  input: UpdateUserPolicyByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserUploadArgs = {
  input: UpdateUserUploadInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserUploadByIdArgs = {
  input: UpdateUserUploadByIdInput
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>
}

export type Patient = Node & {
  __typename?: 'Patient'
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection
  charmId?: Maybe<Scalars['String']['output']>
  charmRecordId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `Patient`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
  zohoId?: Maybe<Scalars['String']['output']>
}

export type PatientAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AppointmentCondition>
  filter?: InputMaybe<AppointmentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/** A condition to be used against `Patient` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PatientCondition = {
  /** Checks for equality with the object’s `charmId` field. */
  charmId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `charmRecordId` field. */
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `zohoId` field. */
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** A filter to be used against `Patient` object types. All fields are combined with a logical ‘and.’ */
export type PatientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PatientFilter>>
  /** Filter by the object’s `appointments` relation. */
  appointments?: InputMaybe<PatientToManyAppointmentFilter>
  /** Some related `appointments` exist. */
  appointmentsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `charmId` field. */
  charmId?: InputMaybe<StringFilter>
  /** Filter by the object’s `charmRecordId` field. */
  charmRecordId?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Negates the expression. */
  not?: InputMaybe<PatientFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PatientFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `zohoId` field. */
  zohoId?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `Patient` */
export type PatientInput = {
  appointments?: InputMaybe<AppointmentsPatientIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<PatientsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type PatientNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type PatientNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `patient` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type PatientOnAppointmentForAppointmentsPatientIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `appointment` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: AppointmentPatch
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsPkeyUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnAppointmentForAppointmentsPatientIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnAppointmentForAppointmentsPatientIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsUniqueCharmRecordIdUpdate = {
  charmRecordId: Scalars['String']['input']
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnAppointmentForAppointmentsPatientIdFkeyPatch
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnAppointmentForAppointmentsPatientIdFkeyUsingPatientsUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnAppointmentForAppointmentsPatientIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type PatientOnPatientForPatientsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientsUserIdFkeyUsingPatientsPkeyUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientsUserIdFkeyUsingPatientsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientsUserIdFkeyUsingPatientsUniqueCharmRecordIdUpdate = {
  charmRecordId: Scalars['String']['input']
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientsUserIdFkeyPatch
}

/** The fields on `patient` to look up the row to update. */
export type PatientOnPatientForPatientsUserIdFkeyUsingPatientsUniqueUserIdUpdate = {
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: UpdatePatientOnPatientForPatientsUserIdFkeyPatch
  userId: Scalars['UUID']['input']
}

/** Represents an update to a `Patient`. Fields that are set will be updated. */
export type PatientPatch = {
  appointments?: InputMaybe<AppointmentsPatientIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<PatientsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The fields on `patient` to look up the row to connect. */
export type PatientPatientsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `patient` to look up the row to delete. */
export type PatientPatientsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `patient` to look up the row to connect. */
export type PatientPatientsSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `patient` to look up the row to delete. */
export type PatientPatientsSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** The fields on `patient` to look up the row to connect. */
export type PatientPatientsUniqueCharmRecordIdConnect = {
  charmRecordId: Scalars['String']['input']
}

/** The fields on `patient` to look up the row to delete. */
export type PatientPatientsUniqueCharmRecordIdDelete = {
  charmRecordId: Scalars['String']['input']
}

/** The fields on `patient` to look up the row to connect. */
export type PatientPatientsUniqueUserIdConnect = {
  userId: Scalars['UUID']['input']
}

/** The fields on `patient` to look up the row to delete. */
export type PatientPatientsUniqueUserIdDelete = {
  userId: Scalars['UUID']['input']
}

/** A filter to be used against many `Appointment` object types. All fields are combined with a logical ‘and.’ */
export type PatientToManyAppointmentFilter = {
  /** Every related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AppointmentFilter>
  /** No related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AppointmentFilter>
  /** Some related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AppointmentFilter>
}

/** A connection to a list of `Patient` values. */
export type PatientsConnection = {
  __typename?: 'PatientsConnection'
  /** A list of edges which contains the `Patient` and cursor to aid in pagination. */
  edges: Array<PatientsEdge>
  /** A list of `Patient` objects. */
  nodes: Array<Patient>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Patient` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Patient` edge in the connection. */
export type PatientsEdge = {
  __typename?: 'PatientsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Patient` at the end of the edge. */
  node: Patient
}

/** Methods to use when ordering `Patient`. */
export enum PatientsOrderBy {
  AppointmentsByPatientIdCountAsc = 'APPOINTMENTS_BY_PATIENT_ID__COUNT_ASC',
  AppointmentsByPatientIdCountDesc = 'APPOINTMENTS_BY_PATIENT_ID__COUNT_DESC',
  CharmIdAsc = 'CHARM_ID_ASC',
  CharmIdDesc = 'CHARM_ID_DESC',
  CharmRecordIdAsc = 'CHARM_RECORD_ID_ASC',
  CharmRecordIdDesc = 'CHARM_RECORD_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ZohoIdAsc = 'ZOHO_ID_ASC',
  ZohoIdDesc = 'ZOHO_ID_DESC'
}

/** Input for the nested mutation of `user` in the `PatientInput` mutation. */
export type PatientsUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<PatientsUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<PatientOnPatientForPatientsUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnPatientForPatientsUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnPatientForPatientsUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `patient` in the `UserInput` mutation. */
export type PatientsUserIdFkeyInverseInput = {
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByCharmRecordId?: InputMaybe<PatientPatientsUniqueCharmRecordIdConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectById?: InputMaybe<PatientNodeIdConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByRowId?: InputMaybe<PatientPatientsPkeyConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectBySlug?: InputMaybe<PatientPatientsSlugKeyConnect>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  connectByUserId?: InputMaybe<PatientPatientsUniqueUserIdConnect>
  /** A `PatientInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<PatientsUserIdFkeyPatientsCreateInput>>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteByCharmRecordId?: InputMaybe<PatientPatientsUniqueCharmRecordIdDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteById?: InputMaybe<PatientNodeIdDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<PatientPatientsPkeyDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<PatientPatientsSlugKeyDelete>
  /** The primary key(s) for `patient` for the far side of the relationship. */
  deleteByUserId?: InputMaybe<PatientPatientsUniqueUserIdDelete>
  /** Flag indicating whether all other `patient` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByCharmRecordId?: InputMaybe<PatientOnPatientForPatientsUserIdFkeyUsingPatientsUniqueCharmRecordIdUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPatientForPatientsUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByRowId?: InputMaybe<PatientOnPatientForPatientsUserIdFkeyUsingPatientsPkeyUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateBySlug?: InputMaybe<PatientOnPatientForPatientsUserIdFkeyUsingPatientsSlugKeyUpdate>
  /** The primary key(s) and patch data for `patient` for the far side of the relationship. */
  updateByUserId?: InputMaybe<PatientOnPatientForPatientsUserIdFkeyUsingPatientsUniqueUserIdUpdate>
}

/** The `patient` to be created by this mutation. */
export type PatientsUserIdFkeyPatientsCreateInput = {
  appointments?: InputMaybe<AppointmentsPatientIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<PatientsUserIdFkeyInput>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** The `user` to be created by this mutation. */
export type PatientsUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export enum PaymentProviders {
  Stripe = 'STRIPE'
}

/** A filter to be used against PaymentProviders fields. All fields are combined with a logical ‘and.’ */
export type PaymentProvidersFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PaymentProviders>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PaymentProviders>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PaymentProviders>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PaymentProviders>
  /** Included in the specified list. */
  in?: InputMaybe<Array<PaymentProviders>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<PaymentProviders>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PaymentProviders>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PaymentProviders>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PaymentProviders>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PaymentProviders>>
}

/** A connection to a list of `Policy` values. */
export type PoliciesConnection = {
  __typename?: 'PoliciesConnection'
  /** A list of edges which contains the `Policy` and cursor to aid in pagination. */
  edges: Array<PoliciesEdge>
  /** A list of `Policy` objects. */
  nodes: Array<Policy>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Policy` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Policy` edge in the connection. */
export type PoliciesEdge = {
  __typename?: 'PoliciesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Policy` at the end of the edge. */
  node: Policy
}

/** Methods to use when ordering `Policy`. */
export enum PoliciesOrderBy {
  BodyEnAsc = 'BODY_EN_ASC',
  BodyEnDesc = 'BODY_EN_DESC',
  BodyEsAsc = 'BODY_ES_ASC',
  BodyEsDesc = 'BODY_ES_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserPoliciesByPolicyIdCountAsc = 'USER_POLICIES_BY_POLICY_ID__COUNT_ASC',
  UserPoliciesByPolicyIdCountDesc = 'USER_POLICIES_BY_POLICY_ID__COUNT_DESC',
  ValidAtAsc = 'VALID_AT_ASC',
  ValidAtDesc = 'VALID_AT_DESC'
}

export type Policy = Node & {
  __typename?: 'Policy'
  bodyEn?: Maybe<Scalars['String']['output']>
  bodyEs?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Datetime']['output']
  description?: Maybe<Scalars['String']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  type: PolicyType
  updatedAt: Scalars['Datetime']['output']
  /** Reads and enables pagination through a set of `UserPolicy`. */
  userPolicies: UserPoliciesConnection
  validAt: Scalars['Datetime']['output']
}

export type PolicyUserPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPolicyCondition>
  filter?: InputMaybe<UserPolicyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPoliciesOrderBy>>
}

/** A condition to be used against `Policy` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PolicyCondition = {
  /** Checks for equality with the object’s `bodyEn` field. */
  bodyEn?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `bodyEs` field. */
  bodyEs?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<PolicyType>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `validAt` field. */
  validAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `Policy` object types. All fields are combined with a logical ‘and.’ */
export type PolicyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PolicyFilter>>
  /** Filter by the object’s `bodyEn` field. */
  bodyEn?: InputMaybe<StringFilter>
  /** Filter by the object’s `bodyEs` field. */
  bodyEs?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PolicyFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PolicyFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<PolicyTypeFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `userPolicies` relation. */
  userPolicies?: InputMaybe<PolicyToManyUserPolicyFilter>
  /** Some related `userPolicies` exist. */
  userPoliciesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `validAt` field. */
  validAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `Policy` */
export type PolicyInput = {
  bodyEn?: InputMaybe<Scalars['String']['input']>
  bodyEs?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  type: PolicyType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userPolicies?: InputMaybe<UserPoliciesPolicyIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type PolicyNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `policy` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type PolicyNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `policy` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type PolicyOnUserPolicyForUserPoliciesPolicyIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userPolicy` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userPolicy` being updated. */
  patch: UserPolicyPatch
}

/** The fields on `policy` to look up the row to update. */
export type PolicyOnUserPolicyForUserPoliciesPolicyIdFkeyUsingPoliciesPkeyUpdate = {
  /** An object where the defined keys will be set on the `policy` being updated. */
  patch: UpdatePolicyOnUserPolicyForUserPoliciesPolicyIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `policy` to look up the row to update. */
export type PolicyOnUserPolicyForUserPoliciesPolicyIdFkeyUsingPoliciesSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `policy` being updated. */
  patch: UpdatePolicyOnUserPolicyForUserPoliciesPolicyIdFkeyPatch
  slug: Scalars['String']['input']
}

/** Represents an update to a `Policy`. Fields that are set will be updated. */
export type PolicyPatch = {
  bodyEn?: InputMaybe<Scalars['String']['input']>
  bodyEs?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<PolicyType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userPolicies?: InputMaybe<UserPoliciesPolicyIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The fields on `policy` to look up the row to connect. */
export type PolicyPoliciesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `policy` to look up the row to delete. */
export type PolicyPoliciesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `policy` to look up the row to connect. */
export type PolicyPoliciesSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `policy` to look up the row to delete. */
export type PolicyPoliciesSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** A filter to be used against many `UserPolicy` object types. All fields are combined with a logical ‘and.’ */
export type PolicyToManyUserPolicyFilter = {
  /** Every related `UserPolicy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPolicyFilter>
  /** No related `UserPolicy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPolicyFilter>
  /** Some related `UserPolicy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPolicyFilter>
}

export enum PolicyType {
  Clinician = 'CLINICIAN',
  General = 'GENERAL',
  Patient = 'PATIENT'
}

/** A filter to be used against PolicyType fields. All fields are combined with a logical ‘and.’ */
export type PolicyTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PolicyType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PolicyType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PolicyType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PolicyType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<PolicyType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<PolicyType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PolicyType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PolicyType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PolicyType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PolicyType>>
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query'
  address?: Maybe<Address>
  /** Reads a single `Address` using its globally unique `ID`. */
  addressById?: Maybe<Address>
  /** Reads and enables pagination through a set of `Address`. */
  addresses?: Maybe<AddressesConnection>
  appointment?: Maybe<Appointment>
  /** Reads and enables pagination through a set of `AppointmentAvailabilityType`. */
  appointmentAvailabilities?: Maybe<AppointmentAvailabilityTypesConnection>
  /** Reads a single `Appointment` using its globally unique `ID`. */
  appointmentById?: Maybe<Appointment>
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments?: Maybe<AppointmentsConnection>
  clinician?: Maybe<Clinician>
  /** Reads and enables pagination through a set of `ClinicianAvailability`. */
  clinicianAvailabilities?: Maybe<ClinicianAvailabilitiesConnection>
  clinicianAvailability?: Maybe<ClinicianAvailability>
  /** Reads a single `ClinicianAvailability` using its globally unique `ID`. */
  clinicianAvailabilityById?: Maybe<ClinicianAvailability>
  /** Reads a single `Clinician` using its globally unique `ID`. */
  clinicianById?: Maybe<Clinician>
  clinicianBySlug?: Maybe<Clinician>
  clinicianBySlugPublic?: Maybe<Clinician>
  clinicianByUserId?: Maybe<Clinician>
  /** Reads and enables pagination through a set of `Clinician`. */
  clinicians?: Maybe<CliniciansConnection>
  currentUser?: Maybe<User>
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  id: Scalars['ID']['output']
  insuranceProvider?: Maybe<InsuranceProvider>
  /** Reads a single `InsuranceProvider` using its globally unique `ID`. */
  insuranceProviderById?: Maybe<InsuranceProvider>
  insuranceProviderBySlug?: Maybe<InsuranceProvider>
  /** Reads and enables pagination through a set of `InsuranceProvider`. */
  insuranceProviders?: Maybe<InsuranceProvidersConnection>
  lead?: Maybe<Lead>
  /** Reads a single `Lead` using its globally unique `ID`. */
  leadById?: Maybe<Lead>
  leadBySlug?: Maybe<Lead>
  leadByUserId?: Maybe<Lead>
  /** Reads and enables pagination through a set of `Lead`. */
  leads?: Maybe<LeadsConnection>
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>
  patient?: Maybe<Patient>
  patientByCharmRecordId?: Maybe<Patient>
  /** Reads a single `Patient` using its globally unique `ID`. */
  patientById?: Maybe<Patient>
  patientBySlug?: Maybe<Patient>
  patientByUserId?: Maybe<Patient>
  /** Reads and enables pagination through a set of `Patient`. */
  patients?: Maybe<PatientsConnection>
  /** Reads and enables pagination through a set of `Policy`. */
  policies?: Maybe<PoliciesConnection>
  policy?: Maybe<Policy>
  /** Reads a single `Policy` using its globally unique `ID`. */
  policyById?: Maybe<Policy>
  policyBySlug?: Maybe<Policy>
  referralPartner?: Maybe<ReferralPartner>
  /** Reads a single `ReferralPartner` using its globally unique `ID`. */
  referralPartnerById?: Maybe<ReferralPartner>
  referralPartnerBySlug?: Maybe<ReferralPartner>
  referralPartnerBySlugPublic?: Maybe<ReferralPartner>
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** Reads a single `ReferralPartnerSource` using its globally unique `ID`. */
  referralPartnerSourceById?: Maybe<ReferralPartnerSource>
  /** Reads and enables pagination through a set of `ReferralPartnerSource`. */
  referralPartnerSources?: Maybe<ReferralPartnerSourcesConnection>
  referralPartnerUpload?: Maybe<ReferralPartnerUpload>
  /** Reads a single `ReferralPartnerUpload` using its globally unique `ID`. */
  referralPartnerUploadById?: Maybe<ReferralPartnerUpload>
  /** Reads and enables pagination through a set of `ReferralPartnerUpload`. */
  referralPartnerUploads?: Maybe<ReferralPartnerUploadsConnection>
  /** Reads and enables pagination through a set of `ReferralPartner`. */
  referralPartners?: Maybe<ReferralPartnersConnection>
  service?: Maybe<Service>
  /** Reads a single `Service` using its globally unique `ID`. */
  serviceById?: Maybe<Service>
  serviceBySlug?: Maybe<Service>
  /** Reads and enables pagination through a set of `Service`. */
  services?: Maybe<ServicesConnection>
  supportedLanguage?: Maybe<SupportedLanguage>
  /** Reads a single `SupportedLanguage` using its globally unique `ID`. */
  supportedLanguageById?: Maybe<SupportedLanguage>
  /** Reads and enables pagination through a set of `SupportedLanguage`. */
  supportedLanguages?: Maybe<SupportedLanguagesConnection>
  upload?: Maybe<Upload>
  /** Reads a single `Upload` using its globally unique `ID`. */
  uploadById?: Maybe<Upload>
  uploadBySlug?: Maybe<Upload>
  /** Reads and enables pagination through a set of `Upload`. */
  uploads?: Maybe<UploadsConnection>
  user?: Maybe<User>
  userAddress?: Maybe<UserAddress>
  /** Reads a single `UserAddress` using its globally unique `ID`. */
  userAddressById?: Maybe<UserAddress>
  /** Reads and enables pagination through a set of `UserAddress`. */
  userAddresses?: Maybe<UserAddressesConnection>
  /** Reads a single `User` using its globally unique `ID`. */
  userById?: Maybe<User>
  userBySlug?: Maybe<User>
  userChild?: Maybe<UserChild>
  /** Reads a single `UserChild` using its globally unique `ID`. */
  userChildById?: Maybe<UserChild>
  /** Reads and enables pagination through a set of `UserChild`. */
  userChildren?: Maybe<UserChildrenConnection>
  userInsurance?: Maybe<UserInsurance>
  /** Reads a single `UserInsurance` using its globally unique `ID`. */
  userInsuranceById?: Maybe<UserInsurance>
  userInsuranceUpload?: Maybe<UserInsuranceUpload>
  /** Reads a single `UserInsuranceUpload` using its globally unique `ID`. */
  userInsuranceUploadById?: Maybe<UserInsuranceUpload>
  /** Reads and enables pagination through a set of `UserInsuranceUpload`. */
  userInsuranceUploads?: Maybe<UserInsuranceUploadsConnection>
  /** Reads and enables pagination through a set of `UserInsurance`. */
  userInsurances?: Maybe<UserInsurancesConnection>
  userLanguage?: Maybe<UserLanguage>
  /** Reads a single `UserLanguage` using its globally unique `ID`. */
  userLanguageById?: Maybe<UserLanguage>
  /** Reads and enables pagination through a set of `UserLanguage`. */
  userLanguages?: Maybe<UserLanguagesConnection>
  userPaymentMethod?: Maybe<UserPaymentMethod>
  /** Reads a single `UserPaymentMethod` using its globally unique `ID`. */
  userPaymentMethodById?: Maybe<UserPaymentMethod>
  userPaymentMethodBySlug?: Maybe<UserPaymentMethod>
  /** Reads and enables pagination through a set of `UserPaymentMethod`. */
  userPaymentMethods?: Maybe<UserPaymentMethodsConnection>
  userPaymentProvider?: Maybe<UserPaymentProvider>
  /** Reads a single `UserPaymentProvider` using its globally unique `ID`. */
  userPaymentProviderById?: Maybe<UserPaymentProvider>
  userPaymentProviderBySlug?: Maybe<UserPaymentProvider>
  /** Reads and enables pagination through a set of `UserPaymentProvider`. */
  userPaymentProviders?: Maybe<UserPaymentProvidersConnection>
  userPhone?: Maybe<UserPhone>
  /** Reads a single `UserPhone` using its globally unique `ID`. */
  userPhoneById?: Maybe<UserPhone>
  /** Reads and enables pagination through a set of `UserPhone`. */
  userPhones?: Maybe<UserPhonesConnection>
  /** Reads and enables pagination through a set of `UserPolicy`. */
  userPolicies?: Maybe<UserPoliciesConnection>
  userPolicy?: Maybe<UserPolicy>
  /** Reads a single `UserPolicy` using its globally unique `ID`. */
  userPolicyById?: Maybe<UserPolicy>
  userUpload?: Maybe<UserUpload>
  /** Reads a single `UserUpload` using its globally unique `ID`. */
  userUploadById?: Maybe<UserUpload>
  /** Reads and enables pagination through a set of `UserUpload`. */
  userUploads?: Maybe<UserUploadsConnection>
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>
}

/** The root query type which gives access points into the data universe. */
export type QueryAddressArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAddressByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AddressCondition>
  filter?: InputMaybe<AddressFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentAvailabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  filter?: InputMaybe<AppointmentAvailabilityTypeFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  rangeEndsAt: Scalars['Datetime']['input']
  rangeStartsAt: Scalars['Datetime']['input']
  requestedClinicianId?: InputMaybe<Scalars['UUID']['input']>
  requestedLanguage?: InputMaybe<Scalars['String']['input']>
  requestedServiceId: Scalars['UUID']['input']
  timeslotDuration: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AppointmentCondition>
  filter?: InputMaybe<AppointmentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianAvailabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ClinicianAvailabilityCondition>
  filter?: InputMaybe<ClinicianAvailabilityFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ClinicianAvailabilitiesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianAvailabilityArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianAvailabilityByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianBySlugPublicArgs = {
  slugPublic: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryClinicianByUserIdArgs = {
  userId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryCliniciansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ClinicianCondition>
  filter?: InputMaybe<ClinicianFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<CliniciansOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryInsuranceProviderArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryInsuranceProviderByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryInsuranceProviderBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryInsuranceProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<InsuranceProviderCondition>
  filter?: InputMaybe<InsuranceProviderFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<InsuranceProvidersOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryLeadArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryLeadByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryLeadBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryLeadByUserIdArgs = {
  userId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<LeadCondition>
  filter?: InputMaybe<LeadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<LeadsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPatientArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPatientByCharmRecordIdArgs = {
  charmRecordId: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPatientByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPatientBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPatientByUserIdArgs = {
  userId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPatientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<PatientCondition>
  filter?: InputMaybe<PatientFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<PatientsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<PolicyCondition>
  filter?: InputMaybe<PolicyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<PoliciesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryPolicyArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPolicyByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryPolicyBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerBySlugPublicArgs = {
  slugPublic: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerSourceArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerSourceByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ReferralPartnerSourceCondition>
  filter?: InputMaybe<ReferralPartnerSourceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ReferralPartnerSourcesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerUploadArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerUploadByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnerUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ReferralPartnerUploadCondition>
  filter?: InputMaybe<ReferralPartnerUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ReferralPartnerUploadsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryReferralPartnersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ReferralPartnerCondition>
  filter?: InputMaybe<ReferralPartnerFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ReferralPartnersOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryServiceArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryServiceByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryServiceBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryServicesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ServiceCondition>
  filter?: InputMaybe<ServiceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ServicesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QuerySupportedLanguageArgs = {
  rowId: Scalars['Int']['input']
}

/** The root query type which gives access points into the data universe. */
export type QuerySupportedLanguageByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QuerySupportedLanguagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<SupportedLanguageCondition>
  filter?: InputMaybe<SupportedLanguageFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<SupportedLanguagesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUploadArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUploadByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUploadBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UploadCondition>
  filter?: InputMaybe<UploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UploadsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserAddressArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserAddressByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserAddressCondition>
  filter?: InputMaybe<UserAddressFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserAddressesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserChildArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserChildByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserChildCondition>
  filter?: InputMaybe<UserChildFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserChildrenOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserInsuranceArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserInsuranceByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserInsuranceUploadArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserInsuranceUploadByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserInsuranceUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserInsuranceUploadCondition>
  filter?: InputMaybe<UserInsuranceUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserInsuranceUploadsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserInsurancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserInsuranceCondition>
  filter?: InputMaybe<UserInsuranceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserInsurancesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserLanguageArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserLanguageByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserLanguagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserLanguageCondition>
  filter?: InputMaybe<UserLanguageFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserLanguagesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentMethodArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentMethodByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentMethodBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPaymentMethodCondition>
  filter?: InputMaybe<UserPaymentMethodFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPaymentMethodsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentProviderArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentProviderByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentProviderBySlugArgs = {
  slug: Scalars['String']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPaymentProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPaymentProviderCondition>
  filter?: InputMaybe<UserPaymentProviderFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPaymentProvidersOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPhoneArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPhoneByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPhonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPhoneCondition>
  filter?: InputMaybe<UserPhoneFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPhonesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPolicyCondition>
  filter?: InputMaybe<UserPolicyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPoliciesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPolicyArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserPolicyByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserUploadArgs = {
  rowId: Scalars['UUID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserUploadByIdArgs = {
  id: Scalars['ID']['input']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserUploadCondition>
  filter?: InputMaybe<UserUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserUploadsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserCondition>
  filter?: InputMaybe<UserFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UsersOrderBy>>
}

export type ReferralPartner = Node & {
  __typename?: 'ReferralPartner'
  config?: Maybe<Scalars['JSON']['output']>
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isActive?: Maybe<Scalars['Boolean']['output']>
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection
  name: Scalars['String']['output']
  /** Reads and enables pagination through a set of `ReferralPartnerSource`. */
  referralPartnerSources: ReferralPartnerSourcesConnection
  /** Reads and enables pagination through a set of `ReferralPartnerUpload`. */
  referralPartnerUploads: ReferralPartnerUploadsConnection
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  slugPublic?: Maybe<Scalars['String']['output']>
  type: ReferralPartnerType
  updatedAt: Scalars['Datetime']['output']
}

export type ReferralPartnerLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<LeadCondition>
  filter?: InputMaybe<LeadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<LeadsOrderBy>>
}

export type ReferralPartnerReferralPartnerSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ReferralPartnerSourceCondition>
  filter?: InputMaybe<ReferralPartnerSourceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ReferralPartnerSourcesOrderBy>>
}

export type ReferralPartnerReferralPartnerUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ReferralPartnerUploadCondition>
  filter?: InputMaybe<ReferralPartnerUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ReferralPartnerUploadsOrderBy>>
}

/**
 * A condition to be used against `ReferralPartner` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ReferralPartnerCondition = {
  /** Checks for equality with the object’s `config` field. */
  config?: InputMaybe<Scalars['JSON']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `slugPublic` field. */
  slugPublic?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ReferralPartnerType>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `ReferralPartner` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReferralPartnerFilter>>
  /** Filter by the object’s `config` field. */
  config?: InputMaybe<JsonFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `leads` relation. */
  leads?: InputMaybe<ReferralPartnerToManyLeadFilter>
  /** Some related `leads` exist. */
  leadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<ReferralPartnerFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReferralPartnerFilter>>
  /** Filter by the object’s `referralPartnerSources` relation. */
  referralPartnerSources?: InputMaybe<ReferralPartnerToManyReferralPartnerSourceFilter>
  /** Some related `referralPartnerSources` exist. */
  referralPartnerSourcesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `referralPartnerUploads` relation. */
  referralPartnerUploads?: InputMaybe<ReferralPartnerToManyReferralPartnerUploadFilter>
  /** Some related `referralPartnerUploads` exist. */
  referralPartnerUploadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `slugPublic` field. */
  slugPublic?: InputMaybe<StringFilter>
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<ReferralPartnerTypeFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `ReferralPartner` */
export type ReferralPartnerInput = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type: ReferralPartnerType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type ReferralPartnerNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `referralPartner` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type ReferralPartnerNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `referralPartner` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `lead` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: LeadPatch
}

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyUsingReferralPartnerPkeyUpdate = {
  /** An object where the defined keys will be set on the `referralPartner` being updated. */
  patch: UpdateReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyUsingReferralPartnerSlugPublicUpdate = {
  /** An object where the defined keys will be set on the `referralPartner` being updated. */
  patch: UpdateReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyPatch
  slugPublic: Scalars['String']['input']
}

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyUsingReferralPartnerUniqueSlugUpdate = {
  /** An object where the defined keys will be set on the `referralPartner` being updated. */
  patch: UpdateReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartnerSource` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartnerSource` being updated. */
  patch: ReferralPartnerSourcePatch
}

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartner` being updated. */
    patch: UpdateReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerSlugPublicUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartner` being updated. */
    patch: UpdateReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyPatch
    slugPublic: Scalars['String']['input']
  }

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerUniqueSlugUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartner` being updated. */
    patch: UpdateReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyPatch
    slug: Scalars['String']['input']
  }

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartnerUpload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartnerUpload` being updated. */
  patch: ReferralPartnerUploadPatch
}

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartner` being updated. */
    patch: UpdateReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerSlugPublicUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartner` being updated. */
    patch: UpdateReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyPatch
    slugPublic: Scalars['String']['input']
  }

/** The fields on `referralPartner` to look up the row to update. */
export type ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerUniqueSlugUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartner` being updated. */
    patch: UpdateReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyPatch
    slug: Scalars['String']['input']
  }

/** Represents an update to a `ReferralPartner`. Fields that are set will be updated. */
export type ReferralPartnerPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ReferralPartnerType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The fields on `referralPartner` to look up the row to connect. */
export type ReferralPartnerReferralPartnerPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `referralPartner` to look up the row to delete. */
export type ReferralPartnerReferralPartnerPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `referralPartner` to look up the row to connect. */
export type ReferralPartnerReferralPartnerSlugPublicConnect = {
  slugPublic: Scalars['String']['input']
}

/** The fields on `referralPartner` to look up the row to delete. */
export type ReferralPartnerReferralPartnerSlugPublicDelete = {
  slugPublic: Scalars['String']['input']
}

/** The fields on `referralPartner` to look up the row to connect. */
export type ReferralPartnerReferralPartnerUniqueSlugConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `referralPartner` to look up the row to delete. */
export type ReferralPartnerReferralPartnerUniqueSlugDelete = {
  slug: Scalars['String']['input']
}

export type ReferralPartnerSource = Node & {
  __typename?: 'ReferralPartnerSource'
  description: Scalars['String']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  /** Reads and enables pagination through a set of `Lead`. */
  leads: LeadsConnection
  name: Scalars['String']['output']
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerSource`. */
  referralPartner?: Maybe<ReferralPartner>
  referralPartnerId: Scalars['UUID']['output']
  rowId: Scalars['UUID']['output']
}

export type ReferralPartnerSourceLeadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<LeadCondition>
  filter?: InputMaybe<LeadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<LeadsOrderBy>>
}

/**
 * A condition to be used against `ReferralPartnerSource` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReferralPartnerSourceCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `referralPartnerId` field. */
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `ReferralPartnerSource` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerSourceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReferralPartnerSourceFilter>>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `leads` relation. */
  leads?: InputMaybe<ReferralPartnerSourceToManyLeadFilter>
  /** Some related `leads` exist. */
  leadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<ReferralPartnerSourceFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReferralPartnerSourceFilter>>
  /** Filter by the object’s `referralPartner` relation. */
  referralPartner?: InputMaybe<ReferralPartnerFilter>
  /** Filter by the object’s `referralPartnerId` field. */
  referralPartnerId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `ReferralPartnerSource` */
export type ReferralPartnerSourceInput = {
  description: Scalars['String']['input']
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartner?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type ReferralPartnerSourceNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `referralPartnerSource` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type ReferralPartnerSourceNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `referralPartnerSource` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerSourceOnLeadForLeadsReferralPartnerSourceIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `lead` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: LeadPatch
}

/** The fields on `referralPartnerSource` to look up the row to update. */
export type ReferralPartnerSourceOnLeadForLeadsReferralPartnerSourceIdFkeyUsingReferralPartnerSourcesPkeyUpdate = {
  /** An object where the defined keys will be set on the `referralPartnerSource` being updated. */
  patch: UpdateReferralPartnerSourceOnLeadForLeadsReferralPartnerSourceIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerSourceOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartner` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartner` being updated. */
  patch: ReferralPartnerPatch
}

/** The fields on `referralPartnerSource` to look up the row to update. */
export type ReferralPartnerSourceOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerSourcesPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartnerSource` being updated. */
    patch: UpdateReferralPartnerSourceOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** Represents an update to a `ReferralPartnerSource`. Fields that are set will be updated. */
export type ReferralPartnerSourcePatch = {
  description?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `referralPartnerSource` to look up the row to connect. */
export type ReferralPartnerSourceReferralPartnerSourcesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `referralPartnerSource` to look up the row to delete. */
export type ReferralPartnerSourceReferralPartnerSourcesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A filter to be used against many `Lead` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerSourceToManyLeadFilter = {
  /** Every related `Lead` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LeadFilter>
  /** No related `Lead` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LeadFilter>
  /** Some related `Lead` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LeadFilter>
}

/** A connection to a list of `ReferralPartnerSource` values. */
export type ReferralPartnerSourcesConnection = {
  __typename?: 'ReferralPartnerSourcesConnection'
  /** A list of edges which contains the `ReferralPartnerSource` and cursor to aid in pagination. */
  edges: Array<ReferralPartnerSourcesEdge>
  /** A list of `ReferralPartnerSource` objects. */
  nodes: Array<ReferralPartnerSource>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `ReferralPartnerSource` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `ReferralPartnerSource` edge in the connection. */
export type ReferralPartnerSourcesEdge = {
  __typename?: 'ReferralPartnerSourcesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `ReferralPartnerSource` at the end of the edge. */
  node: ReferralPartnerSource
}

/** Methods to use when ordering `ReferralPartnerSource`. */
export enum ReferralPartnerSourcesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  LeadsByReferralPartnerSourceIdCountAsc = 'LEADS_BY_REFERRAL_PARTNER_SOURCE_ID__COUNT_ASC',
  LeadsByReferralPartnerSourceIdCountDesc = 'LEADS_BY_REFERRAL_PARTNER_SOURCE_ID__COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralPartnerByReferralPartnerIdConfigAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CONFIG_ASC',
  ReferralPartnerByReferralPartnerIdConfigDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CONFIG_DESC',
  ReferralPartnerByReferralPartnerIdCreatedAtAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CREATED_AT_ASC',
  ReferralPartnerByReferralPartnerIdCreatedAtDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CREATED_AT_DESC',
  ReferralPartnerByReferralPartnerIdIdAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__ID_ASC',
  ReferralPartnerByReferralPartnerIdIdDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__ID_DESC',
  ReferralPartnerByReferralPartnerIdIsActiveAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__IS_ACTIVE_ASC',
  ReferralPartnerByReferralPartnerIdIsActiveDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__IS_ACTIVE_DESC',
  ReferralPartnerByReferralPartnerIdNameAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__NAME_ASC',
  ReferralPartnerByReferralPartnerIdNameDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__NAME_DESC',
  ReferralPartnerByReferralPartnerIdSlugAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_ASC',
  ReferralPartnerByReferralPartnerIdSlugDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_DESC',
  ReferralPartnerByReferralPartnerIdSlugPublicAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_PUBLIC_ASC',
  ReferralPartnerByReferralPartnerIdSlugPublicDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_PUBLIC_DESC',
  ReferralPartnerByReferralPartnerIdTypeAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__TYPE_ASC',
  ReferralPartnerByReferralPartnerIdTypeDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__TYPE_DESC',
  ReferralPartnerByReferralPartnerIdUpdatedAtAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__UPDATED_AT_ASC',
  ReferralPartnerByReferralPartnerIdUpdatedAtDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__UPDATED_AT_DESC',
  ReferralPartnerIdAsc = 'REFERRAL_PARTNER_ID_ASC',
  ReferralPartnerIdDesc = 'REFERRAL_PARTNER_ID_DESC'
}

/** Input for the nested mutation of `referralPartner` in the `ReferralPartnerSourceInput` mutation. */
export type ReferralPartnerSourcesReferralPartnerIdFkeyInput = {
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectById?: InputMaybe<ReferralPartnerNodeIdConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ReferralPartnerReferralPartnerPkeyConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ReferralPartnerReferralPartnerUniqueSlugConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectBySlugPublic?: InputMaybe<ReferralPartnerReferralPartnerSlugPublicConnect>
  /** A `ReferralPartnerInput` object that will be created and connected to this object. */
  create?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyReferralPartnersCreateInput>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteById?: InputMaybe<ReferralPartnerNodeIdDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ReferralPartnerReferralPartnerPkeyDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ReferralPartnerReferralPartnerUniqueSlugDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteBySlugPublic?: InputMaybe<ReferralPartnerReferralPartnerSlugPublicDelete>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateById?: InputMaybe<ReferralPartnerSourceOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerPkeyUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerUniqueSlugUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateBySlugPublic?: InputMaybe<ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerSlugPublicUpdate>
}

/** Input for the nested mutation of `referralPartnerSource` in the `ReferralPartnerInput` mutation. */
export type ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput = {
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ReferralPartnerSourceNodeIdConnect>>
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<ReferralPartnerSourceReferralPartnerSourcesPkeyConnect>>
  /** A `ReferralPartnerSourceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ReferralPartnerSourcesReferralPartnerIdFkeyReferralPartnerSourcesCreateInput>>
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ReferralPartnerSourceNodeIdDelete>>
  /** The primary key(s) for `referralPartnerSource` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<ReferralPartnerSourceReferralPartnerSourcesPkeyDelete>>
  /** Flag indicating whether all other `referralPartnerSource` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `referralPartnerSource` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyNodeIdUpdate>
  >
  /** The primary key(s) and patch data for `referralPartnerSource` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<ReferralPartnerSourceOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyUsingReferralPartnerSourcesPkeyUpdate>
  >
}

/** The `referralPartnerSource` to be created by this mutation. */
export type ReferralPartnerSourcesReferralPartnerIdFkeyReferralPartnerSourcesCreateInput = {
  description: Scalars['String']['input']
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartner?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** The `referralPartner` to be created by this mutation. */
export type ReferralPartnerSourcesReferralPartnerIdFkeyReferralPartnersCreateInput = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type: ReferralPartnerType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against many `Lead` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerToManyLeadFilter = {
  /** Every related `Lead` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LeadFilter>
  /** No related `Lead` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LeadFilter>
  /** Some related `Lead` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LeadFilter>
}

/** A filter to be used against many `ReferralPartnerSource` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerToManyReferralPartnerSourceFilter = {
  /** Every related `ReferralPartnerSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReferralPartnerSourceFilter>
  /** No related `ReferralPartnerSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReferralPartnerSourceFilter>
  /** Some related `ReferralPartnerSource` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReferralPartnerSourceFilter>
}

/** A filter to be used against many `ReferralPartnerUpload` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerToManyReferralPartnerUploadFilter = {
  /** Every related `ReferralPartnerUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReferralPartnerUploadFilter>
  /** No related `ReferralPartnerUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReferralPartnerUploadFilter>
  /** Some related `ReferralPartnerUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReferralPartnerUploadFilter>
}

export enum ReferralPartnerType {
  Clinical = 'CLINICAL',
  Dme = 'DME',
  Employer = 'EMPLOYER'
}

/** A filter to be used against ReferralPartnerType fields. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ReferralPartnerType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ReferralPartnerType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ReferralPartnerType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ReferralPartnerType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<ReferralPartnerType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<ReferralPartnerType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ReferralPartnerType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ReferralPartnerType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ReferralPartnerType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ReferralPartnerType>>
}

export type ReferralPartnerUpload = Node & {
  __typename?: 'ReferralPartnerUpload'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerUpload`. */
  referralPartner?: Maybe<ReferralPartner>
  referralPartnerId: Scalars['UUID']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `Upload` that is related to this `ReferralPartnerUpload`. */
  upload?: Maybe<Upload>
  uploadId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `ReferralPartnerUpload` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ReferralPartnerUploadCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `referralPartnerId` field. */
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `uploadId` field. */
  uploadId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `ReferralPartnerUpload` object types. All fields are combined with a logical ‘and.’ */
export type ReferralPartnerUploadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ReferralPartnerUploadFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<ReferralPartnerUploadFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ReferralPartnerUploadFilter>>
  /** Filter by the object’s `referralPartner` relation. */
  referralPartner?: InputMaybe<ReferralPartnerFilter>
  /** Filter by the object’s `referralPartnerId` field. */
  referralPartnerId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `upload` relation. */
  upload?: InputMaybe<UploadFilter>
  /** Filter by the object’s `uploadId` field. */
  uploadId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `ReferralPartnerUpload` */
export type ReferralPartnerUploadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  referralPartner?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type ReferralPartnerUploadNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `referralPartnerUpload` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type ReferralPartnerUploadNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `referralPartnerUpload` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartner` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartner` being updated. */
  patch: ReferralPartnerPatch
}

/** The fields on `referralPartnerUpload` to look up the row to update. */
export type ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerUploadsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartnerUpload` being updated. */
    patch: UpdateReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** The globally unique `ID` look up for the row to update. */
export type ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `upload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UploadPatch
}

/** The fields on `referralPartnerUpload` to look up the row to update. */
export type ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyUsingReferralPartnerUploadsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `referralPartnerUpload` being updated. */
    patch: UpdateReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** Represents an update to a `ReferralPartnerUpload`. Fields that are set will be updated. */
export type ReferralPartnerUploadPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `referralPartnerUpload` to look up the row to connect. */
export type ReferralPartnerUploadReferralPartnerUploadsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `referralPartnerUpload` to look up the row to delete. */
export type ReferralPartnerUploadReferralPartnerUploadsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `ReferralPartnerUpload` values. */
export type ReferralPartnerUploadsConnection = {
  __typename?: 'ReferralPartnerUploadsConnection'
  /** A list of edges which contains the `ReferralPartnerUpload` and cursor to aid in pagination. */
  edges: Array<ReferralPartnerUploadsEdge>
  /** A list of `ReferralPartnerUpload` objects. */
  nodes: Array<ReferralPartnerUpload>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `ReferralPartnerUpload` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `ReferralPartnerUpload` edge in the connection. */
export type ReferralPartnerUploadsEdge = {
  __typename?: 'ReferralPartnerUploadsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `ReferralPartnerUpload` at the end of the edge. */
  node: ReferralPartnerUpload
}

/** Methods to use when ordering `ReferralPartnerUpload`. */
export enum ReferralPartnerUploadsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralPartnerByReferralPartnerIdConfigAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CONFIG_ASC',
  ReferralPartnerByReferralPartnerIdConfigDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CONFIG_DESC',
  ReferralPartnerByReferralPartnerIdCreatedAtAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CREATED_AT_ASC',
  ReferralPartnerByReferralPartnerIdCreatedAtDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__CREATED_AT_DESC',
  ReferralPartnerByReferralPartnerIdIdAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__ID_ASC',
  ReferralPartnerByReferralPartnerIdIdDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__ID_DESC',
  ReferralPartnerByReferralPartnerIdIsActiveAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__IS_ACTIVE_ASC',
  ReferralPartnerByReferralPartnerIdIsActiveDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__IS_ACTIVE_DESC',
  ReferralPartnerByReferralPartnerIdNameAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__NAME_ASC',
  ReferralPartnerByReferralPartnerIdNameDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__NAME_DESC',
  ReferralPartnerByReferralPartnerIdSlugAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_ASC',
  ReferralPartnerByReferralPartnerIdSlugDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_DESC',
  ReferralPartnerByReferralPartnerIdSlugPublicAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_PUBLIC_ASC',
  ReferralPartnerByReferralPartnerIdSlugPublicDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__SLUG_PUBLIC_DESC',
  ReferralPartnerByReferralPartnerIdTypeAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__TYPE_ASC',
  ReferralPartnerByReferralPartnerIdTypeDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__TYPE_DESC',
  ReferralPartnerByReferralPartnerIdUpdatedAtAsc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__UPDATED_AT_ASC',
  ReferralPartnerByReferralPartnerIdUpdatedAtDesc = 'REFERRAL_PARTNER_BY_REFERRAL_PARTNER_ID__UPDATED_AT_DESC',
  ReferralPartnerIdAsc = 'REFERRAL_PARTNER_ID_ASC',
  ReferralPartnerIdDesc = 'REFERRAL_PARTNER_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UploadByUploadIdBucketAsc = 'UPLOAD_BY_UPLOAD_ID__BUCKET_ASC',
  UploadByUploadIdBucketDesc = 'UPLOAD_BY_UPLOAD_ID__BUCKET_DESC',
  UploadByUploadIdCreatedAtAsc = 'UPLOAD_BY_UPLOAD_ID__CREATED_AT_ASC',
  UploadByUploadIdCreatedAtDesc = 'UPLOAD_BY_UPLOAD_ID__CREATED_AT_DESC',
  UploadByUploadIdFilenameAsc = 'UPLOAD_BY_UPLOAD_ID__FILENAME_ASC',
  UploadByUploadIdFilenameDesc = 'UPLOAD_BY_UPLOAD_ID__FILENAME_DESC',
  UploadByUploadIdFilesizeAsc = 'UPLOAD_BY_UPLOAD_ID__FILESIZE_ASC',
  UploadByUploadIdFilesizeDesc = 'UPLOAD_BY_UPLOAD_ID__FILESIZE_DESC',
  UploadByUploadIdFiletypeAsc = 'UPLOAD_BY_UPLOAD_ID__FILETYPE_ASC',
  UploadByUploadIdFiletypeDesc = 'UPLOAD_BY_UPLOAD_ID__FILETYPE_DESC',
  UploadByUploadIdIdAsc = 'UPLOAD_BY_UPLOAD_ID__ID_ASC',
  UploadByUploadIdIdDesc = 'UPLOAD_BY_UPLOAD_ID__ID_DESC',
  UploadByUploadIdKeyAsc = 'UPLOAD_BY_UPLOAD_ID__KEY_ASC',
  UploadByUploadIdKeyDesc = 'UPLOAD_BY_UPLOAD_ID__KEY_DESC',
  UploadByUploadIdSlugAsc = 'UPLOAD_BY_UPLOAD_ID__SLUG_ASC',
  UploadByUploadIdSlugDesc = 'UPLOAD_BY_UPLOAD_ID__SLUG_DESC',
  UploadByUploadIdUpdatedAtAsc = 'UPLOAD_BY_UPLOAD_ID__UPDATED_AT_ASC',
  UploadByUploadIdUpdatedAtDesc = 'UPLOAD_BY_UPLOAD_ID__UPDATED_AT_DESC',
  UploadByUploadIdUploaderIdAsc = 'UPLOAD_BY_UPLOAD_ID__UPLOADER_ID_ASC',
  UploadByUploadIdUploaderIdDesc = 'UPLOAD_BY_UPLOAD_ID__UPLOADER_ID_DESC',
  UploadIdAsc = 'UPLOAD_ID_ASC',
  UploadIdDesc = 'UPLOAD_ID_DESC'
}

/** Input for the nested mutation of `referralPartner` in the `ReferralPartnerUploadInput` mutation. */
export type ReferralPartnerUploadsReferralPartnerIdFkeyInput = {
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectById?: InputMaybe<ReferralPartnerNodeIdConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectByRowId?: InputMaybe<ReferralPartnerReferralPartnerPkeyConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectBySlug?: InputMaybe<ReferralPartnerReferralPartnerUniqueSlugConnect>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  connectBySlugPublic?: InputMaybe<ReferralPartnerReferralPartnerSlugPublicConnect>
  /** A `ReferralPartnerInput` object that will be created and connected to this object. */
  create?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyReferralPartnersCreateInput>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteById?: InputMaybe<ReferralPartnerNodeIdDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<ReferralPartnerReferralPartnerPkeyDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<ReferralPartnerReferralPartnerUniqueSlugDelete>
  /** The primary key(s) for `referralPartner` for the far side of the relationship. */
  deleteBySlugPublic?: InputMaybe<ReferralPartnerReferralPartnerSlugPublicDelete>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateById?: InputMaybe<ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateByRowId?: InputMaybe<ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerPkeyUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateBySlug?: InputMaybe<ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerUniqueSlugUpdate>
  /** The primary key(s) and patch data for `referralPartner` for the far side of the relationship. */
  updateBySlugPublic?: InputMaybe<ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerSlugPublicUpdate>
}

/** Input for the nested mutation of `referralPartnerUpload` in the `ReferralPartnerInput` mutation. */
export type ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput = {
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ReferralPartnerUploadNodeIdConnect>>
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<ReferralPartnerUploadReferralPartnerUploadsPkeyConnect>>
  /** A `ReferralPartnerUploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ReferralPartnerUploadsReferralPartnerIdFkeyReferralPartnerUploadsCreateInput>>
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ReferralPartnerUploadNodeIdDelete>>
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<ReferralPartnerUploadReferralPartnerUploadsPkeyDelete>>
  /** Flag indicating whether all other `referralPartnerUpload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `referralPartnerUpload` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<ReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyNodeIdUpdate>
  >
  /** The primary key(s) and patch data for `referralPartnerUpload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyUsingReferralPartnerUploadsPkeyUpdate>
  >
}

/** The `referralPartnerUpload` to be created by this mutation. */
export type ReferralPartnerUploadsReferralPartnerIdFkeyReferralPartnerUploadsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  referralPartner?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
}

/** The `referralPartner` to be created by this mutation. */
export type ReferralPartnerUploadsReferralPartnerIdFkeyReferralPartnersCreateInput = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name: Scalars['String']['input']
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type: ReferralPartnerType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Input for the nested mutation of `upload` in the `ReferralPartnerUploadInput` mutation. */
export type ReferralPartnerUploadsUploadIdFkeyInput = {
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectById?: InputMaybe<UploadNodeIdConnect>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UploadUploadsPkeyConnect>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UploadUploadsSlugKeyConnect>
  /** A `UploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyUploadsCreateInput>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteById?: InputMaybe<UploadNodeIdDelete>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UploadUploadsPkeyDelete>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UploadUploadsSlugKeyDelete>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateById?: InputMaybe<ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyUsingUploadsPkeyUpdate>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyUsingUploadsSlugKeyUpdate>
}

/** Input for the nested mutation of `referralPartnerUpload` in the `UploadInput` mutation. */
export type ReferralPartnerUploadsUploadIdFkeyInverseInput = {
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ReferralPartnerUploadNodeIdConnect>>
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<ReferralPartnerUploadReferralPartnerUploadsPkeyConnect>>
  /** A `ReferralPartnerUploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<ReferralPartnerUploadsUploadIdFkeyReferralPartnerUploadsCreateInput>>
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ReferralPartnerUploadNodeIdDelete>>
  /** The primary key(s) for `referralPartnerUpload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<ReferralPartnerUploadReferralPartnerUploadsPkeyDelete>>
  /** Flag indicating whether all other `referralPartnerUpload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `referralPartnerUpload` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `referralPartnerUpload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<ReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyUsingReferralPartnerUploadsPkeyUpdate>
  >
}

/** The `referralPartnerUpload` to be created by this mutation. */
export type ReferralPartnerUploadsUploadIdFkeyReferralPartnerUploadsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  referralPartner?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInput>
}

/** The `upload` to be created by this mutation. */
export type ReferralPartnerUploadsUploadIdFkeyUploadsCreateInput = {
  bucket: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  filetype: Scalars['String']['input']
  key: Scalars['String']['input']
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** A connection to a list of `ReferralPartner` values. */
export type ReferralPartnersConnection = {
  __typename?: 'ReferralPartnersConnection'
  /** A list of edges which contains the `ReferralPartner` and cursor to aid in pagination. */
  edges: Array<ReferralPartnersEdge>
  /** A list of `ReferralPartner` objects. */
  nodes: Array<ReferralPartner>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `ReferralPartner` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `ReferralPartner` edge in the connection. */
export type ReferralPartnersEdge = {
  __typename?: 'ReferralPartnersEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `ReferralPartner` at the end of the edge. */
  node: ReferralPartner
}

/** Methods to use when ordering `ReferralPartner`. */
export enum ReferralPartnersOrderBy {
  ConfigAsc = 'CONFIG_ASC',
  ConfigDesc = 'CONFIG_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  LeadsByReferralPartnerIdCountAsc = 'LEADS_BY_REFERRAL_PARTNER_ID__COUNT_ASC',
  LeadsByReferralPartnerIdCountDesc = 'LEADS_BY_REFERRAL_PARTNER_ID__COUNT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralPartnerSourcesByReferralPartnerIdCountAsc = 'REFERRAL_PARTNER_SOURCES_BY_REFERRAL_PARTNER_ID__COUNT_ASC',
  ReferralPartnerSourcesByReferralPartnerIdCountDesc = 'REFERRAL_PARTNER_SOURCES_BY_REFERRAL_PARTNER_ID__COUNT_DESC',
  ReferralPartnerUploadsByReferralPartnerIdCountAsc = 'REFERRAL_PARTNER_UPLOADS_BY_REFERRAL_PARTNER_ID__COUNT_ASC',
  ReferralPartnerUploadsByReferralPartnerIdCountDesc = 'REFERRAL_PARTNER_UPLOADS_BY_REFERRAL_PARTNER_ID__COUNT_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SlugPublicAsc = 'SLUG_PUBLIC_ASC',
  SlugPublicDesc = 'SLUG_PUBLIC_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type Service = Node & {
  __typename?: 'Service'
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection
  charmServiceId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Datetime']['output']
  duration: Interval
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  price: Scalars['BigFloat']['output']
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
}

export type ServiceAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AppointmentCondition>
  filter?: InputMaybe<AppointmentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/** A condition to be used against `Service` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ServiceCondition = {
  /** Checks for equality with the object’s `charmServiceId` field. */
  charmServiceId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `Service` object types. All fields are combined with a logical ‘and.’ */
export type ServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceFilter>>
  /** Filter by the object’s `appointments` relation. */
  appointments?: InputMaybe<ServiceToManyAppointmentFilter>
  /** Some related `appointments` exist. */
  appointmentsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `charmServiceId` field. */
  charmServiceId?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<ServiceFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceFilter>>
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `Service` */
export type ServiceInput = {
  appointments?: InputMaybe<AppointmentsServiceIdFkeyInverseInput>
  charmServiceId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  duration: IntervalInput
  isActive: Scalars['Boolean']['input']
  name: Scalars['String']['input']
  price: Scalars['BigFloat']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type ServiceNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `service` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type ServiceNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `service` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type ServiceOnAppointmentForAppointmentsServiceIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `appointment` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: AppointmentPatch
}

/** The fields on `service` to look up the row to update. */
export type ServiceOnAppointmentForAppointmentsServiceIdFkeyUsingServicesPkeyUpdate = {
  /** An object where the defined keys will be set on the `service` being updated. */
  patch: UpdateServiceOnAppointmentForAppointmentsServiceIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `service` to look up the row to update. */
export type ServiceOnAppointmentForAppointmentsServiceIdFkeyUsingServicesSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `service` being updated. */
  patch: UpdateServiceOnAppointmentForAppointmentsServiceIdFkeyPatch
  slug: Scalars['String']['input']
}

/** Represents an update to a `Service`. Fields that are set will be updated. */
export type ServicePatch = {
  appointments?: InputMaybe<AppointmentsServiceIdFkeyInverseInput>
  charmServiceId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  duration?: InputMaybe<IntervalInput>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['BigFloat']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The fields on `service` to look up the row to connect. */
export type ServiceServicesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `service` to look up the row to delete. */
export type ServiceServicesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `service` to look up the row to connect. */
export type ServiceServicesSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `service` to look up the row to delete. */
export type ServiceServicesSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** A filter to be used against many `Appointment` object types. All fields are combined with a logical ‘and.’ */
export type ServiceToManyAppointmentFilter = {
  /** Every related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AppointmentFilter>
  /** No related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AppointmentFilter>
  /** Some related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AppointmentFilter>
}

/** A connection to a list of `Service` values. */
export type ServicesConnection = {
  __typename?: 'ServicesConnection'
  /** A list of edges which contains the `Service` and cursor to aid in pagination. */
  edges: Array<ServicesEdge>
  /** A list of `Service` objects. */
  nodes: Array<Service>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Service` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Service` edge in the connection. */
export type ServicesEdge = {
  __typename?: 'ServicesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Service` at the end of the edge. */
  node: Service
}

/** Methods to use when ordering `Service`. */
export enum ServicesOrderBy {
  AppointmentsByServiceIdCountAsc = 'APPOINTMENTS_BY_SERVICE_ID__COUNT_ASC',
  AppointmentsByServiceIdCountDesc = 'APPOINTMENTS_BY_SERVICE_ID__COUNT_DESC',
  CharmServiceIdAsc = 'CHARM_SERVICE_ID_ASC',
  CharmServiceIdDesc = 'CHARM_SERVICE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DurationAsc = 'DURATION_ASC',
  DurationDesc = 'DURATION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>
}

export type SupportedLanguage = Node & {
  __typename?: 'SupportedLanguage'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  iso2: Scalars['String']['output']
  iso3: Scalars['String']['output']
  name: Scalars['String']['output']
  nativeName: Scalars['String']['output']
  rowId: Scalars['Int']['output']
  updatedAt: Scalars['Datetime']['output']
}

/**
 * A condition to be used against `SupportedLanguage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SupportedLanguageCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `iso2` field. */
  iso2?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `iso3` field. */
  iso3?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `nativeName` field. */
  nativeName?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['Int']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `SupportedLanguage` object types. All fields are combined with a logical ‘and.’ */
export type SupportedLanguageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SupportedLanguageFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `iso2` field. */
  iso2?: InputMaybe<StringFilter>
  /** Filter by the object’s `iso3` field. */
  iso3?: InputMaybe<StringFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Filter by the object’s `nativeName` field. */
  nativeName?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<SupportedLanguageFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SupportedLanguageFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<IntFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `SupportedLanguage` */
export type SupportedLanguageInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  iso2: Scalars['String']['input']
  iso3: Scalars['String']['input']
  name: Scalars['String']['input']
  nativeName: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** Represents an update to a `SupportedLanguage`. Fields that are set will be updated. */
export type SupportedLanguagePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  iso2?: InputMaybe<Scalars['String']['input']>
  iso3?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  nativeName?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A connection to a list of `SupportedLanguage` values. */
export type SupportedLanguagesConnection = {
  __typename?: 'SupportedLanguagesConnection'
  /** A list of edges which contains the `SupportedLanguage` and cursor to aid in pagination. */
  edges: Array<SupportedLanguagesEdge>
  /** A list of `SupportedLanguage` objects. */
  nodes: Array<SupportedLanguage>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `SupportedLanguage` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `SupportedLanguage` edge in the connection. */
export type SupportedLanguagesEdge = {
  __typename?: 'SupportedLanguagesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `SupportedLanguage` at the end of the edge. */
  node: SupportedLanguage
}

/** Methods to use when ordering `SupportedLanguage`. */
export enum SupportedLanguagesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Iso2Asc = 'ISO2_ASC',
  Iso2Desc = 'ISO2_DESC',
  Iso3Asc = 'ISO3_ASC',
  Iso3Desc = 'ISO3_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NativeNameAsc = 'NATIVE_NAME_ASC',
  NativeNameDesc = 'NATIVE_NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>
}

/** All input for the `updateAddressById` mutation. */
export type UpdateAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Address` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Address` being updated. */
  patch: AddressPatch
}

/** All input for the `updateAddress` mutation. */
export type UpdateAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Address` being updated. */
  patch: AddressPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Address` mutation. */
export type UpdateAddressPayload = {
  __typename?: 'UpdateAddressPayload'
  /** The `Address` that was updated by this mutation. */
  address?: Maybe<Address>
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
}

/** The output of our update `Address` mutation. */
export type UpdateAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** All input for the `updateAppointmentById` mutation. */
export type UpdateAppointmentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Appointment` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Appointment` being updated. */
  patch: AppointmentPatch
}

/** All input for the `updateAppointment` mutation. */
export type UpdateAppointmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Appointment` being updated. */
  patch: AppointmentPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Appointment` mutation. */
export type UpdateAppointmentPayload = {
  __typename?: 'UpdateAppointmentPayload'
  /** The `Appointment` that was updated by this mutation. */
  appointment?: Maybe<Appointment>
  /** An edge for our `Appointment`. May be used by Relay 1. */
  appointmentEdge?: Maybe<AppointmentsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `Appointment`. */
  clinician?: Maybe<Clinician>
  /** Reads a single `Patient` that is related to this `Appointment`. */
  patient?: Maybe<Patient>
  /** Reads a single `Service` that is related to this `Appointment`. */
  service?: Maybe<Service>
  /** Reads a single `UserChild` that is related to this `Appointment`. */
  userChild?: Maybe<UserChild>
}

/** The output of our update `Appointment` mutation. */
export type UpdateAppointmentPayloadAppointmentEdgeArgs = {
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/** All input for the `updateClinicianAvailabilityById` mutation. */
export type UpdateClinicianAvailabilityByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ClinicianAvailability` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `ClinicianAvailability` being updated. */
  patch: ClinicianAvailabilityPatch
}

/** All input for the `updateClinicianAvailability` mutation. */
export type UpdateClinicianAvailabilityInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `ClinicianAvailability` being updated. */
  patch: ClinicianAvailabilityPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `ClinicianAvailability` mutation. */
export type UpdateClinicianAvailabilityPayload = {
  __typename?: 'UpdateClinicianAvailabilityPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Clinician` that is related to this `ClinicianAvailability`. */
  clinician?: Maybe<Clinician>
  /** The `ClinicianAvailability` that was updated by this mutation. */
  clinicianAvailability?: Maybe<ClinicianAvailability>
  /** An edge for our `ClinicianAvailability`. May be used by Relay 1. */
  clinicianAvailabilityEdge?: Maybe<ClinicianAvailabilitiesEdge>
}

/** The output of our update `ClinicianAvailability` mutation. */
export type UpdateClinicianAvailabilityPayloadClinicianAvailabilityEdgeArgs = {
  orderBy?: InputMaybe<Array<ClinicianAvailabilitiesOrderBy>>
}

/** All input for the `updateClinicianById` mutation. */
export type UpdateClinicianByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Clinician` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Clinician` being updated. */
  patch: ClinicianPatch
}

/** All input for the `updateClinicianBySlug` mutation. */
export type UpdateClinicianBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Clinician` being updated. */
  patch: ClinicianPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateClinicianBySlugPublic` mutation. */
export type UpdateClinicianBySlugPublicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Clinician` being updated. */
  patch: ClinicianPatch
  slugPublic: Scalars['String']['input']
}

/** All input for the `updateClinicianByUserId` mutation. */
export type UpdateClinicianByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Clinician` being updated. */
  patch: ClinicianPatch
  userId: Scalars['UUID']['input']
}

/** All input for the `updateClinician` mutation. */
export type UpdateClinicianInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Clinician` being updated. */
  patch: ClinicianPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Clinician` mutation. */
export type UpdateClinicianPayload = {
  __typename?: 'UpdateClinicianPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Clinician` that was updated by this mutation. */
  clinician?: Maybe<Clinician>
  /** An edge for our `Clinician`. May be used by Relay 1. */
  clinicianEdge?: Maybe<CliniciansEdge>
  /** Reads a single `User` that is related to this `Clinician`. */
  user?: Maybe<User>
}

/** The output of our update `Clinician` mutation. */
export type UpdateClinicianPayloadClinicianEdgeArgs = {
  orderBy?: InputMaybe<Array<CliniciansOrderBy>>
}

/** All input for the `updateInsuranceProviderById` mutation. */
export type UpdateInsuranceProviderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `InsuranceProvider` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `InsuranceProvider` being updated. */
  patch: InsuranceProviderPatch
}

/** All input for the `updateInsuranceProviderBySlug` mutation. */
export type UpdateInsuranceProviderBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `InsuranceProvider` being updated. */
  patch: InsuranceProviderPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateInsuranceProvider` mutation. */
export type UpdateInsuranceProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `InsuranceProvider` being updated. */
  patch: InsuranceProviderPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `InsuranceProvider` mutation. */
export type UpdateInsuranceProviderPayload = {
  __typename?: 'UpdateInsuranceProviderPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `InsuranceProvider` that was updated by this mutation. */
  insuranceProvider?: Maybe<InsuranceProvider>
  /** An edge for our `InsuranceProvider`. May be used by Relay 1. */
  insuranceProviderEdge?: Maybe<InsuranceProvidersEdge>
}

/** The output of our update `InsuranceProvider` mutation. */
export type UpdateInsuranceProviderPayloadInsuranceProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<InsuranceProvidersOrderBy>>
}

/** All input for the `updateLeadById` mutation. */
export type UpdateLeadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Lead` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch
}

/** All input for the `updateLeadBySlug` mutation. */
export type UpdateLeadBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateLeadByUserId` mutation. */
export type UpdateLeadByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch
  userId: Scalars['UUID']['input']
}

/** All input for the `updateLead` mutation. */
export type UpdateLeadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Lead` being updated. */
  patch: LeadPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Lead` mutation. */
export type UpdateLeadPayload = {
  __typename?: 'UpdateLeadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Lead` that was updated by this mutation. */
  lead?: Maybe<Lead>
  /** An edge for our `Lead`. May be used by Relay 1. */
  leadEdge?: Maybe<LeadsEdge>
  /** Reads a single `ReferralPartner` that is related to this `Lead`. */
  referralPartner?: Maybe<ReferralPartner>
  /** Reads a single `ReferralPartnerSource` that is related to this `Lead`. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** Reads a single `User` that is related to this `Lead`. */
  user?: Maybe<User>
}

/** The output of our update `Lead` mutation. */
export type UpdateLeadPayloadLeadEdgeArgs = {
  orderBy?: InputMaybe<Array<LeadsOrderBy>>
}

/** All input for the `updatePatientByCharmRecordId` mutation. */
export type UpdatePatientByCharmRecordIdInput = {
  charmRecordId: Scalars['String']['input']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Patient` being updated. */
  patch: PatientPatch
}

/** All input for the `updatePatientById` mutation. */
export type UpdatePatientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Patient` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Patient` being updated. */
  patch: PatientPatch
}

/** All input for the `updatePatientBySlug` mutation. */
export type UpdatePatientBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Patient` being updated. */
  patch: PatientPatch
  slug: Scalars['String']['input']
}

/** All input for the `updatePatientByUserId` mutation. */
export type UpdatePatientByUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Patient` being updated. */
  patch: PatientPatch
  userId: Scalars['UUID']['input']
}

/** All input for the `updatePatient` mutation. */
export type UpdatePatientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Patient` being updated. */
  patch: PatientPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Patient` mutation. */
export type UpdatePatientPayload = {
  __typename?: 'UpdatePatientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Patient` that was updated by this mutation. */
  patient?: Maybe<Patient>
  /** An edge for our `Patient`. May be used by Relay 1. */
  patientEdge?: Maybe<PatientsEdge>
  /** Reads a single `User` that is related to this `Patient`. */
  user?: Maybe<User>
}

/** The output of our update `Patient` mutation. */
export type UpdatePatientPayloadPatientEdgeArgs = {
  orderBy?: InputMaybe<Array<PatientsOrderBy>>
}

/** All input for the `updatePolicyById` mutation. */
export type UpdatePolicyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Policy` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Policy` being updated. */
  patch: PolicyPatch
}

/** All input for the `updatePolicyBySlug` mutation. */
export type UpdatePolicyBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Policy` being updated. */
  patch: PolicyPatch
  slug: Scalars['String']['input']
}

/** All input for the `updatePolicy` mutation. */
export type UpdatePolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Policy` being updated. */
  patch: PolicyPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Policy` mutation. */
export type UpdatePolicyPayload = {
  __typename?: 'UpdatePolicyPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Policy` that was updated by this mutation. */
  policy?: Maybe<Policy>
  /** An edge for our `Policy`. May be used by Relay 1. */
  policyEdge?: Maybe<PoliciesEdge>
}

/** The output of our update `Policy` mutation. */
export type UpdatePolicyPayloadPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<PoliciesOrderBy>>
}

/** All input for the `updateReferralPartnerById` mutation. */
export type UpdateReferralPartnerByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ReferralPartner` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `ReferralPartner` being updated. */
  patch: ReferralPartnerPatch
}

/** All input for the `updateReferralPartnerBySlug` mutation. */
export type UpdateReferralPartnerBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `ReferralPartner` being updated. */
  patch: ReferralPartnerPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateReferralPartnerBySlugPublic` mutation. */
export type UpdateReferralPartnerBySlugPublicInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `ReferralPartner` being updated. */
  patch: ReferralPartnerPatch
  slugPublic: Scalars['String']['input']
}

/** All input for the `updateReferralPartner` mutation. */
export type UpdateReferralPartnerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `ReferralPartner` being updated. */
  patch: ReferralPartnerPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `ReferralPartner` mutation. */
export type UpdateReferralPartnerPayload = {
  __typename?: 'UpdateReferralPartnerPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `ReferralPartner` that was updated by this mutation. */
  referralPartner?: Maybe<ReferralPartner>
  /** An edge for our `ReferralPartner`. May be used by Relay 1. */
  referralPartnerEdge?: Maybe<ReferralPartnersEdge>
}

/** The output of our update `ReferralPartner` mutation. */
export type UpdateReferralPartnerPayloadReferralPartnerEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnersOrderBy>>
}

/** All input for the `updateReferralPartnerSourceById` mutation. */
export type UpdateReferralPartnerSourceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ReferralPartnerSource` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `ReferralPartnerSource` being updated. */
  patch: ReferralPartnerSourcePatch
}

/** All input for the `updateReferralPartnerSource` mutation. */
export type UpdateReferralPartnerSourceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `ReferralPartnerSource` being updated. */
  patch: ReferralPartnerSourcePatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `ReferralPartnerSource` mutation. */
export type UpdateReferralPartnerSourcePayload = {
  __typename?: 'UpdateReferralPartnerSourcePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerSource`. */
  referralPartner?: Maybe<ReferralPartner>
  /** The `ReferralPartnerSource` that was updated by this mutation. */
  referralPartnerSource?: Maybe<ReferralPartnerSource>
  /** An edge for our `ReferralPartnerSource`. May be used by Relay 1. */
  referralPartnerSourceEdge?: Maybe<ReferralPartnerSourcesEdge>
}

/** The output of our update `ReferralPartnerSource` mutation. */
export type UpdateReferralPartnerSourcePayloadReferralPartnerSourceEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnerSourcesOrderBy>>
}

/** All input for the `updateReferralPartnerUploadById` mutation. */
export type UpdateReferralPartnerUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `ReferralPartnerUpload` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `ReferralPartnerUpload` being updated. */
  patch: ReferralPartnerUploadPatch
}

/** All input for the `updateReferralPartnerUpload` mutation. */
export type UpdateReferralPartnerUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `ReferralPartnerUpload` being updated. */
  patch: ReferralPartnerUploadPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `ReferralPartnerUpload` mutation. */
export type UpdateReferralPartnerUploadPayload = {
  __typename?: 'UpdateReferralPartnerUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `ReferralPartner` that is related to this `ReferralPartnerUpload`. */
  referralPartner?: Maybe<ReferralPartner>
  /** The `ReferralPartnerUpload` that was updated by this mutation. */
  referralPartnerUpload?: Maybe<ReferralPartnerUpload>
  /** An edge for our `ReferralPartnerUpload`. May be used by Relay 1. */
  referralPartnerUploadEdge?: Maybe<ReferralPartnerUploadsEdge>
  /** Reads a single `Upload` that is related to this `ReferralPartnerUpload`. */
  upload?: Maybe<Upload>
}

/** The output of our update `ReferralPartnerUpload` mutation. */
export type UpdateReferralPartnerUploadPayloadReferralPartnerUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<ReferralPartnerUploadsOrderBy>>
}

/** All input for the `updateServiceById` mutation. */
export type UpdateServiceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Service` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Service` being updated. */
  patch: ServicePatch
}

/** All input for the `updateServiceBySlug` mutation. */
export type UpdateServiceBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Service` being updated. */
  patch: ServicePatch
  slug: Scalars['String']['input']
}

/** All input for the `updateService` mutation. */
export type UpdateServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Service` being updated. */
  patch: ServicePatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Service` mutation. */
export type UpdateServicePayload = {
  __typename?: 'UpdateServicePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Service` that was updated by this mutation. */
  service?: Maybe<Service>
  /** An edge for our `Service`. May be used by Relay 1. */
  serviceEdge?: Maybe<ServicesEdge>
}

/** The output of our update `Service` mutation. */
export type UpdateServicePayloadServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<ServicesOrderBy>>
}

/** All input for the `updateSupportedLanguageById` mutation. */
export type UpdateSupportedLanguageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `SupportedLanguage` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `SupportedLanguage` being updated. */
  patch: SupportedLanguagePatch
}

/** All input for the `updateSupportedLanguage` mutation. */
export type UpdateSupportedLanguageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `SupportedLanguage` being updated. */
  patch: SupportedLanguagePatch
  rowId: Scalars['Int']['input']
}

/** The output of our update `SupportedLanguage` mutation. */
export type UpdateSupportedLanguagePayload = {
  __typename?: 'UpdateSupportedLanguagePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `SupportedLanguage` that was updated by this mutation. */
  supportedLanguage?: Maybe<SupportedLanguage>
  /** An edge for our `SupportedLanguage`. May be used by Relay 1. */
  supportedLanguageEdge?: Maybe<SupportedLanguagesEdge>
}

/** The output of our update `SupportedLanguage` mutation. */
export type UpdateSupportedLanguagePayloadSupportedLanguageEdgeArgs = {
  orderBy?: InputMaybe<Array<SupportedLanguagesOrderBy>>
}

/** All input for the `updateUploadById` mutation. */
export type UpdateUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `Upload` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `Upload` being updated. */
  patch: UploadPatch
}

/** All input for the `updateUploadBySlug` mutation. */
export type UpdateUploadBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Upload` being updated. */
  patch: UploadPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateUpload` mutation. */
export type UpdateUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `Upload` being updated. */
  patch: UploadPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `Upload` mutation. */
export type UpdateUploadPayload = {
  __typename?: 'UpdateUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `Upload` that was updated by this mutation. */
  upload?: Maybe<Upload>
  /** An edge for our `Upload`. May be used by Relay 1. */
  uploadEdge?: Maybe<UploadsEdge>
  /** Reads a single `User` that is related to this `Upload`. */
  uploader?: Maybe<User>
}

/** The output of our update `Upload` mutation. */
export type UpdateUploadPayloadUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UploadsOrderBy>>
}

/** All input for the `updateUserAddressById` mutation. */
export type UpdateUserAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserAddress` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserAddress` being updated. */
  patch: UserAddressPatch
}

/** All input for the `updateUserAddress` mutation. */
export type UpdateUserAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserAddress` being updated. */
  patch: UserAddressPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserAddress` mutation. */
export type UpdateUserAddressPayload = {
  __typename?: 'UpdateUserAddressPayload'
  /** Reads a single `Address` that is related to this `UserAddress`. */
  address?: Maybe<Address>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserAddress`. */
  user?: Maybe<User>
  /** The `UserAddress` that was updated by this mutation. */
  userAddress?: Maybe<UserAddress>
  /** An edge for our `UserAddress`. May be used by Relay 1. */
  userAddressEdge?: Maybe<UserAddressesEdge>
}

/** The output of our update `UserAddress` mutation. */
export type UpdateUserAddressPayloadUserAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserAddressesOrderBy>>
}

/** All input for the `updateUserById` mutation. */
export type UpdateUserByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch
}

/** All input for the `updateUserBySlug` mutation. */
export type UpdateUserBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateUserChildById` mutation. */
export type UpdateUserChildByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserChild` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserChild` being updated. */
  patch: UserChildPatch
}

/** All input for the `updateUserChild` mutation. */
export type UpdateUserChildInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserChild` being updated. */
  patch: UserChildPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserChild` mutation. */
export type UpdateUserChildPayload = {
  __typename?: 'UpdateUserChildPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserChild`. */
  user?: Maybe<User>
  /** The `UserChild` that was updated by this mutation. */
  userChild?: Maybe<UserChild>
  /** An edge for our `UserChild`. May be used by Relay 1. */
  userChildEdge?: Maybe<UserChildrenEdge>
}

/** The output of our update `UserChild` mutation. */
export type UpdateUserChildPayloadUserChildEdgeArgs = {
  orderBy?: InputMaybe<Array<UserChildrenOrderBy>>
}

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch
  rowId: Scalars['UUID']['input']
}

/** All input for the `updateUserInsuranceById` mutation. */
export type UpdateUserInsuranceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserInsurance` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserInsurance` being updated. */
  patch: UserInsurancePatch
}

/** All input for the `updateUserInsurance` mutation. */
export type UpdateUserInsuranceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserInsurance` being updated. */
  patch: UserInsurancePatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserInsurance` mutation. */
export type UpdateUserInsurancePayload = {
  __typename?: 'UpdateUserInsurancePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `InsuranceProvider` that is related to this `UserInsurance`. */
  insuranceProvider?: Maybe<InsuranceProvider>
  /** Reads a single `User` that is related to this `UserInsurance`. */
  user?: Maybe<User>
  /** The `UserInsurance` that was updated by this mutation. */
  userInsurance?: Maybe<UserInsurance>
  /** An edge for our `UserInsurance`. May be used by Relay 1. */
  userInsuranceEdge?: Maybe<UserInsurancesEdge>
}

/** The output of our update `UserInsurance` mutation. */
export type UpdateUserInsurancePayloadUserInsuranceEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInsurancesOrderBy>>
}

/** All input for the `updateUserInsuranceUploadById` mutation. */
export type UpdateUserInsuranceUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserInsuranceUpload` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserInsuranceUpload` being updated. */
  patch: UserInsuranceUploadPatch
}

/** All input for the `updateUserInsuranceUpload` mutation. */
export type UpdateUserInsuranceUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserInsuranceUpload` being updated. */
  patch: UserInsuranceUploadPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserInsuranceUpload` mutation. */
export type UpdateUserInsuranceUploadPayload = {
  __typename?: 'UpdateUserInsuranceUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Upload` that is related to this `UserInsuranceUpload`. */
  upload?: Maybe<Upload>
  /** Reads a single `UserInsurance` that is related to this `UserInsuranceUpload`. */
  userInsurance?: Maybe<UserInsurance>
  /** The `UserInsuranceUpload` that was updated by this mutation. */
  userInsuranceUpload?: Maybe<UserInsuranceUpload>
  /** An edge for our `UserInsuranceUpload`. May be used by Relay 1. */
  userInsuranceUploadEdge?: Maybe<UserInsuranceUploadsEdge>
}

/** The output of our update `UserInsuranceUpload` mutation. */
export type UpdateUserInsuranceUploadPayloadUserInsuranceUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UserInsuranceUploadsOrderBy>>
}

/** All input for the `updateUserLanguageById` mutation. */
export type UpdateUserLanguageByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserLanguage` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserLanguage` being updated. */
  patch: UserLanguagePatch
}

/** All input for the `updateUserLanguage` mutation. */
export type UpdateUserLanguageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserLanguage` being updated. */
  patch: UserLanguagePatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserLanguage` mutation. */
export type UpdateUserLanguagePayload = {
  __typename?: 'UpdateUserLanguagePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserLanguage`. */
  user?: Maybe<User>
  /** The `UserLanguage` that was updated by this mutation. */
  userLanguage?: Maybe<UserLanguage>
  /** An edge for our `UserLanguage`. May be used by Relay 1. */
  userLanguageEdge?: Maybe<UserLanguagesEdge>
}

/** The output of our update `UserLanguage` mutation. */
export type UpdateUserLanguagePayloadUserLanguageEdgeArgs = {
  orderBy?: InputMaybe<Array<UserLanguagesOrderBy>>
}

/** All input for the `updateUserPassword` mutation. */
export type UpdateUserPasswordInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  password: Scalars['String']['input']
  rowId: Scalars['UUID']['input']
}

/** The output of our `updateUserPassword` mutation. */
export type UpdateUserPasswordPayload = {
  __typename?: 'UpdateUserPasswordPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  user?: Maybe<User>
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>
}

/** The output of our `updateUserPassword` mutation. */
export type UpdateUserPasswordPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>
}

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>
}

/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>
}

/** All input for the `updateUserPaymentMethodById` mutation. */
export type UpdateUserPaymentMethodByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPaymentMethod` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserPaymentMethod` being updated. */
  patch: UserPaymentMethodPatch
}

/** All input for the `updateUserPaymentMethodBySlug` mutation. */
export type UpdateUserPaymentMethodBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserPaymentMethod` being updated. */
  patch: UserPaymentMethodPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateUserPaymentMethod` mutation. */
export type UpdateUserPaymentMethodInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserPaymentMethod` being updated. */
  patch: UserPaymentMethodPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserPaymentMethod` mutation. */
export type UpdateUserPaymentMethodPayload = {
  __typename?: 'UpdateUserPaymentMethodPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserPaymentMethod`. */
  user?: Maybe<User>
  /** The `UserPaymentMethod` that was updated by this mutation. */
  userPaymentMethod?: Maybe<UserPaymentMethod>
  /** An edge for our `UserPaymentMethod`. May be used by Relay 1. */
  userPaymentMethodEdge?: Maybe<UserPaymentMethodsEdge>
}

/** The output of our update `UserPaymentMethod` mutation. */
export type UpdateUserPaymentMethodPayloadUserPaymentMethodEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPaymentMethodsOrderBy>>
}

/** All input for the `updateUserPaymentProviderById` mutation. */
export type UpdateUserPaymentProviderByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPaymentProvider` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserPaymentProvider` being updated. */
  patch: UserPaymentProviderPatch
}

/** All input for the `updateUserPaymentProviderBySlug` mutation. */
export type UpdateUserPaymentProviderBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserPaymentProvider` being updated. */
  patch: UserPaymentProviderPatch
  slug: Scalars['String']['input']
}

/** All input for the `updateUserPaymentProvider` mutation. */
export type UpdateUserPaymentProviderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserPaymentProvider` being updated. */
  patch: UserPaymentProviderPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserPaymentProvider` mutation. */
export type UpdateUserPaymentProviderPayload = {
  __typename?: 'UpdateUserPaymentProviderPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserPaymentProvider`. */
  user?: Maybe<User>
  /** The `UserPaymentProvider` that was updated by this mutation. */
  userPaymentProvider?: Maybe<UserPaymentProvider>
  /** An edge for our `UserPaymentProvider`. May be used by Relay 1. */
  userPaymentProviderEdge?: Maybe<UserPaymentProvidersEdge>
}

/** The output of our update `UserPaymentProvider` mutation. */
export type UpdateUserPaymentProviderPayloadUserPaymentProviderEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPaymentProvidersOrderBy>>
}

/** All input for the `updateUserPhoneById` mutation. */
export type UpdateUserPhoneByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPhone` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserPhone` being updated. */
  patch: UserPhonePatch
}

/** All input for the `updateUserPhone` mutation. */
export type UpdateUserPhoneInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserPhone` being updated. */
  patch: UserPhonePatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserPhone` mutation. */
export type UpdateUserPhonePayload = {
  __typename?: 'UpdateUserPhonePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `User` that is related to this `UserPhone`. */
  user?: Maybe<User>
  /** The `UserPhone` that was updated by this mutation. */
  userPhone?: Maybe<UserPhone>
  /** An edge for our `UserPhone`. May be used by Relay 1. */
  userPhoneEdge?: Maybe<UserPhonesEdge>
}

/** The output of our update `UserPhone` mutation. */
export type UpdateUserPhonePayloadUserPhoneEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPhonesOrderBy>>
}

/** All input for the `updateUserPolicyById` mutation. */
export type UpdateUserPolicyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserPolicy` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserPolicy` being updated. */
  patch: UserPolicyPatch
}

/** All input for the `updateUserPolicy` mutation. */
export type UpdateUserPolicyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserPolicy` being updated. */
  patch: UserPolicyPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserPolicy` mutation. */
export type UpdateUserPolicyPayload = {
  __typename?: 'UpdateUserPolicyPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Policy` that is related to this `UserPolicy`. */
  policy?: Maybe<Policy>
  /** Reads a single `User` that is related to this `UserPolicy`. */
  user?: Maybe<User>
  /** The `UserPolicy` that was updated by this mutation. */
  userPolicy?: Maybe<UserPolicy>
  /** An edge for our `UserPolicy`. May be used by Relay 1. */
  userPolicyEdge?: Maybe<UserPoliciesEdge>
}

/** The output of our update `UserPolicy` mutation. */
export type UpdateUserPolicyPayloadUserPolicyEdgeArgs = {
  orderBy?: InputMaybe<Array<UserPoliciesOrderBy>>
}

/** All input for the `updateUserUploadById` mutation. */
export type UpdateUserUploadByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** The globally unique `ID` which will identify a single `UserUpload` to be updated. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `UserUpload` being updated. */
  patch: UserUploadPatch
}

/** All input for the `updateUserUpload` mutation. */
export type UpdateUserUploadInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>
  /** An object where the defined keys will be set on the `UserUpload` being updated. */
  patch: UserUploadPatch
  rowId: Scalars['UUID']['input']
}

/** The output of our update `UserUpload` mutation. */
export type UpdateUserUploadPayload = {
  __typename?: 'UpdateUserUploadPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>
  /** Reads a single `Upload` that is related to this `UserUpload`. */
  upload?: Maybe<Upload>
  /** Reads a single `User` that is related to this `UserUpload`. */
  user?: Maybe<User>
  /** The `UserUpload` that was updated by this mutation. */
  userUpload?: Maybe<UserUpload>
  /** An edge for our `UserUpload`. May be used by Relay 1. */
  userUploadEdge?: Maybe<UserUploadsEdge>
}

/** The output of our update `UserUpload` mutation. */
export type UpdateUserUploadPayloadUserUploadEdgeArgs = {
  orderBy?: InputMaybe<Array<UserUploadsOrderBy>>
}

export type Upload = Node & {
  __typename?: 'Upload'
  bucket: Scalars['String']['output']
  createdAt: Scalars['Datetime']['output']
  filename: Scalars['String']['output']
  filesize: Scalars['Int']['output']
  filetype: Scalars['String']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  /** Reads and enables pagination through a set of `ReferralPartnerUpload`. */
  referralPartnerUploads: ReferralPartnerUploadsConnection
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `Upload`. */
  uploader?: Maybe<User>
  uploaderId?: Maybe<Scalars['UUID']['output']>
  url: Scalars['String']['output']
  /** Reads and enables pagination through a set of `UserInsuranceUpload`. */
  userInsuranceUploads: UserInsuranceUploadsConnection
  /** Reads and enables pagination through a set of `UserUpload`. */
  userUploads: UserUploadsConnection
}

export type UploadReferralPartnerUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<ReferralPartnerUploadCondition>
  filter?: InputMaybe<ReferralPartnerUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<ReferralPartnerUploadsOrderBy>>
}

export type UploadUserInsuranceUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserInsuranceUploadCondition>
  filter?: InputMaybe<UserInsuranceUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserInsuranceUploadsOrderBy>>
}

export type UploadUserUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserUploadCondition>
  filter?: InputMaybe<UserUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserUploadsOrderBy>>
}

/** A condition to be used against `Upload` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UploadCondition = {
  /** Checks for equality with the object’s `bucket` field. */
  bucket?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `filesize` field. */
  filesize?: InputMaybe<Scalars['Int']['input']>
  /** Checks for equality with the object’s `filetype` field. */
  filetype?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `uploaderId` field. */
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `Upload` object types. All fields are combined with a logical ‘and.’ */
export type UploadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UploadFilter>>
  /** Filter by the object’s `bucket` field. */
  bucket?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>
  /** Filter by the object’s `filesize` field. */
  filesize?: InputMaybe<IntFilter>
  /** Filter by the object’s `filetype` field. */
  filetype?: InputMaybe<StringFilter>
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UploadFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UploadFilter>>
  /** Filter by the object’s `referralPartnerUploads` relation. */
  referralPartnerUploads?: InputMaybe<UploadToManyReferralPartnerUploadFilter>
  /** Some related `referralPartnerUploads` exist. */
  referralPartnerUploadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `uploader` relation. */
  uploader?: InputMaybe<UserFilter>
  /** A related `uploader` exists. */
  uploaderExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `uploaderId` field. */
  uploaderId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `userInsuranceUploads` relation. */
  userInsuranceUploads?: InputMaybe<UploadToManyUserInsuranceUploadFilter>
  /** Some related `userInsuranceUploads` exist. */
  userInsuranceUploadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userUploads` relation. */
  userUploads?: InputMaybe<UploadToManyUserUploadFilter>
  /** Some related `userUploads` exist. */
  userUploadsExist?: InputMaybe<Scalars['Boolean']['input']>
}

/** An input for mutations affecting `Upload` */
export type UploadInput = {
  bucket: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  filetype: Scalars['String']['input']
  key: Scalars['String']['input']
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** The globally unique `ID` look up for the row to connect. */
export type UploadNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `upload` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UploadNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `upload` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `referralPartnerUpload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `referralPartnerUpload` being updated. */
  patch: ReferralPartnerUploadPatch
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyUsingUploadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyUsingUploadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UploadOnUploadForUploadsUploaderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnUploadForUploadsUploaderIdFkeyUsingUploadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnUploadForUploadsUploaderIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnUploadForUploadsUploaderIdFkeyUsingUploadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnUploadForUploadsUploaderIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userInsuranceUpload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userInsuranceUpload` being updated. */
  patch: UserInsuranceUploadPatch
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyUsingUploadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyUsingUploadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UploadOnUserUploadForUserUploadsUploadIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userUpload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userUpload` being updated. */
  patch: UserUploadPatch
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnUserUploadForUserUploadsUploadIdFkeyUsingUploadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnUserUploadForUserUploadsUploadIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `upload` to look up the row to update. */
export type UploadOnUserUploadForUserUploadsUploadIdFkeyUsingUploadsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UpdateUploadOnUserUploadForUserUploadsUploadIdFkeyPatch
  slug: Scalars['String']['input']
}

/** Represents an update to a `Upload`. Fields that are set will be updated. */
export type UploadPatch = {
  bucket?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Int']['input']>
  filetype?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** A filter to be used against many `ReferralPartnerUpload` object types. All fields are combined with a logical ‘and.’ */
export type UploadToManyReferralPartnerUploadFilter = {
  /** Every related `ReferralPartnerUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ReferralPartnerUploadFilter>
  /** No related `ReferralPartnerUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ReferralPartnerUploadFilter>
  /** Some related `ReferralPartnerUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ReferralPartnerUploadFilter>
}

/** A filter to be used against many `UserInsuranceUpload` object types. All fields are combined with a logical ‘and.’ */
export type UploadToManyUserInsuranceUploadFilter = {
  /** Every related `UserInsuranceUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserInsuranceUploadFilter>
  /** No related `UserInsuranceUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserInsuranceUploadFilter>
  /** Some related `UserInsuranceUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserInsuranceUploadFilter>
}

/** A filter to be used against many `UserUpload` object types. All fields are combined with a logical ‘and.’ */
export type UploadToManyUserUploadFilter = {
  /** Every related `UserUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserUploadFilter>
  /** No related `UserUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserUploadFilter>
  /** Some related `UserUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserUploadFilter>
}

/** The fields on `upload` to look up the row to connect. */
export type UploadUploadsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `upload` to look up the row to delete. */
export type UploadUploadsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `upload` to look up the row to connect. */
export type UploadUploadsSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `upload` to look up the row to delete. */
export type UploadUploadsSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** A connection to a list of `Upload` values. */
export type UploadsConnection = {
  __typename?: 'UploadsConnection'
  /** A list of edges which contains the `Upload` and cursor to aid in pagination. */
  edges: Array<UploadsEdge>
  /** A list of `Upload` objects. */
  nodes: Array<Upload>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Upload` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `Upload` edge in the connection. */
export type UploadsEdge = {
  __typename?: 'UploadsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `Upload` at the end of the edge. */
  node: Upload
}

/** Methods to use when ordering `Upload`. */
export enum UploadsOrderBy {
  BucketAsc = 'BUCKET_ASC',
  BucketDesc = 'BUCKET_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FilenameAsc = 'FILENAME_ASC',
  FilenameDesc = 'FILENAME_DESC',
  FilesizeAsc = 'FILESIZE_ASC',
  FilesizeDesc = 'FILESIZE_DESC',
  FiletypeAsc = 'FILETYPE_ASC',
  FiletypeDesc = 'FILETYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReferralPartnerUploadsByUploadIdCountAsc = 'REFERRAL_PARTNER_UPLOADS_BY_UPLOAD_ID__COUNT_ASC',
  ReferralPartnerUploadsByUploadIdCountDesc = 'REFERRAL_PARTNER_UPLOADS_BY_UPLOAD_ID__COUNT_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UploaderIdAsc = 'UPLOADER_ID_ASC',
  UploaderIdDesc = 'UPLOADER_ID_DESC',
  UserByUploaderIdBirthdateAtAsc = 'USER_BY_UPLOADER_ID__BIRTHDATE_AT_ASC',
  UserByUploaderIdBirthdateAtDesc = 'USER_BY_UPLOADER_ID__BIRTHDATE_AT_DESC',
  UserByUploaderIdCreatedAtAsc = 'USER_BY_UPLOADER_ID__CREATED_AT_ASC',
  UserByUploaderIdCreatedAtDesc = 'USER_BY_UPLOADER_ID__CREATED_AT_DESC',
  UserByUploaderIdEmailAsc = 'USER_BY_UPLOADER_ID__EMAIL_ASC',
  UserByUploaderIdEmailDesc = 'USER_BY_UPLOADER_ID__EMAIL_DESC',
  UserByUploaderIdFirstNameAsc = 'USER_BY_UPLOADER_ID__FIRST_NAME_ASC',
  UserByUploaderIdFirstNameDesc = 'USER_BY_UPLOADER_ID__FIRST_NAME_DESC',
  UserByUploaderIdGenderAsc = 'USER_BY_UPLOADER_ID__GENDER_ASC',
  UserByUploaderIdGenderDesc = 'USER_BY_UPLOADER_ID__GENDER_DESC',
  UserByUploaderIdIdAsc = 'USER_BY_UPLOADER_ID__ID_ASC',
  UserByUploaderIdIdDesc = 'USER_BY_UPLOADER_ID__ID_DESC',
  UserByUploaderIdIsAdminAsc = 'USER_BY_UPLOADER_ID__IS_ADMIN_ASC',
  UserByUploaderIdIsAdminDesc = 'USER_BY_UPLOADER_ID__IS_ADMIN_DESC',
  UserByUploaderIdLastNameAsc = 'USER_BY_UPLOADER_ID__LAST_NAME_ASC',
  UserByUploaderIdLastNameDesc = 'USER_BY_UPLOADER_ID__LAST_NAME_DESC',
  UserByUploaderIdMiddleNameAsc = 'USER_BY_UPLOADER_ID__MIDDLE_NAME_ASC',
  UserByUploaderIdMiddleNameDesc = 'USER_BY_UPLOADER_ID__MIDDLE_NAME_DESC',
  UserByUploaderIdSlugAsc = 'USER_BY_UPLOADER_ID__SLUG_ASC',
  UserByUploaderIdSlugDesc = 'USER_BY_UPLOADER_ID__SLUG_DESC',
  UserByUploaderIdUpdatedAtAsc = 'USER_BY_UPLOADER_ID__UPDATED_AT_ASC',
  UserByUploaderIdUpdatedAtDesc = 'USER_BY_UPLOADER_ID__UPDATED_AT_DESC',
  UserByUploaderIdVerifiedAtAsc = 'USER_BY_UPLOADER_ID__VERIFIED_AT_ASC',
  UserByUploaderIdVerifiedAtDesc = 'USER_BY_UPLOADER_ID__VERIFIED_AT_DESC',
  UserInsuranceUploadsByUploadIdCountAsc = 'USER_INSURANCE_UPLOADS_BY_UPLOAD_ID__COUNT_ASC',
  UserInsuranceUploadsByUploadIdCountDesc = 'USER_INSURANCE_UPLOADS_BY_UPLOAD_ID__COUNT_DESC',
  UserUploadsByUploadIdCountAsc = 'USER_UPLOADS_BY_UPLOAD_ID__COUNT_ASC',
  UserUploadsByUploadIdCountDesc = 'USER_UPLOADS_BY_UPLOAD_ID__COUNT_DESC'
}

/** Input for the nested mutation of `user` in the `UploadInput` mutation. */
export type UploadsUploaderIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UploadsUploaderIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UploadOnUploadForUploadsUploaderIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUploadForUploadsUploaderIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUploadForUploadsUploaderIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `upload` in the `UserInput` mutation. */
export type UploadsUploaderIdFkeyInverseInput = {
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UploadNodeIdConnect>>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UploadUploadsPkeyConnect>>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectBySlug?: InputMaybe<Array<UploadUploadsSlugKeyConnect>>
  /** A `UploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UploadsUploaderIdFkeyUploadsCreateInput>>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UploadNodeIdDelete>>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UploadUploadsPkeyDelete>>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<Array<UploadUploadsSlugKeyDelete>>
  /** Flag indicating whether all other `upload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUploadForUploadsUploaderIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UploadOnUploadForUploadsUploaderIdFkeyUsingUploadsPkeyUpdate>>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateBySlug?: InputMaybe<Array<UploadOnUploadForUploadsUploaderIdFkeyUsingUploadsSlugKeyUpdate>>
}

/** The `upload` to be created by this mutation. */
export type UploadsUploaderIdFkeyUploadsCreateInput = {
  bucket: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  filetype: Scalars['String']['input']
  key: Scalars['String']['input']
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** The `user` to be created by this mutation. */
export type UploadsUploaderIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type User = Node & {
  __typename?: 'User'
  birthdateAt?: Maybe<Scalars['Date']['output']>
  /** Reads a single `Clinician` that is related to this `User`. */
  clinician?: Maybe<Clinician>
  createdAt: Scalars['Datetime']['output']
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  gender?: Maybe<UserGender>
  hasPassword?: Maybe<Scalars['Boolean']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isAdmin?: Maybe<Scalars['Boolean']['output']>
  lastName: Scalars['String']['output']
  /** Reads a single `Lead` that is related to this `User`. */
  lead?: Maybe<Lead>
  middleName?: Maybe<Scalars['String']['output']>
  /** Reads a single `Patient` that is related to this `User`. */
  patient?: Maybe<Patient>
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  stripeCustomer: Scalars['JSON']['output']
  stripeCustomerId?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads and enables pagination through a set of `Upload`. */
  uploadsByUploaderId: UploadsConnection
  /** Reads and enables pagination through a set of `UserAddress`. */
  userAddresses: UserAddressesConnection
  /** Reads and enables pagination through a set of `UserChild`. */
  userChildren: UserChildrenConnection
  /** Reads and enables pagination through a set of `UserInsurance`. */
  userInsurances: UserInsurancesConnection
  /** Reads and enables pagination through a set of `UserLanguage`. */
  userLanguages: UserLanguagesConnection
  /** Reads and enables pagination through a set of `UserPaymentMethod`. */
  userPaymentMethods: UserPaymentMethodsConnection
  /** Reads and enables pagination through a set of `UserPaymentProvider`. */
  userPaymentProviders: UserPaymentProvidersConnection
  /** Reads and enables pagination through a set of `UserPhone`. */
  userPhones: UserPhonesConnection
  /** Reads and enables pagination through a set of `UserPolicy`. */
  userPolicies: UserPoliciesConnection
  /** Reads and enables pagination through a set of `UserUpload`. */
  userUploads: UserUploadsConnection
  verifiedAt?: Maybe<Scalars['Datetime']['output']>
}

export type UserUploadsByUploaderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UploadCondition>
  filter?: InputMaybe<UploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UploadsOrderBy>>
}

export type UserUserAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserAddressCondition>
  filter?: InputMaybe<UserAddressFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserAddressesOrderBy>>
}

export type UserUserChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserChildCondition>
  filter?: InputMaybe<UserChildFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserChildrenOrderBy>>
}

export type UserUserInsurancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserInsuranceCondition>
  filter?: InputMaybe<UserInsuranceFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserInsurancesOrderBy>>
}

export type UserUserLanguagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserLanguageCondition>
  filter?: InputMaybe<UserLanguageFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserLanguagesOrderBy>>
}

export type UserUserPaymentMethodsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPaymentMethodCondition>
  filter?: InputMaybe<UserPaymentMethodFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPaymentMethodsOrderBy>>
}

export type UserUserPaymentProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPaymentProviderCondition>
  filter?: InputMaybe<UserPaymentProviderFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPaymentProvidersOrderBy>>
}

export type UserUserPhonesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPhoneCondition>
  filter?: InputMaybe<UserPhoneFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPhonesOrderBy>>
}

export type UserUserPoliciesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserPolicyCondition>
  filter?: InputMaybe<UserPolicyFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserPoliciesOrderBy>>
}

export type UserUserUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserUploadCondition>
  filter?: InputMaybe<UserUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserUploadsOrderBy>>
}

export type UserAddress = Node & {
  __typename?: 'UserAddress'
  /** Reads a single `Address` that is related to this `UserAddress`. */
  address?: Maybe<Address>
  addressId: Scalars['UUID']['output']
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isPrimary: Scalars['Boolean']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserAddress`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserAddress` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserAddressCondition = {
  /** Checks for equality with the object’s `addressId` field. */
  addressId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserAddress` object types. All fields are combined with a logical ‘and.’ */
export type UserAddressFilter = {
  /** Filter by the object’s `address` relation. */
  address?: InputMaybe<AddressFilter>
  /** Filter by the object’s `addressId` field. */
  addressId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserAddressFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserAddressFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserAddressFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserAddress` */
export type UserAddressInput = {
  address?: InputMaybe<UserAddressesAddressIdFkeyInput>
  addressId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserAddressesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserAddressNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userAddress` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserAddressNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userAddress` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserAddressOnUserAddressForUserAddressesAddressIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `address` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `address` being updated. */
  patch: AddressPatch
}

/** The fields on `userAddress` to look up the row to update. */
export type UserAddressOnUserAddressForUserAddressesAddressIdFkeyUsingUserAddressesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userAddress` being updated. */
  patch: UpdateUserAddressOnUserAddressForUserAddressesAddressIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserAddressOnUserAddressForUserAddressesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userAddress` to look up the row to update. */
export type UserAddressOnUserAddressForUserAddressesUserIdFkeyUsingUserAddressesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userAddress` being updated. */
  patch: UpdateUserAddressOnUserAddressForUserAddressesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `UserAddress`. Fields that are set will be updated. */
export type UserAddressPatch = {
  address?: InputMaybe<UserAddressesAddressIdFkeyInput>
  addressId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserAddressesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userAddress` to look up the row to connect. */
export type UserAddressUserAddressesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userAddress` to look up the row to delete. */
export type UserAddressUserAddressesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The `address` to be created by this mutation. */
export type UserAddressesAddressIdFkeyAddressesCreateInput = {
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  postalCode: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  stateOrProvince: Scalars['String']['input']
  street1: Scalars['String']['input']
  street2?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userAddresses?: InputMaybe<UserAddressesAddressIdFkeyInverseInput>
}

/** Input for the nested mutation of `address` in the `UserAddressInput` mutation. */
export type UserAddressesAddressIdFkeyInput = {
  /** The primary key(s) for `address` for the far side of the relationship. */
  connectById?: InputMaybe<AddressNodeIdConnect>
  /** The primary key(s) for `address` for the far side of the relationship. */
  connectByRowId?: InputMaybe<AddressAddressesPkeyConnect>
  /** A `AddressInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserAddressesAddressIdFkeyAddressesCreateInput>
  /** The primary key(s) for `address` for the far side of the relationship. */
  deleteById?: InputMaybe<AddressNodeIdDelete>
  /** The primary key(s) for `address` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<AddressAddressesPkeyDelete>
  /** The primary key(s) and patch data for `address` for the far side of the relationship. */
  updateById?: InputMaybe<UserAddressOnUserAddressForUserAddressesAddressIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `address` for the far side of the relationship. */
  updateByRowId?: InputMaybe<AddressOnUserAddressForUserAddressesAddressIdFkeyUsingAddressesPkeyUpdate>
}

/** Input for the nested mutation of `userAddress` in the `AddressInput` mutation. */
export type UserAddressesAddressIdFkeyInverseInput = {
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserAddressNodeIdConnect>>
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserAddressUserAddressesPkeyConnect>>
  /** A `UserAddressInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserAddressesAddressIdFkeyUserAddressesCreateInput>>
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserAddressNodeIdDelete>>
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserAddressUserAddressesPkeyDelete>>
  /** Flag indicating whether all other `userAddress` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userAddress` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AddressOnUserAddressForUserAddressesAddressIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userAddress` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserAddressOnUserAddressForUserAddressesAddressIdFkeyUsingUserAddressesPkeyUpdate>>
}

/** The `userAddress` to be created by this mutation. */
export type UserAddressesAddressIdFkeyUserAddressesCreateInput = {
  address?: InputMaybe<UserAddressesAddressIdFkeyInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserAddressesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A connection to a list of `UserAddress` values. */
export type UserAddressesConnection = {
  __typename?: 'UserAddressesConnection'
  /** A list of edges which contains the `UserAddress` and cursor to aid in pagination. */
  edges: Array<UserAddressesEdge>
  /** A list of `UserAddress` objects. */
  nodes: Array<UserAddress>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserAddress` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserAddress` edge in the connection. */
export type UserAddressesEdge = {
  __typename?: 'UserAddressesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserAddress` at the end of the edge. */
  node: UserAddress
}

/** Methods to use when ordering `UserAddress`. */
export enum UserAddressesOrderBy {
  AddressByAddressIdCityAsc = 'ADDRESS_BY_ADDRESS_ID__CITY_ASC',
  AddressByAddressIdCityDesc = 'ADDRESS_BY_ADDRESS_ID__CITY_DESC',
  AddressByAddressIdCountryAsc = 'ADDRESS_BY_ADDRESS_ID__COUNTRY_ASC',
  AddressByAddressIdCountryDesc = 'ADDRESS_BY_ADDRESS_ID__COUNTRY_DESC',
  AddressByAddressIdCreatedAtAsc = 'ADDRESS_BY_ADDRESS_ID__CREATED_AT_ASC',
  AddressByAddressIdCreatedAtDesc = 'ADDRESS_BY_ADDRESS_ID__CREATED_AT_DESC',
  AddressByAddressIdIdAsc = 'ADDRESS_BY_ADDRESS_ID__ID_ASC',
  AddressByAddressIdIdDesc = 'ADDRESS_BY_ADDRESS_ID__ID_DESC',
  AddressByAddressIdPostalCodeAsc = 'ADDRESS_BY_ADDRESS_ID__POSTAL_CODE_ASC',
  AddressByAddressIdPostalCodeDesc = 'ADDRESS_BY_ADDRESS_ID__POSTAL_CODE_DESC',
  AddressByAddressIdStateOrProvinceAsc = 'ADDRESS_BY_ADDRESS_ID__STATE_OR_PROVINCE_ASC',
  AddressByAddressIdStateOrProvinceDesc = 'ADDRESS_BY_ADDRESS_ID__STATE_OR_PROVINCE_DESC',
  AddressByAddressIdStreet_1Asc = 'ADDRESS_BY_ADDRESS_ID__STREET_1_ASC',
  AddressByAddressIdStreet_1Desc = 'ADDRESS_BY_ADDRESS_ID__STREET_1_DESC',
  AddressByAddressIdStreet_2Asc = 'ADDRESS_BY_ADDRESS_ID__STREET_2_ASC',
  AddressByAddressIdStreet_2Desc = 'ADDRESS_BY_ADDRESS_ID__STREET_2_DESC',
  AddressByAddressIdUpdatedAtAsc = 'ADDRESS_BY_ADDRESS_ID__UPDATED_AT_ASC',
  AddressByAddressIdUpdatedAtDesc = 'ADDRESS_BY_ADDRESS_ID__UPDATED_AT_DESC',
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressIdDesc = 'ADDRESS_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPrimaryAsc = 'IS_PRIMARY_ASC',
  IsPrimaryDesc = 'IS_PRIMARY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `user` in the `UserAddressInput` mutation. */
export type UserAddressesUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserAddressesUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserAddressOnUserAddressForUserAddressesUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserAddressForUserAddressesUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserAddressForUserAddressesUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userAddress` in the `UserInput` mutation. */
export type UserAddressesUserIdFkeyInverseInput = {
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserAddressNodeIdConnect>>
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserAddressUserAddressesPkeyConnect>>
  /** A `UserAddressInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserAddressesUserIdFkeyUserAddressesCreateInput>>
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserAddressNodeIdDelete>>
  /** The primary key(s) for `userAddress` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserAddressUserAddressesPkeyDelete>>
  /** Flag indicating whether all other `userAddress` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userAddress` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserAddressForUserAddressesUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userAddress` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserAddressOnUserAddressForUserAddressesUserIdFkeyUsingUserAddressesPkeyUpdate>>
}

/** The `userAddress` to be created by this mutation. */
export type UserAddressesUserIdFkeyUserAddressesCreateInput = {
  address?: InputMaybe<UserAddressesAddressIdFkeyInput>
  addressId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserAddressesUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserAddressesUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserChild = Node & {
  __typename?: 'UserChild'
  /** Reads and enables pagination through a set of `Appointment`. */
  appointments: AppointmentsConnection
  birthdateAt?: Maybe<Scalars['Date']['output']>
  createdAt: Scalars['Datetime']['output']
  dueAt?: Maybe<Scalars['Date']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserChild`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

export type UserChildAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<AppointmentCondition>
  filter?: InputMaybe<AppointmentFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<AppointmentsOrderBy>>
}

/**
 * A condition to be used against `UserChild` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserChildCondition = {
  /** Checks for equality with the object’s `birthdateAt` field. */
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `dueAt` field. */
  dueAt?: InputMaybe<Scalars['Date']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserChild` object types. All fields are combined with a logical ‘and.’ */
export type UserChildFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserChildFilter>>
  /** Filter by the object’s `appointments` relation. */
  appointments?: InputMaybe<UserChildToManyAppointmentFilter>
  /** Some related `appointments` exist. */
  appointmentsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `birthdateAt` field. */
  birthdateAt?: InputMaybe<DateFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `dueAt` field. */
  dueAt?: InputMaybe<DateFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserChildFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserChildFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserChild` */
export type UserChildInput = {
  appointments?: InputMaybe<AppointmentsUserChildIdFkeyInverseInput>
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  dueAt?: InputMaybe<Scalars['Date']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserChildrenUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserChildNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userChild` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserChildNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userChild` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserChildOnAppointmentForAppointmentsUserChildIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `appointment` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `appointment` being updated. */
  patch: AppointmentPatch
}

/** The fields on `userChild` to look up the row to update. */
export type UserChildOnAppointmentForAppointmentsUserChildIdFkeyUsingUserChildrenPkeyUpdate = {
  /** An object where the defined keys will be set on the `userChild` being updated. */
  patch: UpdateUserChildOnAppointmentForAppointmentsUserChildIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserChildOnUserChildForUserChildrenUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userChild` to look up the row to update. */
export type UserChildOnUserChildForUserChildrenUserIdFkeyUsingUserChildrenPkeyUpdate = {
  /** An object where the defined keys will be set on the `userChild` being updated. */
  patch: UpdateUserChildOnUserChildForUserChildrenUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `UserChild`. Fields that are set will be updated. */
export type UserChildPatch = {
  appointments?: InputMaybe<AppointmentsUserChildIdFkeyInverseInput>
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  dueAt?: InputMaybe<Scalars['Date']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserChildrenUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against many `Appointment` object types. All fields are combined with a logical ‘and.’ */
export type UserChildToManyAppointmentFilter = {
  /** Every related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AppointmentFilter>
  /** No related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AppointmentFilter>
  /** Some related `Appointment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AppointmentFilter>
}

/** The fields on `userChild` to look up the row to connect. */
export type UserChildUserChildrenPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userChild` to look up the row to delete. */
export type UserChildUserChildrenPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `UserChild` values. */
export type UserChildrenConnection = {
  __typename?: 'UserChildrenConnection'
  /** A list of edges which contains the `UserChild` and cursor to aid in pagination. */
  edges: Array<UserChildrenEdge>
  /** A list of `UserChild` objects. */
  nodes: Array<UserChild>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserChild` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserChild` edge in the connection. */
export type UserChildrenEdge = {
  __typename?: 'UserChildrenEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserChild` at the end of the edge. */
  node: UserChild
}

/** Methods to use when ordering `UserChild`. */
export enum UserChildrenOrderBy {
  AppointmentsByUserChildIdCountAsc = 'APPOINTMENTS_BY_USER_CHILD_ID__COUNT_ASC',
  AppointmentsByUserChildIdCountDesc = 'APPOINTMENTS_BY_USER_CHILD_ID__COUNT_DESC',
  BirthdateAtAsc = 'BIRTHDATE_AT_ASC',
  BirthdateAtDesc = 'BIRTHDATE_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DueAtAsc = 'DUE_AT_ASC',
  DueAtDesc = 'DUE_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `user` in the `UserChildInput` mutation. */
export type UserChildrenUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserChildrenUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserChildOnUserChildForUserChildrenUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserChildForUserChildrenUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserChildForUserChildrenUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userChild` in the `UserInput` mutation. */
export type UserChildrenUserIdFkeyInverseInput = {
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserChildNodeIdConnect>>
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserChildUserChildrenPkeyConnect>>
  /** A `UserChildInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserChildrenUserIdFkeyUserChildrenCreateInput>>
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserChildNodeIdDelete>>
  /** The primary key(s) for `userChild` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserChildUserChildrenPkeyDelete>>
  /** Flag indicating whether all other `userChild` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userChild` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserChildForUserChildrenUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userChild` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserChildOnUserChildForUserChildrenUserIdFkeyUsingUserChildrenPkeyUpdate>>
}

/** The `userChild` to be created by this mutation. */
export type UserChildrenUserIdFkeyUserChildrenCreateInput = {
  appointments?: InputMaybe<AppointmentsUserChildIdFkeyInverseInput>
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  dueAt?: InputMaybe<Scalars['Date']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserChildrenUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserChildrenUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `birthdateAt` field. */
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `gender` field. */
  gender?: InputMaybe<UserGender>
  /** Checks for equality with the object’s `isAdmin` field. */
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `middleName` field. */
  middleName?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `verifiedAt` field. */
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>
  /** Filter by the object’s `birthdateAt` field. */
  birthdateAt?: InputMaybe<DateFilter>
  /** Filter by the object’s `clinician` relation. */
  clinician?: InputMaybe<ClinicianFilter>
  /** A related `clinician` exists. */
  clinicianExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>
  /** Filter by the object’s `gender` field. */
  gender?: InputMaybe<UserGenderFilter>
  /** Filter by the object’s `hasPassword` field. */
  hasPassword?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `isAdmin` field. */
  isAdmin?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>
  /** Filter by the object’s `lead` relation. */
  lead?: InputMaybe<LeadFilter>
  /** A related `lead` exists. */
  leadExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `middleName` field. */
  middleName?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>
  /** Filter by the object’s `patient` relation. */
  patient?: InputMaybe<PatientFilter>
  /** A related `patient` exists. */
  patientExists?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `uploadsByUploaderId` relation. */
  uploadsByUploaderId?: InputMaybe<UserToManyUploadFilter>
  /** Some related `uploadsByUploaderId` exist. */
  uploadsByUploaderIdExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userAddresses` relation. */
  userAddresses?: InputMaybe<UserToManyUserAddressFilter>
  /** Some related `userAddresses` exist. */
  userAddressesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userChildren` relation. */
  userChildren?: InputMaybe<UserToManyUserChildFilter>
  /** Some related `userChildren` exist. */
  userChildrenExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userInsurances` relation. */
  userInsurances?: InputMaybe<UserToManyUserInsuranceFilter>
  /** Some related `userInsurances` exist. */
  userInsurancesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userLanguages` relation. */
  userLanguages?: InputMaybe<UserToManyUserLanguageFilter>
  /** Some related `userLanguages` exist. */
  userLanguagesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userPaymentMethods` relation. */
  userPaymentMethods?: InputMaybe<UserToManyUserPaymentMethodFilter>
  /** Some related `userPaymentMethods` exist. */
  userPaymentMethodsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userPaymentProviders` relation. */
  userPaymentProviders?: InputMaybe<UserToManyUserPaymentProviderFilter>
  /** Some related `userPaymentProviders` exist. */
  userPaymentProvidersExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userPhones` relation. */
  userPhones?: InputMaybe<UserToManyUserPhoneFilter>
  /** Some related `userPhones` exist. */
  userPhonesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userPolicies` relation. */
  userPolicies?: InputMaybe<UserToManyUserPolicyFilter>
  /** Some related `userPolicies` exist. */
  userPoliciesExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `userUploads` relation. */
  userUploads?: InputMaybe<UserToManyUserUploadFilter>
  /** Some related `userUploads` exist. */
  userUploadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `verifiedAt` field. */
  verifiedAt?: InputMaybe<DatetimeFilter>
}

export enum UserGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

/** A filter to be used against UserGender fields. All fields are combined with a logical ‘and.’ */
export type UserGenderFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserGender>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserGender>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserGender>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserGender>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserGender>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserGender>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserGender>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserGender>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserGender>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserGender>>
}

/** An input for mutations affecting `User` */
export type UserInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserInsurance = Node & {
  __typename?: 'UserInsurance'
  category: UserInsuranceCategory
  charmId?: Maybe<Scalars['String']['output']>
  comments?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Datetime']['output']
  groupId?: Maybe<Scalars['String']['output']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  /** Reads a single `InsuranceProvider` that is related to this `UserInsurance`. */
  insuranceProvider?: Maybe<InsuranceProvider>
  insuranceProviderId: Scalars['UUID']['output']
  memberId: Scalars['String']['output']
  policyHolderAddressCity?: Maybe<Scalars['String']['output']>
  policyHolderAddressCountry?: Maybe<Scalars['String']['output']>
  policyHolderAddressPostalCode?: Maybe<Scalars['String']['output']>
  policyHolderAddressStateOrProvince?: Maybe<Scalars['String']['output']>
  policyHolderAddressStreet1?: Maybe<Scalars['String']['output']>
  policyHolderAddressStreet2?: Maybe<Scalars['String']['output']>
  policyHolderBirthdateAt?: Maybe<Scalars['Date']['output']>
  policyHolderFirstName?: Maybe<Scalars['String']['output']>
  policyHolderGender?: Maybe<Scalars['String']['output']>
  policyHolderHomePhone?: Maybe<Scalars['String']['output']>
  policyHolderLastName?: Maybe<Scalars['String']['output']>
  policyHolderMobilePhone?: Maybe<Scalars['String']['output']>
  policyHolderRelationship: UserInsurancePolicyHolderRelationship
  policyHolderSsn?: Maybe<Scalars['String']['output']>
  rowId: Scalars['UUID']['output']
  type: UserInsuranceType
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserInsurance`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
  /** Reads and enables pagination through a set of `UserInsuranceUpload`. */
  userInsuranceUploads: UserInsuranceUploadsConnection
  validAt?: Maybe<Scalars['Date']['output']>
}

export type UserInsuranceUserInsuranceUploadsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>
  before?: InputMaybe<Scalars['Cursor']['input']>
  condition?: InputMaybe<UserInsuranceUploadCondition>
  filter?: InputMaybe<UserInsuranceUploadFilter>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  orderBy?: InputMaybe<Array<UserInsuranceUploadsOrderBy>>
}

export enum UserInsuranceCategory {
  Auto = 'AUTO',
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY',
  Workercomp = 'WORKERCOMP'
}

/** A filter to be used against UserInsuranceCategory fields. All fields are combined with a logical ‘and.’ */
export type UserInsuranceCategoryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserInsuranceCategory>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserInsuranceCategory>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserInsuranceCategory>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserInsuranceCategory>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserInsuranceCategory>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserInsuranceCategory>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserInsuranceCategory>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserInsuranceCategory>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserInsuranceCategory>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserInsuranceCategory>>
}

/**
 * A condition to be used against `UserInsurance` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserInsuranceCondition = {
  /** Checks for equality with the object’s `category` field. */
  category?: InputMaybe<UserInsuranceCategory>
  /** Checks for equality with the object’s `charmId` field. */
  charmId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `comments` field. */
  comments?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `insuranceProviderId` field. */
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderAddressCity` field. */
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderAddressCountry` field. */
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderAddressPostalCode` field. */
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderAddressStateOrProvince` field. */
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderAddressStreet1` field. */
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderAddressStreet2` field. */
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderBirthdateAt` field. */
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  /** Checks for equality with the object’s `policyHolderFirstName` field. */
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderGender` field. */
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderHomePhone` field. */
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderLastName` field. */
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderMobilePhone` field. */
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `policyHolderRelationship` field. */
  policyHolderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Checks for equality with the object’s `policyHolderSsn` field. */
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<UserInsuranceType>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `validAt` field. */
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** A filter to be used against `UserInsurance` object types. All fields are combined with a logical ‘and.’ */
export type UserInsuranceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserInsuranceFilter>>
  /** Filter by the object’s `category` field. */
  category?: InputMaybe<UserInsuranceCategoryFilter>
  /** Filter by the object’s `charmId` field. */
  charmId?: InputMaybe<StringFilter>
  /** Filter by the object’s `comments` field. */
  comments?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<StringFilter>
  /** Filter by the object’s `insuranceProvider` relation. */
  insuranceProvider?: InputMaybe<InsuranceProviderFilter>
  /** Filter by the object’s `insuranceProviderId` field. */
  insuranceProviderId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserInsuranceFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserInsuranceFilter>>
  /** Filter by the object’s `policyHolderAddressCity` field. */
  policyHolderAddressCity?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderAddressCountry` field. */
  policyHolderAddressCountry?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderAddressPostalCode` field. */
  policyHolderAddressPostalCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderAddressStateOrProvince` field. */
  policyHolderAddressStateOrProvince?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderAddressStreet1` field. */
  policyHolderAddressStreet1?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderAddressStreet2` field. */
  policyHolderAddressStreet2?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderBirthdateAt` field. */
  policyHolderBirthdateAt?: InputMaybe<DateFilter>
  /** Filter by the object’s `policyHolderFirstName` field. */
  policyHolderFirstName?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderGender` field. */
  policyHolderGender?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderHomePhone` field. */
  policyHolderHomePhone?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderLastName` field. */
  policyHolderLastName?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderMobilePhone` field. */
  policyHolderMobilePhone?: InputMaybe<StringFilter>
  /** Filter by the object’s `policyHolderRelationship` field. */
  policyHolderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationshipFilter>
  /** Filter by the object’s `policyHolderSsn` field. */
  policyHolderSsn?: InputMaybe<StringFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<UserInsuranceTypeFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `userInsuranceUploads` relation. */
  userInsuranceUploads?: InputMaybe<UserInsuranceToManyUserInsuranceUploadFilter>
  /** Some related `userInsuranceUploads` exist. */
  userInsuranceUploadsExist?: InputMaybe<Scalars['Boolean']['input']>
  /** Filter by the object’s `validAt` field. */
  validAt?: InputMaybe<DateFilter>
}

/** An input for mutations affecting `UserInsurance` */
export type UserInsuranceInput = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  memberId: Scalars['String']['input']
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship: UserInsurancePolicyHolderRelationship
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type: UserInsuranceType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserInsuranceNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userInsurance` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserInsuranceNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userInsurance` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserInsuranceOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `insuranceProvider` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `insuranceProvider` being updated. */
  patch: InsuranceProviderPatch
}

/** The fields on `userInsurance` to look up the row to update. */
export type UserInsuranceOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyUsingUserInsurancesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userInsurance` being updated. */
  patch: UpdateUserInsuranceOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserInsuranceOnUserInsuranceForUserInsurancesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userInsurance` to look up the row to update. */
export type UserInsuranceOnUserInsuranceForUserInsurancesUserIdFkeyUsingUserInsurancesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userInsurance` being updated. */
  patch: UpdateUserInsuranceOnUserInsuranceForUserInsurancesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserInsuranceOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userInsuranceUpload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userInsuranceUpload` being updated. */
  patch: UserInsuranceUploadPatch
}

/** The fields on `userInsurance` to look up the row to update. */
export type UserInsuranceOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyUsingUserInsurancesPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `userInsurance` being updated. */
    patch: UpdateUserInsuranceOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** Represents an update to a `UserInsurance`. Fields that are set will be updated. */
export type UserInsurancePatch = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  memberId?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationship>
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type?: InputMaybe<UserInsuranceType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

export enum UserInsurancePolicyHolderRelationship {
  Child = 'CHILD',
  Other = 'OTHER',
  Self = 'SELF',
  Spouse = 'SPOUSE',
  Unknown = 'UNKNOWN'
}

/** A filter to be used against UserInsurancePolicyHolderRelationship fields. All fields are combined with a logical ‘and.’ */
export type UserInsurancePolicyHolderRelationshipFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserInsurancePolicyHolderRelationship>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserInsurancePolicyHolderRelationship>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserInsurancePolicyHolderRelationship>>
}

/** A filter to be used against many `UserInsuranceUpload` object types. All fields are combined with a logical ‘and.’ */
export type UserInsuranceToManyUserInsuranceUploadFilter = {
  /** Every related `UserInsuranceUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserInsuranceUploadFilter>
  /** No related `UserInsuranceUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserInsuranceUploadFilter>
  /** Some related `UserInsuranceUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserInsuranceUploadFilter>
}

export enum UserInsuranceType {
  Champva = 'CHAMPVA',
  FecaBlkLung = 'FECA_BLK_LUNG',
  GroupHealthPlan = 'GROUP_HEALTH_PLAN',
  Medicaid = 'MEDICAID',
  Medicare = 'MEDICARE',
  Other = 'OTHER',
  TricareChampus = 'TRICARE_CHAMPUS'
}

/** A filter to be used against UserInsuranceType fields. All fields are combined with a logical ‘and.’ */
export type UserInsuranceTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserInsuranceType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserInsuranceType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserInsuranceType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserInsuranceType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserInsuranceType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserInsuranceType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserInsuranceType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserInsuranceType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserInsuranceType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserInsuranceType>>
}

export type UserInsuranceUpload = Node & {
  __typename?: 'UserInsuranceUpload'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `Upload` that is related to this `UserInsuranceUpload`. */
  upload?: Maybe<Upload>
  uploadId: Scalars['UUID']['output']
  /** Reads a single `UserInsurance` that is related to this `UserInsuranceUpload`. */
  userInsurance?: Maybe<UserInsurance>
  userInsuranceId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserInsuranceUpload` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserInsuranceUploadCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `uploadId` field. */
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `userInsuranceId` field. */
  userInsuranceId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserInsuranceUpload` object types. All fields are combined with a logical ‘and.’ */
export type UserInsuranceUploadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserInsuranceUploadFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserInsuranceUploadFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserInsuranceUploadFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `upload` relation. */
  upload?: InputMaybe<UploadFilter>
  /** Filter by the object’s `uploadId` field. */
  uploadId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `userInsurance` relation. */
  userInsurance?: InputMaybe<UserInsuranceFilter>
  /** Filter by the object’s `userInsuranceId` field. */
  userInsuranceId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserInsuranceUpload` */
export type UserInsuranceUploadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  userInsurance?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInput>
  userInsuranceId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserInsuranceUploadNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userInsuranceUpload` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserInsuranceUploadNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userInsuranceUpload` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `upload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UploadPatch
}

/** The fields on `userInsuranceUpload` to look up the row to update. */
export type UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyUsingUserInsuranceUploadsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `userInsuranceUpload` being updated. */
    patch: UpdateUserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** The globally unique `ID` look up for the row to update. */
export type UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userInsurance` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userInsurance` being updated. */
  patch: UserInsurancePatch
}

/** The fields on `userInsuranceUpload` to look up the row to update. */
export type UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyUsingUserInsuranceUploadsPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `userInsuranceUpload` being updated. */
    patch: UpdateUserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** Represents an update to a `UserInsuranceUpload`. Fields that are set will be updated. */
export type UserInsuranceUploadPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  userInsurance?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInput>
  userInsuranceId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userInsuranceUpload` to look up the row to connect. */
export type UserInsuranceUploadUserInsuranceUploadsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userInsuranceUpload` to look up the row to delete. */
export type UserInsuranceUploadUserInsuranceUploadsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `UserInsuranceUpload` values. */
export type UserInsuranceUploadsConnection = {
  __typename?: 'UserInsuranceUploadsConnection'
  /** A list of edges which contains the `UserInsuranceUpload` and cursor to aid in pagination. */
  edges: Array<UserInsuranceUploadsEdge>
  /** A list of `UserInsuranceUpload` objects. */
  nodes: Array<UserInsuranceUpload>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserInsuranceUpload` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserInsuranceUpload` edge in the connection. */
export type UserInsuranceUploadsEdge = {
  __typename?: 'UserInsuranceUploadsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserInsuranceUpload` at the end of the edge. */
  node: UserInsuranceUpload
}

/** Methods to use when ordering `UserInsuranceUpload`. */
export enum UserInsuranceUploadsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UploadByUploadIdBucketAsc = 'UPLOAD_BY_UPLOAD_ID__BUCKET_ASC',
  UploadByUploadIdBucketDesc = 'UPLOAD_BY_UPLOAD_ID__BUCKET_DESC',
  UploadByUploadIdCreatedAtAsc = 'UPLOAD_BY_UPLOAD_ID__CREATED_AT_ASC',
  UploadByUploadIdCreatedAtDesc = 'UPLOAD_BY_UPLOAD_ID__CREATED_AT_DESC',
  UploadByUploadIdFilenameAsc = 'UPLOAD_BY_UPLOAD_ID__FILENAME_ASC',
  UploadByUploadIdFilenameDesc = 'UPLOAD_BY_UPLOAD_ID__FILENAME_DESC',
  UploadByUploadIdFilesizeAsc = 'UPLOAD_BY_UPLOAD_ID__FILESIZE_ASC',
  UploadByUploadIdFilesizeDesc = 'UPLOAD_BY_UPLOAD_ID__FILESIZE_DESC',
  UploadByUploadIdFiletypeAsc = 'UPLOAD_BY_UPLOAD_ID__FILETYPE_ASC',
  UploadByUploadIdFiletypeDesc = 'UPLOAD_BY_UPLOAD_ID__FILETYPE_DESC',
  UploadByUploadIdIdAsc = 'UPLOAD_BY_UPLOAD_ID__ID_ASC',
  UploadByUploadIdIdDesc = 'UPLOAD_BY_UPLOAD_ID__ID_DESC',
  UploadByUploadIdKeyAsc = 'UPLOAD_BY_UPLOAD_ID__KEY_ASC',
  UploadByUploadIdKeyDesc = 'UPLOAD_BY_UPLOAD_ID__KEY_DESC',
  UploadByUploadIdSlugAsc = 'UPLOAD_BY_UPLOAD_ID__SLUG_ASC',
  UploadByUploadIdSlugDesc = 'UPLOAD_BY_UPLOAD_ID__SLUG_DESC',
  UploadByUploadIdUpdatedAtAsc = 'UPLOAD_BY_UPLOAD_ID__UPDATED_AT_ASC',
  UploadByUploadIdUpdatedAtDesc = 'UPLOAD_BY_UPLOAD_ID__UPDATED_AT_DESC',
  UploadByUploadIdUploaderIdAsc = 'UPLOAD_BY_UPLOAD_ID__UPLOADER_ID_ASC',
  UploadByUploadIdUploaderIdDesc = 'UPLOAD_BY_UPLOAD_ID__UPLOADER_ID_DESC',
  UploadIdAsc = 'UPLOAD_ID_ASC',
  UploadIdDesc = 'UPLOAD_ID_DESC',
  UserInsuranceByUserInsuranceIdCategoryAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__CATEGORY_ASC',
  UserInsuranceByUserInsuranceIdCategoryDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__CATEGORY_DESC',
  UserInsuranceByUserInsuranceIdCharmIdAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__CHARM_ID_ASC',
  UserInsuranceByUserInsuranceIdCharmIdDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__CHARM_ID_DESC',
  UserInsuranceByUserInsuranceIdCommentsAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__COMMENTS_ASC',
  UserInsuranceByUserInsuranceIdCommentsDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__COMMENTS_DESC',
  UserInsuranceByUserInsuranceIdCreatedAtAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__CREATED_AT_ASC',
  UserInsuranceByUserInsuranceIdCreatedAtDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__CREATED_AT_DESC',
  UserInsuranceByUserInsuranceIdGroupIdAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__GROUP_ID_ASC',
  UserInsuranceByUserInsuranceIdGroupIdDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__GROUP_ID_DESC',
  UserInsuranceByUserInsuranceIdIdAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__ID_ASC',
  UserInsuranceByUserInsuranceIdIdDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__ID_DESC',
  UserInsuranceByUserInsuranceIdInsuranceProviderIdAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__INSURANCE_PROVIDER_ID_ASC',
  UserInsuranceByUserInsuranceIdInsuranceProviderIdDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__INSURANCE_PROVIDER_ID_DESC',
  UserInsuranceByUserInsuranceIdMemberIdAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__MEMBER_ID_ASC',
  UserInsuranceByUserInsuranceIdMemberIdDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__MEMBER_ID_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressCityAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_CITY_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressCityDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_CITY_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressCountryAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_COUNTRY_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressCountryDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_COUNTRY_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressPostalCodeAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_POSTAL_CODE_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressPostalCodeDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_POSTAL_CODE_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressStateOrProvinceAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_STATE_OR_PROVINCE_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressStateOrProvinceDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_STATE_OR_PROVINCE_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressStreet_1Asc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_STREET_1_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressStreet_1Desc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_STREET_1_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressStreet_2Asc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_STREET_2_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderAddressStreet_2Desc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_ADDRESS_STREET_2_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderBirthdateAtAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_BIRTHDATE_AT_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderBirthdateAtDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_BIRTHDATE_AT_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderFirstNameAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_FIRST_NAME_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderFirstNameDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_FIRST_NAME_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderGenderAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_GENDER_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderGenderDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_GENDER_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderHomePhoneAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_HOME_PHONE_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderHomePhoneDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_HOME_PHONE_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderLastNameAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_LAST_NAME_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderLastNameDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_LAST_NAME_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderMobilePhoneAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_MOBILE_PHONE_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderMobilePhoneDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_MOBILE_PHONE_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderRelationshipAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_RELATIONSHIP_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderRelationshipDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_RELATIONSHIP_DESC',
  UserInsuranceByUserInsuranceIdPolicyHolderSsnAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_SSN_ASC',
  UserInsuranceByUserInsuranceIdPolicyHolderSsnDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__POLICY_HOLDER_SSN_DESC',
  UserInsuranceByUserInsuranceIdTypeAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__TYPE_ASC',
  UserInsuranceByUserInsuranceIdTypeDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__TYPE_DESC',
  UserInsuranceByUserInsuranceIdUpdatedAtAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__UPDATED_AT_ASC',
  UserInsuranceByUserInsuranceIdUpdatedAtDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__UPDATED_AT_DESC',
  UserInsuranceByUserInsuranceIdUserIdAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__USER_ID_ASC',
  UserInsuranceByUserInsuranceIdUserIdDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__USER_ID_DESC',
  UserInsuranceByUserInsuranceIdValidAtAsc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__VALID_AT_ASC',
  UserInsuranceByUserInsuranceIdValidAtDesc = 'USER_INSURANCE_BY_USER_INSURANCE_ID__VALID_AT_DESC',
  UserInsuranceIdAsc = 'USER_INSURANCE_ID_ASC',
  UserInsuranceIdDesc = 'USER_INSURANCE_ID_DESC'
}

/** Input for the nested mutation of `upload` in the `UserInsuranceUploadInput` mutation. */
export type UserInsuranceUploadsUploadIdFkeyInput = {
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectById?: InputMaybe<UploadNodeIdConnect>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UploadUploadsPkeyConnect>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UploadUploadsSlugKeyConnect>
  /** A `UploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserInsuranceUploadsUploadIdFkeyUploadsCreateInput>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteById?: InputMaybe<UploadNodeIdDelete>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UploadUploadsPkeyDelete>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UploadUploadsSlugKeyDelete>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateById?: InputMaybe<UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyUsingUploadsPkeyUpdate>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyUsingUploadsSlugKeyUpdate>
}

/** Input for the nested mutation of `userInsuranceUpload` in the `UploadInput` mutation. */
export type UserInsuranceUploadsUploadIdFkeyInverseInput = {
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserInsuranceUploadNodeIdConnect>>
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserInsuranceUploadUserInsuranceUploadsPkeyConnect>>
  /** A `UserInsuranceUploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserInsuranceUploadsUploadIdFkeyUserInsuranceUploadsCreateInput>>
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserInsuranceUploadNodeIdDelete>>
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserInsuranceUploadUserInsuranceUploadsPkeyDelete>>
  /** Flag indicating whether all other `userInsuranceUpload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userInsuranceUpload` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userInsuranceUpload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyUsingUserInsuranceUploadsPkeyUpdate>
  >
}

/** The `upload` to be created by this mutation. */
export type UserInsuranceUploadsUploadIdFkeyUploadsCreateInput = {
  bucket: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  filetype: Scalars['String']['input']
  key: Scalars['String']['input']
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** The `userInsuranceUpload` to be created by this mutation. */
export type UserInsuranceUploadsUploadIdFkeyUserInsuranceUploadsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInput>
  userInsurance?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInput>
  userInsuranceId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `userInsurance` in the `UserInsuranceUploadInput` mutation. */
export type UserInsuranceUploadsUserInsuranceIdFkeyInput = {
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  connectById?: InputMaybe<UserInsuranceNodeIdConnect>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserInsuranceUserInsurancesPkeyConnect>
  /** A `UserInsuranceInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyUserInsurancesCreateInput>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  deleteById?: InputMaybe<UserInsuranceNodeIdDelete>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserInsuranceUserInsurancesPkeyDelete>
  /** The primary key(s) and patch data for `userInsurance` for the far side of the relationship. */
  updateById?: InputMaybe<UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `userInsurance` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserInsuranceOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyUsingUserInsurancesPkeyUpdate>
}

/** Input for the nested mutation of `userInsuranceUpload` in the `UserInsuranceInput` mutation. */
export type UserInsuranceUploadsUserInsuranceIdFkeyInverseInput = {
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserInsuranceUploadNodeIdConnect>>
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserInsuranceUploadUserInsuranceUploadsPkeyConnect>>
  /** A `UserInsuranceUploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserInsuranceUploadsUserInsuranceIdFkeyUserInsuranceUploadsCreateInput>>
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserInsuranceUploadNodeIdDelete>>
  /** The primary key(s) for `userInsuranceUpload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserInsuranceUploadUserInsuranceUploadsPkeyDelete>>
  /** Flag indicating whether all other `userInsuranceUpload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userInsuranceUpload` for the far side of the relationship. */
  updateById?: InputMaybe<
    Array<UserInsuranceOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyNodeIdUpdate>
  >
  /** The primary key(s) and patch data for `userInsuranceUpload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<UserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyUsingUserInsuranceUploadsPkeyUpdate>
  >
}

/** The `userInsuranceUpload` to be created by this mutation. */
export type UserInsuranceUploadsUserInsuranceIdFkeyUserInsuranceUploadsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  userInsurance?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInput>
}

/** The `userInsurance` to be created by this mutation. */
export type UserInsuranceUploadsUserInsuranceIdFkeyUserInsurancesCreateInput = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  memberId: Scalars['String']['input']
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship: UserInsurancePolicyHolderRelationship
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type: UserInsuranceType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** The fields on `userInsurance` to look up the row to connect. */
export type UserInsuranceUserInsurancesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userInsurance` to look up the row to delete. */
export type UserInsuranceUserInsurancesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `UserInsurance` values. */
export type UserInsurancesConnection = {
  __typename?: 'UserInsurancesConnection'
  /** A list of edges which contains the `UserInsurance` and cursor to aid in pagination. */
  edges: Array<UserInsurancesEdge>
  /** A list of `UserInsurance` objects. */
  nodes: Array<UserInsurance>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserInsurance` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserInsurance` edge in the connection. */
export type UserInsurancesEdge = {
  __typename?: 'UserInsurancesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserInsurance` at the end of the edge. */
  node: UserInsurance
}

/** Input for the nested mutation of `insuranceProvider` in the `UserInsuranceInput` mutation. */
export type UserInsurancesInsuranceProviderIdFkeyInput = {
  /** The primary key(s) for `insuranceProvider` for the far side of the relationship. */
  connectById?: InputMaybe<InsuranceProviderNodeIdConnect>
  /** The primary key(s) for `insuranceProvider` for the far side of the relationship. */
  connectByRowId?: InputMaybe<InsuranceProviderInsuranceProvidersPkeyConnect>
  /** The primary key(s) for `insuranceProvider` for the far side of the relationship. */
  connectBySlug?: InputMaybe<InsuranceProviderInsuranceProvidersSlugKeyConnect>
  /** A `InsuranceProviderInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInsuranceProvidersCreateInput>
  /** The primary key(s) for `insuranceProvider` for the far side of the relationship. */
  deleteById?: InputMaybe<InsuranceProviderNodeIdDelete>
  /** The primary key(s) for `insuranceProvider` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<InsuranceProviderInsuranceProvidersPkeyDelete>
  /** The primary key(s) for `insuranceProvider` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<InsuranceProviderInsuranceProvidersSlugKeyDelete>
  /** The primary key(s) and patch data for `insuranceProvider` for the far side of the relationship. */
  updateById?: InputMaybe<UserInsuranceOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `insuranceProvider` for the far side of the relationship. */
  updateByRowId?: InputMaybe<InsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyUsingInsuranceProvidersPkeyUpdate>
  /** The primary key(s) and patch data for `insuranceProvider` for the far side of the relationship. */
  updateBySlug?: InputMaybe<InsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyUsingInsuranceProvidersSlugKeyUpdate>
}

/** The `insuranceProvider` to be created by this mutation. */
export type UserInsurancesInsuranceProviderIdFkeyInsuranceProvidersCreateInput = {
  charmId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  payerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userInsurances?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInverseInput>
}

/** Input for the nested mutation of `userInsurance` in the `InsuranceProviderInput` mutation. */
export type UserInsurancesInsuranceProviderIdFkeyInverseInput = {
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserInsuranceNodeIdConnect>>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserInsuranceUserInsurancesPkeyConnect>>
  /** A `UserInsuranceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserInsurancesInsuranceProviderIdFkeyUserInsurancesCreateInput>>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserInsuranceNodeIdDelete>>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserInsuranceUserInsurancesPkeyDelete>>
  /** Flag indicating whether all other `userInsurance` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userInsurance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<InsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userInsurance` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<UserInsuranceOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyUsingUserInsurancesPkeyUpdate>
  >
}

/** The `userInsurance` to be created by this mutation. */
export type UserInsurancesInsuranceProviderIdFkeyUserInsurancesCreateInput = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  memberId: Scalars['String']['input']
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship: UserInsurancePolicyHolderRelationship
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type: UserInsuranceType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** Methods to use when ordering `UserInsurance`. */
export enum UserInsurancesOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CharmIdAsc = 'CHARM_ID_ASC',
  CharmIdDesc = 'CHARM_ID_DESC',
  CommentsAsc = 'COMMENTS_ASC',
  CommentsDesc = 'COMMENTS_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InsuranceProviderByInsuranceProviderIdCharmIdAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__CHARM_ID_ASC',
  InsuranceProviderByInsuranceProviderIdCharmIdDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__CHARM_ID_DESC',
  InsuranceProviderByInsuranceProviderIdCreatedAtAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__CREATED_AT_ASC',
  InsuranceProviderByInsuranceProviderIdCreatedAtDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__CREATED_AT_DESC',
  InsuranceProviderByInsuranceProviderIdIdAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__ID_ASC',
  InsuranceProviderByInsuranceProviderIdIdDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__ID_DESC',
  InsuranceProviderByInsuranceProviderIdNameAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__NAME_ASC',
  InsuranceProviderByInsuranceProviderIdNameDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__NAME_DESC',
  InsuranceProviderByInsuranceProviderIdPayerIdAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__PAYER_ID_ASC',
  InsuranceProviderByInsuranceProviderIdPayerIdDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__PAYER_ID_DESC',
  InsuranceProviderByInsuranceProviderIdSlugAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__SLUG_ASC',
  InsuranceProviderByInsuranceProviderIdSlugDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__SLUG_DESC',
  InsuranceProviderByInsuranceProviderIdUpdatedAtAsc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__UPDATED_AT_ASC',
  InsuranceProviderByInsuranceProviderIdUpdatedAtDesc = 'INSURANCE_PROVIDER_BY_INSURANCE_PROVIDER_ID__UPDATED_AT_DESC',
  InsuranceProviderIdAsc = 'INSURANCE_PROVIDER_ID_ASC',
  InsuranceProviderIdDesc = 'INSURANCE_PROVIDER_ID_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PolicyHolderAddressCityAsc = 'POLICY_HOLDER_ADDRESS_CITY_ASC',
  PolicyHolderAddressCityDesc = 'POLICY_HOLDER_ADDRESS_CITY_DESC',
  PolicyHolderAddressCountryAsc = 'POLICY_HOLDER_ADDRESS_COUNTRY_ASC',
  PolicyHolderAddressCountryDesc = 'POLICY_HOLDER_ADDRESS_COUNTRY_DESC',
  PolicyHolderAddressPostalCodeAsc = 'POLICY_HOLDER_ADDRESS_POSTAL_CODE_ASC',
  PolicyHolderAddressPostalCodeDesc = 'POLICY_HOLDER_ADDRESS_POSTAL_CODE_DESC',
  PolicyHolderAddressStateOrProvinceAsc = 'POLICY_HOLDER_ADDRESS_STATE_OR_PROVINCE_ASC',
  PolicyHolderAddressStateOrProvinceDesc = 'POLICY_HOLDER_ADDRESS_STATE_OR_PROVINCE_DESC',
  PolicyHolderAddressStreet_1Asc = 'POLICY_HOLDER_ADDRESS_STREET_1_ASC',
  PolicyHolderAddressStreet_1Desc = 'POLICY_HOLDER_ADDRESS_STREET_1_DESC',
  PolicyHolderAddressStreet_2Asc = 'POLICY_HOLDER_ADDRESS_STREET_2_ASC',
  PolicyHolderAddressStreet_2Desc = 'POLICY_HOLDER_ADDRESS_STREET_2_DESC',
  PolicyHolderBirthdateAtAsc = 'POLICY_HOLDER_BIRTHDATE_AT_ASC',
  PolicyHolderBirthdateAtDesc = 'POLICY_HOLDER_BIRTHDATE_AT_DESC',
  PolicyHolderFirstNameAsc = 'POLICY_HOLDER_FIRST_NAME_ASC',
  PolicyHolderFirstNameDesc = 'POLICY_HOLDER_FIRST_NAME_DESC',
  PolicyHolderGenderAsc = 'POLICY_HOLDER_GENDER_ASC',
  PolicyHolderGenderDesc = 'POLICY_HOLDER_GENDER_DESC',
  PolicyHolderHomePhoneAsc = 'POLICY_HOLDER_HOME_PHONE_ASC',
  PolicyHolderHomePhoneDesc = 'POLICY_HOLDER_HOME_PHONE_DESC',
  PolicyHolderLastNameAsc = 'POLICY_HOLDER_LAST_NAME_ASC',
  PolicyHolderLastNameDesc = 'POLICY_HOLDER_LAST_NAME_DESC',
  PolicyHolderMobilePhoneAsc = 'POLICY_HOLDER_MOBILE_PHONE_ASC',
  PolicyHolderMobilePhoneDesc = 'POLICY_HOLDER_MOBILE_PHONE_DESC',
  PolicyHolderRelationshipAsc = 'POLICY_HOLDER_RELATIONSHIP_ASC',
  PolicyHolderRelationshipDesc = 'POLICY_HOLDER_RELATIONSHIP_DESC',
  PolicyHolderSsnAsc = 'POLICY_HOLDER_SSN_ASC',
  PolicyHolderSsnDesc = 'POLICY_HOLDER_SSN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  UserInsuranceUploadsByUserInsuranceIdCountAsc = 'USER_INSURANCE_UPLOADS_BY_USER_INSURANCE_ID__COUNT_ASC',
  UserInsuranceUploadsByUserInsuranceIdCountDesc = 'USER_INSURANCE_UPLOADS_BY_USER_INSURANCE_ID__COUNT_DESC',
  ValidAtAsc = 'VALID_AT_ASC',
  ValidAtDesc = 'VALID_AT_DESC'
}

/** Input for the nested mutation of `user` in the `UserInsuranceInput` mutation. */
export type UserInsurancesUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserInsurancesUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserInsuranceOnUserInsuranceForUserInsurancesUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserInsuranceForUserInsurancesUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserInsuranceForUserInsurancesUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userInsurance` in the `UserInput` mutation. */
export type UserInsurancesUserIdFkeyInverseInput = {
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserInsuranceNodeIdConnect>>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserInsuranceUserInsurancesPkeyConnect>>
  /** A `UserInsuranceInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserInsurancesUserIdFkeyUserInsurancesCreateInput>>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserInsuranceNodeIdDelete>>
  /** The primary key(s) for `userInsurance` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserInsuranceUserInsurancesPkeyDelete>>
  /** Flag indicating whether all other `userInsurance` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userInsurance` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserInsuranceForUserInsurancesUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userInsurance` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<UserInsuranceOnUserInsuranceForUserInsurancesUserIdFkeyUsingUserInsurancesPkeyUpdate>
  >
}

/** The `userInsurance` to be created by this mutation. */
export type UserInsurancesUserIdFkeyUserInsurancesCreateInput = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  memberId: Scalars['String']['input']
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship: UserInsurancePolicyHolderRelationship
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type: UserInsuranceType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** The `user` to be created by this mutation. */
export type UserInsurancesUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserLanguage = Node & {
  __typename?: 'UserLanguage'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isPrimary: Scalars['Boolean']['output']
  language: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserLanguage`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserLanguage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserLanguageCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `language` field. */
  language?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserLanguage` object types. All fields are combined with a logical ‘and.’ */
export type UserLanguageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserLanguageFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `language` field. */
  language?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserLanguageFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserLanguageFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserLanguage` */
export type UserLanguageInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  language: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserLanguagesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserLanguageNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userLanguage` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserLanguageNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userLanguage` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserLanguageOnUserLanguageForUserLanguagesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userLanguage` to look up the row to update. */
export type UserLanguageOnUserLanguageForUserLanguagesUserIdFkeyUsingUserLanguagesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userLanguage` being updated. */
  patch: UpdateUserLanguageOnUserLanguageForUserLanguagesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `UserLanguage`. Fields that are set will be updated. */
export type UserLanguagePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserLanguagesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userLanguage` to look up the row to connect. */
export type UserLanguageUserLanguagesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userLanguage` to look up the row to delete. */
export type UserLanguageUserLanguagesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `UserLanguage` values. */
export type UserLanguagesConnection = {
  __typename?: 'UserLanguagesConnection'
  /** A list of edges which contains the `UserLanguage` and cursor to aid in pagination. */
  edges: Array<UserLanguagesEdge>
  /** A list of `UserLanguage` objects. */
  nodes: Array<UserLanguage>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserLanguage` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserLanguage` edge in the connection. */
export type UserLanguagesEdge = {
  __typename?: 'UserLanguagesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserLanguage` at the end of the edge. */
  node: UserLanguage
}

/** Methods to use when ordering `UserLanguage`. */
export enum UserLanguagesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPrimaryAsc = 'IS_PRIMARY_ASC',
  IsPrimaryDesc = 'IS_PRIMARY_DESC',
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `user` in the `UserLanguageInput` mutation. */
export type UserLanguagesUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserLanguagesUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserLanguageOnUserLanguageForUserLanguagesUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserLanguageForUserLanguagesUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserLanguageForUserLanguagesUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userLanguage` in the `UserInput` mutation. */
export type UserLanguagesUserIdFkeyInverseInput = {
  /** The primary key(s) for `userLanguage` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserLanguageNodeIdConnect>>
  /** The primary key(s) for `userLanguage` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserLanguageUserLanguagesPkeyConnect>>
  /** A `UserLanguageInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserLanguagesUserIdFkeyUserLanguagesCreateInput>>
  /** The primary key(s) for `userLanguage` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserLanguageNodeIdDelete>>
  /** The primary key(s) for `userLanguage` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserLanguageUserLanguagesPkeyDelete>>
  /** Flag indicating whether all other `userLanguage` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userLanguage` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserLanguageForUserLanguagesUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userLanguage` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserLanguageOnUserLanguageForUserLanguagesUserIdFkeyUsingUserLanguagesPkeyUpdate>>
}

/** The `userLanguage` to be created by this mutation. */
export type UserLanguagesUserIdFkeyUserLanguagesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  language: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserLanguagesUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserLanguagesUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `user` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnClinicianForCliniciansUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `clinician` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `clinician` being updated. */
  patch: ClinicianPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnClinicianForCliniciansUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnClinicianForCliniciansUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnClinicianForCliniciansUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnClinicianForCliniciansUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnLeadForLeadsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `lead` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `lead` being updated. */
  patch: LeadPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnLeadForLeadsUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnLeadForLeadsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnLeadForLeadsUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnLeadForLeadsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnPatientForPatientsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `patient` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `patient` being updated. */
  patch: PatientPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnPatientForPatientsUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPatientForPatientsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnPatientForPatientsUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPatientForPatientsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUploadForUploadsUploaderIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `upload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UploadPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUploadForUploadsUploaderIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUploadForUploadsUploaderIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUploadForUploadsUploaderIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUploadForUploadsUploaderIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserAddressForUserAddressesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userAddress` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userAddress` being updated. */
  patch: UserAddressPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserAddressForUserAddressesUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserAddressForUserAddressesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserAddressForUserAddressesUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserAddressForUserAddressesUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserChildForUserChildrenUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userChild` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userChild` being updated. */
  patch: UserChildPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserChildForUserChildrenUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserChildForUserChildrenUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserChildForUserChildrenUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserChildForUserChildrenUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserInsuranceForUserInsurancesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userInsurance` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userInsurance` being updated. */
  patch: UserInsurancePatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserInsuranceForUserInsurancesUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserInsuranceForUserInsurancesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserInsuranceForUserInsurancesUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserInsuranceForUserInsurancesUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserLanguageForUserLanguagesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userLanguage` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userLanguage` being updated. */
  patch: UserLanguagePatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserLanguageForUserLanguagesUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserLanguageForUserLanguagesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserLanguageForUserLanguagesUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserLanguageForUserLanguagesUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userPaymentMethod` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userPaymentMethod` being updated. */
  patch: UserPaymentMethodPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userPaymentProvider` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userPaymentProvider` being updated. */
  patch: UserPaymentProviderPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserPhoneForUserPhonesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userPhone` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userPhone` being updated. */
  patch: UserPhonePatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPhoneForUserPhonesUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPhoneForUserPhonesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPhoneForUserPhonesUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPhoneForUserPhonesUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserPolicyForUserPoliciesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userPolicy` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userPolicy` being updated. */
  patch: UserPolicyPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPolicyForUserPoliciesUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPolicyForUserPoliciesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserPolicyForUserPoliciesUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserPolicyForUserPoliciesUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserUploadForUserUploadsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userUpload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `userUpload` being updated. */
  patch: UserUploadPatch
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserUploadForUserUploadsUserIdFkeyUsingUsersPkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserUploadForUserUploadsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to update. */
export type UserOnUserUploadForUserUploadsUserIdFkeyUsingUsersSlugUkeyUpdate = {
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserUploadForUserUploadsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserPaymentMethod = Node & {
  __typename?: 'UserPaymentMethod'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  isPrimary: Scalars['Boolean']['output']
  methodData: Scalars['JSON']['output']
  methodId: Scalars['String']['output']
  provider: PaymentProviders
  providerId: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserPaymentMethod`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserPaymentMethod` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserPaymentMethodCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `methodId` field. */
  methodId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<PaymentProviders>
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserPaymentMethod` object types. All fields are combined with a logical ‘and.’ */
export type UserPaymentMethodFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPaymentMethodFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `methodId` field. */
  methodId?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserPaymentMethodFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPaymentMethodFilter>>
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<PaymentProvidersFilter>
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserPaymentMethod` */
export type UserPaymentMethodInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  methodId: Scalars['String']['input']
  provider: PaymentProviders
  providerId: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentMethodsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserPaymentMethodNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userPaymentMethod` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserPaymentMethodNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userPaymentMethod` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userPaymentMethod` to look up the row to update. */
export type UserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUserPaymentMethodsPkeyUpdate = {
  /** An object where the defined keys will be set on the `userPaymentMethod` being updated. */
  patch: UpdateUserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPaymentMethod` to look up the row to update. */
export type UserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUserPaymentMethodsSlugKeyUpdate = {
  /** An object where the defined keys will be set on the `userPaymentMethod` being updated. */
  patch: UpdateUserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyPatch
  slug: Scalars['String']['input']
}

/** Represents an update to a `UserPaymentMethod`. Fields that are set will be updated. */
export type UserPaymentMethodPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  methodId?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<PaymentProviders>
  providerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentMethodsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userPaymentMethod` to look up the row to connect. */
export type UserPaymentMethodUserPaymentMethodsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPaymentMethod` to look up the row to delete. */
export type UserPaymentMethodUserPaymentMethodsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPaymentMethod` to look up the row to connect. */
export type UserPaymentMethodUserPaymentMethodsSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `userPaymentMethod` to look up the row to delete. */
export type UserPaymentMethodUserPaymentMethodsSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** A connection to a list of `UserPaymentMethod` values. */
export type UserPaymentMethodsConnection = {
  __typename?: 'UserPaymentMethodsConnection'
  /** A list of edges which contains the `UserPaymentMethod` and cursor to aid in pagination. */
  edges: Array<UserPaymentMethodsEdge>
  /** A list of `UserPaymentMethod` objects. */
  nodes: Array<UserPaymentMethod>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserPaymentMethod` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserPaymentMethod` edge in the connection. */
export type UserPaymentMethodsEdge = {
  __typename?: 'UserPaymentMethodsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserPaymentMethod` at the end of the edge. */
  node: UserPaymentMethod
}

/** Methods to use when ordering `UserPaymentMethod`. */
export enum UserPaymentMethodsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  IsPrimaryAsc = 'IS_PRIMARY_ASC',
  IsPrimaryDesc = 'IS_PRIMARY_DESC',
  MethodIdAsc = 'METHOD_ID_ASC',
  MethodIdDesc = 'METHOD_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `user` in the `UserPaymentMethodInput` mutation. */
export type UserPaymentMethodsUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPaymentMethodsUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userPaymentMethod` in the `UserInput` mutation. */
export type UserPaymentMethodsUserIdFkeyInverseInput = {
  /** The primary key(s) for `userPaymentMethod` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserPaymentMethodNodeIdConnect>>
  /** The primary key(s) for `userPaymentMethod` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserPaymentMethodUserPaymentMethodsPkeyConnect>>
  /** The primary key(s) for `userPaymentMethod` for the far side of the relationship. */
  connectBySlug?: InputMaybe<Array<UserPaymentMethodUserPaymentMethodsSlugKeyConnect>>
  /** A `UserPaymentMethodInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserPaymentMethodsUserIdFkeyUserPaymentMethodsCreateInput>>
  /** The primary key(s) for `userPaymentMethod` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserPaymentMethodNodeIdDelete>>
  /** The primary key(s) for `userPaymentMethod` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserPaymentMethodUserPaymentMethodsPkeyDelete>>
  /** The primary key(s) for `userPaymentMethod` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<Array<UserPaymentMethodUserPaymentMethodsSlugKeyDelete>>
  /** Flag indicating whether all other `userPaymentMethod` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userPaymentMethod` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userPaymentMethod` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<UserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUserPaymentMethodsPkeyUpdate>
  >
  /** The primary key(s) and patch data for `userPaymentMethod` for the far side of the relationship. */
  updateBySlug?: InputMaybe<
    Array<UserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyUsingUserPaymentMethodsSlugKeyUpdate>
  >
}

/** The `userPaymentMethod` to be created by this mutation. */
export type UserPaymentMethodsUserIdFkeyUserPaymentMethodsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  methodId: Scalars['String']['input']
  provider: PaymentProviders
  providerId: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentMethodsUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserPaymentMethodsUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserPaymentProvider = Node & {
  __typename?: 'UserPaymentProvider'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  isPrimary: Scalars['Boolean']['output']
  provider: PaymentProviders
  providerData: Scalars['JSON']['output']
  providerId: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  slug?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserPaymentProvider`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserPaymentProvider` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type UserPaymentProviderCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `isActive` field. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<PaymentProviders>
  /** Checks for equality with the object’s `providerId` field. */
  providerId?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserPaymentProvider` object types. All fields are combined with a logical ‘and.’ */
export type UserPaymentProviderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPaymentProviderFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `isActive` field. */
  isActive?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserPaymentProviderFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPaymentProviderFilter>>
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<PaymentProvidersFilter>
  /** Filter by the object’s `providerId` field. */
  providerId?: InputMaybe<StringFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserPaymentProvider` */
export type UserPaymentProviderInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  provider: PaymentProviders
  providerId: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentProvidersUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserPaymentProviderNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userPaymentProvider` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserPaymentProviderNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userPaymentProvider` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userPaymentProvider` to look up the row to update. */
export type UserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUserPaymentProvidersPkeyUpdate =
  {
    /** An object where the defined keys will be set on the `userPaymentProvider` being updated. */
    patch: UpdateUserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyPatch
    rowId: Scalars['UUID']['input']
  }

/** The fields on `userPaymentProvider` to look up the row to update. */
export type UserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUserPaymentProvidersSlugKeyUpdate =
  {
    /** An object where the defined keys will be set on the `userPaymentProvider` being updated. */
    patch: UpdateUserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyPatch
    slug: Scalars['String']['input']
  }

/** Represents an update to a `UserPaymentProvider`. Fields that are set will be updated. */
export type UserPaymentProviderPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  provider?: InputMaybe<PaymentProviders>
  providerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentProvidersUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userPaymentProvider` to look up the row to connect. */
export type UserPaymentProviderUserPaymentProvidersPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPaymentProvider` to look up the row to delete. */
export type UserPaymentProviderUserPaymentProvidersPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPaymentProvider` to look up the row to connect. */
export type UserPaymentProviderUserPaymentProvidersSlugKeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `userPaymentProvider` to look up the row to delete. */
export type UserPaymentProviderUserPaymentProvidersSlugKeyDelete = {
  slug: Scalars['String']['input']
}

/** A connection to a list of `UserPaymentProvider` values. */
export type UserPaymentProvidersConnection = {
  __typename?: 'UserPaymentProvidersConnection'
  /** A list of edges which contains the `UserPaymentProvider` and cursor to aid in pagination. */
  edges: Array<UserPaymentProvidersEdge>
  /** A list of `UserPaymentProvider` objects. */
  nodes: Array<UserPaymentProvider>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserPaymentProvider` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserPaymentProvider` edge in the connection. */
export type UserPaymentProvidersEdge = {
  __typename?: 'UserPaymentProvidersEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserPaymentProvider` at the end of the edge. */
  node: UserPaymentProvider
}

/** Methods to use when ordering `UserPaymentProvider`. */
export enum UserPaymentProvidersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsActiveAsc = 'IS_ACTIVE_ASC',
  IsActiveDesc = 'IS_ACTIVE_DESC',
  IsPrimaryAsc = 'IS_PRIMARY_ASC',
  IsPrimaryDesc = 'IS_PRIMARY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `user` in the `UserPaymentProviderInput` mutation. */
export type UserPaymentProvidersUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPaymentProvidersUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userPaymentProvider` in the `UserInput` mutation. */
export type UserPaymentProvidersUserIdFkeyInverseInput = {
  /** The primary key(s) for `userPaymentProvider` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserPaymentProviderNodeIdConnect>>
  /** The primary key(s) for `userPaymentProvider` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserPaymentProviderUserPaymentProvidersPkeyConnect>>
  /** The primary key(s) for `userPaymentProvider` for the far side of the relationship. */
  connectBySlug?: InputMaybe<Array<UserPaymentProviderUserPaymentProvidersSlugKeyConnect>>
  /** A `UserPaymentProviderInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserPaymentProvidersUserIdFkeyUserPaymentProvidersCreateInput>>
  /** The primary key(s) for `userPaymentProvider` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserPaymentProviderNodeIdDelete>>
  /** The primary key(s) for `userPaymentProvider` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserPaymentProviderUserPaymentProvidersPkeyDelete>>
  /** The primary key(s) for `userPaymentProvider` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<Array<UserPaymentProviderUserPaymentProvidersSlugKeyDelete>>
  /** Flag indicating whether all other `userPaymentProvider` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userPaymentProvider` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userPaymentProvider` for the far side of the relationship. */
  updateByRowId?: InputMaybe<
    Array<UserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUserPaymentProvidersPkeyUpdate>
  >
  /** The primary key(s) and patch data for `userPaymentProvider` for the far side of the relationship. */
  updateBySlug?: InputMaybe<
    Array<UserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyUsingUserPaymentProvidersSlugKeyUpdate>
  >
}

/** The `userPaymentProvider` to be created by this mutation. */
export type UserPaymentProvidersUserIdFkeyUserPaymentProvidersCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  provider: PaymentProviders
  providerId: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentProvidersUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserPaymentProvidersUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserPhone = Node & {
  __typename?: 'UserPhone'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  isPrimary: Scalars['Boolean']['output']
  phone: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  type: UserPhonesType
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserPhone`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserPhone` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserPhoneCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<UserPhonesType>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserPhone` object types. All fields are combined with a logical ‘and.’ */
export type UserPhoneFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPhoneFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserPhoneFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPhoneFilter>>
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<UserPhonesTypeFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserPhone` */
export type UserPhoneInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  phone: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type: UserPhonesType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPhonesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserPhoneNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userPhone` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserPhoneNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userPhone` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserPhoneOnUserPhoneForUserPhonesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userPhone` to look up the row to update. */
export type UserPhoneOnUserPhoneForUserPhonesUserIdFkeyUsingUserPhonesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userPhone` being updated. */
  patch: UpdateUserPhoneOnUserPhoneForUserPhonesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `UserPhone`. Fields that are set will be updated. */
export type UserPhonePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type?: InputMaybe<UserPhonesType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPhonesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userPhone` to look up the row to connect. */
export type UserPhoneUserPhonesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPhone` to look up the row to delete. */
export type UserPhoneUserPhonesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `UserPhone` values. */
export type UserPhonesConnection = {
  __typename?: 'UserPhonesConnection'
  /** A list of edges which contains the `UserPhone` and cursor to aid in pagination. */
  edges: Array<UserPhonesEdge>
  /** A list of `UserPhone` objects. */
  nodes: Array<UserPhone>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserPhone` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserPhone` edge in the connection. */
export type UserPhonesEdge = {
  __typename?: 'UserPhonesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserPhone` at the end of the edge. */
  node: UserPhone
}

/** Methods to use when ordering `UserPhone`. */
export enum UserPhonesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPrimaryAsc = 'IS_PRIMARY_ASC',
  IsPrimaryDesc = 'IS_PRIMARY_DESC',
  Natural = 'NATURAL',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum UserPhonesType {
  Fax = 'FAX',
  Home = 'HOME',
  Mobile = 'MOBILE',
  Work = 'WORK'
}

/** A filter to be used against UserPhonesType fields. All fields are combined with a logical ‘and.’ */
export type UserPhonesTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserPhonesType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserPhonesType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserPhonesType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserPhonesType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserPhonesType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserPhonesType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserPhonesType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserPhonesType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserPhonesType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserPhonesType>>
}

/** Input for the nested mutation of `user` in the `UserPhoneInput` mutation. */
export type UserPhonesUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPhonesUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserPhoneOnUserPhoneForUserPhonesUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserPhoneForUserPhonesUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserPhoneForUserPhonesUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userPhone` in the `UserInput` mutation. */
export type UserPhonesUserIdFkeyInverseInput = {
  /** The primary key(s) for `userPhone` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserPhoneNodeIdConnect>>
  /** The primary key(s) for `userPhone` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserPhoneUserPhonesPkeyConnect>>
  /** A `UserPhoneInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserPhonesUserIdFkeyUserPhonesCreateInput>>
  /** The primary key(s) for `userPhone` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserPhoneNodeIdDelete>>
  /** The primary key(s) for `userPhone` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserPhoneUserPhonesPkeyDelete>>
  /** Flag indicating whether all other `userPhone` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userPhone` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserPhoneForUserPhonesUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userPhone` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserPhoneOnUserPhoneForUserPhonesUserIdFkeyUsingUserPhonesPkeyUpdate>>
}

/** The `userPhone` to be created by this mutation. */
export type UserPhonesUserIdFkeyUserPhonesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary: Scalars['Boolean']['input']
  phone: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type: UserPhonesType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPhonesUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserPhonesUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** A connection to a list of `UserPolicy` values. */
export type UserPoliciesConnection = {
  __typename?: 'UserPoliciesConnection'
  /** A list of edges which contains the `UserPolicy` and cursor to aid in pagination. */
  edges: Array<UserPoliciesEdge>
  /** A list of `UserPolicy` objects. */
  nodes: Array<UserPolicy>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserPolicy` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserPolicy` edge in the connection. */
export type UserPoliciesEdge = {
  __typename?: 'UserPoliciesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserPolicy` at the end of the edge. */
  node: UserPolicy
}

/** Methods to use when ordering `UserPolicy`. */
export enum UserPoliciesOrderBy {
  AcceptedAtAsc = 'ACCEPTED_AT_ASC',
  AcceptedAtDesc = 'ACCEPTED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PolicyByPolicyIdBodyEnAsc = 'POLICY_BY_POLICY_ID__BODY_EN_ASC',
  PolicyByPolicyIdBodyEnDesc = 'POLICY_BY_POLICY_ID__BODY_EN_DESC',
  PolicyByPolicyIdBodyEsAsc = 'POLICY_BY_POLICY_ID__BODY_ES_ASC',
  PolicyByPolicyIdBodyEsDesc = 'POLICY_BY_POLICY_ID__BODY_ES_DESC',
  PolicyByPolicyIdCreatedAtAsc = 'POLICY_BY_POLICY_ID__CREATED_AT_ASC',
  PolicyByPolicyIdCreatedAtDesc = 'POLICY_BY_POLICY_ID__CREATED_AT_DESC',
  PolicyByPolicyIdDescriptionAsc = 'POLICY_BY_POLICY_ID__DESCRIPTION_ASC',
  PolicyByPolicyIdDescriptionDesc = 'POLICY_BY_POLICY_ID__DESCRIPTION_DESC',
  PolicyByPolicyIdIdAsc = 'POLICY_BY_POLICY_ID__ID_ASC',
  PolicyByPolicyIdIdDesc = 'POLICY_BY_POLICY_ID__ID_DESC',
  PolicyByPolicyIdNameAsc = 'POLICY_BY_POLICY_ID__NAME_ASC',
  PolicyByPolicyIdNameDesc = 'POLICY_BY_POLICY_ID__NAME_DESC',
  PolicyByPolicyIdSlugAsc = 'POLICY_BY_POLICY_ID__SLUG_ASC',
  PolicyByPolicyIdSlugDesc = 'POLICY_BY_POLICY_ID__SLUG_DESC',
  PolicyByPolicyIdTypeAsc = 'POLICY_BY_POLICY_ID__TYPE_ASC',
  PolicyByPolicyIdTypeDesc = 'POLICY_BY_POLICY_ID__TYPE_DESC',
  PolicyByPolicyIdUpdatedAtAsc = 'POLICY_BY_POLICY_ID__UPDATED_AT_ASC',
  PolicyByPolicyIdUpdatedAtDesc = 'POLICY_BY_POLICY_ID__UPDATED_AT_DESC',
  PolicyByPolicyIdValidAtAsc = 'POLICY_BY_POLICY_ID__VALID_AT_ASC',
  PolicyByPolicyIdValidAtDesc = 'POLICY_BY_POLICY_ID__VALID_AT_DESC',
  PolicyIdAsc = 'POLICY_ID_ASC',
  PolicyIdDesc = 'POLICY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `policy` in the `UserPolicyInput` mutation. */
export type UserPoliciesPolicyIdFkeyInput = {
  /** The primary key(s) for `policy` for the far side of the relationship. */
  connectById?: InputMaybe<PolicyNodeIdConnect>
  /** The primary key(s) for `policy` for the far side of the relationship. */
  connectByRowId?: InputMaybe<PolicyPoliciesPkeyConnect>
  /** The primary key(s) for `policy` for the far side of the relationship. */
  connectBySlug?: InputMaybe<PolicyPoliciesSlugKeyConnect>
  /** A `PolicyInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPoliciesPolicyIdFkeyPoliciesCreateInput>
  /** The primary key(s) for `policy` for the far side of the relationship. */
  deleteById?: InputMaybe<PolicyNodeIdDelete>
  /** The primary key(s) for `policy` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<PolicyPoliciesPkeyDelete>
  /** The primary key(s) for `policy` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<PolicyPoliciesSlugKeyDelete>
  /** The primary key(s) and patch data for `policy` for the far side of the relationship. */
  updateById?: InputMaybe<UserPolicyOnUserPolicyForUserPoliciesPolicyIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `policy` for the far side of the relationship. */
  updateByRowId?: InputMaybe<PolicyOnUserPolicyForUserPoliciesPolicyIdFkeyUsingPoliciesPkeyUpdate>
  /** The primary key(s) and patch data for `policy` for the far side of the relationship. */
  updateBySlug?: InputMaybe<PolicyOnUserPolicyForUserPoliciesPolicyIdFkeyUsingPoliciesSlugKeyUpdate>
}

/** Input for the nested mutation of `userPolicy` in the `PolicyInput` mutation. */
export type UserPoliciesPolicyIdFkeyInverseInput = {
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserPolicyNodeIdConnect>>
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserPolicyUserPoliciesPkeyConnect>>
  /** A `UserPolicyInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserPoliciesPolicyIdFkeyUserPoliciesCreateInput>>
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserPolicyNodeIdDelete>>
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserPolicyUserPoliciesPkeyDelete>>
  /** Flag indicating whether all other `userPolicy` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userPolicy` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PolicyOnUserPolicyForUserPoliciesPolicyIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userPolicy` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserPolicyOnUserPolicyForUserPoliciesPolicyIdFkeyUsingUserPoliciesPkeyUpdate>>
}

/** The `policy` to be created by this mutation. */
export type UserPoliciesPolicyIdFkeyPoliciesCreateInput = {
  bodyEn?: InputMaybe<Scalars['String']['input']>
  bodyEs?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  type: PolicyType
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userPolicies?: InputMaybe<UserPoliciesPolicyIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The `userPolicy` to be created by this mutation. */
export type UserPoliciesPolicyIdFkeyUserPoliciesCreateInput = {
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  policy?: InputMaybe<UserPoliciesPolicyIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPoliciesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `user` in the `UserPolicyInput` mutation. */
export type UserPoliciesUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserPoliciesUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserPolicyOnUserPolicyForUserPoliciesUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserPolicyForUserPoliciesUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserPolicyForUserPoliciesUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userPolicy` in the `UserInput` mutation. */
export type UserPoliciesUserIdFkeyInverseInput = {
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserPolicyNodeIdConnect>>
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserPolicyUserPoliciesPkeyConnect>>
  /** A `UserPolicyInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserPoliciesUserIdFkeyUserPoliciesCreateInput>>
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserPolicyNodeIdDelete>>
  /** The primary key(s) for `userPolicy` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserPolicyUserPoliciesPkeyDelete>>
  /** Flag indicating whether all other `userPolicy` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userPolicy` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserPolicyForUserPoliciesUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userPolicy` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserPolicyOnUserPolicyForUserPoliciesUserIdFkeyUsingUserPoliciesPkeyUpdate>>
}

/** The `userPolicy` to be created by this mutation. */
export type UserPoliciesUserIdFkeyUserPoliciesCreateInput = {
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  policy?: InputMaybe<UserPoliciesPolicyIdFkeyInput>
  policyId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPoliciesUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserPoliciesUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

export type UserPolicy = Node & {
  __typename?: 'UserPolicy'
  acceptedAt: Scalars['Datetime']['output']
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  /** Reads a single `Policy` that is related to this `UserPolicy`. */
  policy?: Maybe<Policy>
  policyId: Scalars['UUID']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `User` that is related to this `UserPolicy`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserPolicy` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserPolicyCondition = {
  /** Checks for equality with the object’s `acceptedAt` field. */
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `policyId` field. */
  policyId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserPolicy` object types. All fields are combined with a logical ‘and.’ */
export type UserPolicyFilter = {
  /** Filter by the object’s `acceptedAt` field. */
  acceptedAt?: InputMaybe<DatetimeFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserPolicyFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserPolicyFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserPolicyFilter>>
  /** Filter by the object’s `policy` relation. */
  policy?: InputMaybe<PolicyFilter>
  /** Filter by the object’s `policyId` field. */
  policyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserPolicy` */
export type UserPolicyInput = {
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  policy?: InputMaybe<UserPoliciesPolicyIdFkeyInput>
  policyId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPoliciesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserPolicyNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userPolicy` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserPolicyNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userPolicy` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserPolicyOnUserPolicyForUserPoliciesPolicyIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `policy` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `policy` being updated. */
  patch: PolicyPatch
}

/** The fields on `userPolicy` to look up the row to update. */
export type UserPolicyOnUserPolicyForUserPoliciesPolicyIdFkeyUsingUserPoliciesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userPolicy` being updated. */
  patch: UpdateUserPolicyOnUserPolicyForUserPoliciesPolicyIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserPolicyOnUserPolicyForUserPoliciesUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userPolicy` to look up the row to update. */
export type UserPolicyOnUserPolicyForUserPoliciesUserIdFkeyUsingUserPoliciesPkeyUpdate = {
  /** An object where the defined keys will be set on the `userPolicy` being updated. */
  patch: UpdateUserPolicyOnUserPolicyForUserPoliciesUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `UserPolicy`. Fields that are set will be updated. */
export type UserPolicyPatch = {
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  policy?: InputMaybe<UserPoliciesPolicyIdFkeyInput>
  policyId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPoliciesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userPolicy` to look up the row to connect. */
export type UserPolicyUserPoliciesPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userPolicy` to look up the row to delete. */
export type UserPolicyUserPoliciesPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A filter to be used against many `Upload` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUploadFilter = {
  /** Every related `Upload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UploadFilter>
  /** No related `Upload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UploadFilter>
  /** Some related `Upload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UploadFilter>
}

/** A filter to be used against many `UserAddress` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserAddressFilter = {
  /** Every related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserAddressFilter>
  /** No related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserAddressFilter>
  /** Some related `UserAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserAddressFilter>
}

/** A filter to be used against many `UserChild` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserChildFilter = {
  /** Every related `UserChild` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserChildFilter>
  /** No related `UserChild` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserChildFilter>
  /** Some related `UserChild` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserChildFilter>
}

/** A filter to be used against many `UserInsurance` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserInsuranceFilter = {
  /** Every related `UserInsurance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserInsuranceFilter>
  /** No related `UserInsurance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserInsuranceFilter>
  /** Some related `UserInsurance` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserInsuranceFilter>
}

/** A filter to be used against many `UserLanguage` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserLanguageFilter = {
  /** Every related `UserLanguage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserLanguageFilter>
  /** No related `UserLanguage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserLanguageFilter>
  /** Some related `UserLanguage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserLanguageFilter>
}

/** A filter to be used against many `UserPaymentMethod` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserPaymentMethodFilter = {
  /** Every related `UserPaymentMethod` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPaymentMethodFilter>
  /** No related `UserPaymentMethod` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPaymentMethodFilter>
  /** Some related `UserPaymentMethod` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPaymentMethodFilter>
}

/** A filter to be used against many `UserPaymentProvider` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserPaymentProviderFilter = {
  /** Every related `UserPaymentProvider` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPaymentProviderFilter>
  /** No related `UserPaymentProvider` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPaymentProviderFilter>
  /** Some related `UserPaymentProvider` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPaymentProviderFilter>
}

/** A filter to be used against many `UserPhone` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserPhoneFilter = {
  /** Every related `UserPhone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPhoneFilter>
  /** No related `UserPhone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPhoneFilter>
  /** Some related `UserPhone` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPhoneFilter>
}

/** A filter to be used against many `UserPolicy` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserPolicyFilter = {
  /** Every related `UserPolicy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserPolicyFilter>
  /** No related `UserPolicy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserPolicyFilter>
  /** Some related `UserPolicy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserPolicyFilter>
}

/** A filter to be used against many `UserUpload` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyUserUploadFilter = {
  /** Every related `UserUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserUploadFilter>
  /** No related `UserUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserUploadFilter>
  /** Some related `UserUpload` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserUploadFilter>
}

export type UserUpload = Node & {
  __typename?: 'UserUpload'
  createdAt: Scalars['Datetime']['output']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rowId: Scalars['UUID']['output']
  updatedAt: Scalars['Datetime']['output']
  /** Reads a single `Upload` that is related to this `UserUpload`. */
  upload?: Maybe<Upload>
  uploadId: Scalars['UUID']['output']
  /** Reads a single `User` that is related to this `UserUpload`. */
  user?: Maybe<User>
  userId: Scalars['UUID']['output']
}

/**
 * A condition to be used against `UserUpload` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserUploadCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>
  /** Checks for equality with the object’s `rowId` field. */
  rowId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  /** Checks for equality with the object’s `uploadId` field. */
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** A filter to be used against `UserUpload` object types. All fields are combined with a logical ‘and.’ */
export type UserUploadFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserUploadFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserUploadFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserUploadFilter>>
  /** Filter by the object’s `rowId` field. */
  rowId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `upload` relation. */
  upload?: InputMaybe<UploadFilter>
  /** Filter by the object’s `uploadId` field. */
  uploadId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `UserUpload` */
export type UserUploadInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UserUploadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The globally unique `ID` look up for the row to connect. */
export type UserUploadNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userUpload` to be connected. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to delete. */
export type UserUploadNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userUpload` to be deleted. */
  id: Scalars['ID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserUploadOnUserUploadForUserUploadsUploadIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `upload` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `upload` being updated. */
  patch: UploadPatch
}

/** The fields on `userUpload` to look up the row to update. */
export type UserUploadOnUserUploadForUserUploadsUploadIdFkeyUsingUserUploadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `userUpload` being updated. */
  patch: UpdateUserUploadOnUserUploadForUserUploadsUploadIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** The globally unique `ID` look up for the row to update. */
export type UserUploadOnUserUploadForUserUploadsUserIdFkeyNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  id: Scalars['ID']['input']
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch
}

/** The fields on `userUpload` to look up the row to update. */
export type UserUploadOnUserUploadForUserUploadsUserIdFkeyUsingUserUploadsPkeyUpdate = {
  /** An object where the defined keys will be set on the `userUpload` being updated. */
  patch: UpdateUserUploadOnUserUploadForUserUploadsUserIdFkeyPatch
  rowId: Scalars['UUID']['input']
}

/** Represents an update to a `UserUpload`. Fields that are set will be updated. */
export type UserUploadPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UserUploadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** The fields on `userUpload` to look up the row to connect. */
export type UserUploadUserUploadsPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `userUpload` to look up the row to delete. */
export type UserUploadUserUploadsPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** A connection to a list of `UserUpload` values. */
export type UserUploadsConnection = {
  __typename?: 'UserUploadsConnection'
  /** A list of edges which contains the `UserUpload` and cursor to aid in pagination. */
  edges: Array<UserUploadsEdge>
  /** A list of `UserUpload` objects. */
  nodes: Array<UserUpload>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserUpload` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `UserUpload` edge in the connection. */
export type UserUploadsEdge = {
  __typename?: 'UserUploadsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `UserUpload` at the end of the edge. */
  node: UserUpload
}

/** Methods to use when ordering `UserUpload`. */
export enum UserUploadsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UploadByUploadIdBucketAsc = 'UPLOAD_BY_UPLOAD_ID__BUCKET_ASC',
  UploadByUploadIdBucketDesc = 'UPLOAD_BY_UPLOAD_ID__BUCKET_DESC',
  UploadByUploadIdCreatedAtAsc = 'UPLOAD_BY_UPLOAD_ID__CREATED_AT_ASC',
  UploadByUploadIdCreatedAtDesc = 'UPLOAD_BY_UPLOAD_ID__CREATED_AT_DESC',
  UploadByUploadIdFilenameAsc = 'UPLOAD_BY_UPLOAD_ID__FILENAME_ASC',
  UploadByUploadIdFilenameDesc = 'UPLOAD_BY_UPLOAD_ID__FILENAME_DESC',
  UploadByUploadIdFilesizeAsc = 'UPLOAD_BY_UPLOAD_ID__FILESIZE_ASC',
  UploadByUploadIdFilesizeDesc = 'UPLOAD_BY_UPLOAD_ID__FILESIZE_DESC',
  UploadByUploadIdFiletypeAsc = 'UPLOAD_BY_UPLOAD_ID__FILETYPE_ASC',
  UploadByUploadIdFiletypeDesc = 'UPLOAD_BY_UPLOAD_ID__FILETYPE_DESC',
  UploadByUploadIdIdAsc = 'UPLOAD_BY_UPLOAD_ID__ID_ASC',
  UploadByUploadIdIdDesc = 'UPLOAD_BY_UPLOAD_ID__ID_DESC',
  UploadByUploadIdKeyAsc = 'UPLOAD_BY_UPLOAD_ID__KEY_ASC',
  UploadByUploadIdKeyDesc = 'UPLOAD_BY_UPLOAD_ID__KEY_DESC',
  UploadByUploadIdSlugAsc = 'UPLOAD_BY_UPLOAD_ID__SLUG_ASC',
  UploadByUploadIdSlugDesc = 'UPLOAD_BY_UPLOAD_ID__SLUG_DESC',
  UploadByUploadIdUpdatedAtAsc = 'UPLOAD_BY_UPLOAD_ID__UPDATED_AT_ASC',
  UploadByUploadIdUpdatedAtDesc = 'UPLOAD_BY_UPLOAD_ID__UPDATED_AT_DESC',
  UploadByUploadIdUploaderIdAsc = 'UPLOAD_BY_UPLOAD_ID__UPLOADER_ID_ASC',
  UploadByUploadIdUploaderIdDesc = 'UPLOAD_BY_UPLOAD_ID__UPLOADER_ID_DESC',
  UploadIdAsc = 'UPLOAD_ID_ASC',
  UploadIdDesc = 'UPLOAD_ID_DESC',
  UserByUserIdBirthdateAtAsc = 'USER_BY_USER_ID__BIRTHDATE_AT_ASC',
  UserByUserIdBirthdateAtDesc = 'USER_BY_USER_ID__BIRTHDATE_AT_DESC',
  UserByUserIdCreatedAtAsc = 'USER_BY_USER_ID__CREATED_AT_ASC',
  UserByUserIdCreatedAtDesc = 'USER_BY_USER_ID__CREATED_AT_DESC',
  UserByUserIdEmailAsc = 'USER_BY_USER_ID__EMAIL_ASC',
  UserByUserIdEmailDesc = 'USER_BY_USER_ID__EMAIL_DESC',
  UserByUserIdFirstNameAsc = 'USER_BY_USER_ID__FIRST_NAME_ASC',
  UserByUserIdFirstNameDesc = 'USER_BY_USER_ID__FIRST_NAME_DESC',
  UserByUserIdGenderAsc = 'USER_BY_USER_ID__GENDER_ASC',
  UserByUserIdGenderDesc = 'USER_BY_USER_ID__GENDER_DESC',
  UserByUserIdIdAsc = 'USER_BY_USER_ID__ID_ASC',
  UserByUserIdIdDesc = 'USER_BY_USER_ID__ID_DESC',
  UserByUserIdIsAdminAsc = 'USER_BY_USER_ID__IS_ADMIN_ASC',
  UserByUserIdIsAdminDesc = 'USER_BY_USER_ID__IS_ADMIN_DESC',
  UserByUserIdLastNameAsc = 'USER_BY_USER_ID__LAST_NAME_ASC',
  UserByUserIdLastNameDesc = 'USER_BY_USER_ID__LAST_NAME_DESC',
  UserByUserIdMiddleNameAsc = 'USER_BY_USER_ID__MIDDLE_NAME_ASC',
  UserByUserIdMiddleNameDesc = 'USER_BY_USER_ID__MIDDLE_NAME_DESC',
  UserByUserIdSlugAsc = 'USER_BY_USER_ID__SLUG_ASC',
  UserByUserIdSlugDesc = 'USER_BY_USER_ID__SLUG_DESC',
  UserByUserIdUpdatedAtAsc = 'USER_BY_USER_ID__UPDATED_AT_ASC',
  UserByUserIdUpdatedAtDesc = 'USER_BY_USER_ID__UPDATED_AT_DESC',
  UserByUserIdVerifiedAtAsc = 'USER_BY_USER_ID__VERIFIED_AT_ASC',
  UserByUserIdVerifiedAtDesc = 'USER_BY_USER_ID__VERIFIED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** Input for the nested mutation of `upload` in the `UserUploadInput` mutation. */
export type UserUploadsUploadIdFkeyInput = {
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectById?: InputMaybe<UploadNodeIdConnect>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UploadUploadsPkeyConnect>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UploadUploadsSlugKeyConnect>
  /** A `UploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserUploadsUploadIdFkeyUploadsCreateInput>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteById?: InputMaybe<UploadNodeIdDelete>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UploadUploadsPkeyDelete>
  /** The primary key(s) for `upload` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UploadUploadsSlugKeyDelete>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateById?: InputMaybe<UserUploadOnUserUploadForUserUploadsUploadIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UploadOnUserUploadForUserUploadsUploadIdFkeyUsingUploadsPkeyUpdate>
  /** The primary key(s) and patch data for `upload` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UploadOnUserUploadForUserUploadsUploadIdFkeyUsingUploadsSlugKeyUpdate>
}

/** Input for the nested mutation of `userUpload` in the `UploadInput` mutation. */
export type UserUploadsUploadIdFkeyInverseInput = {
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserUploadNodeIdConnect>>
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserUploadUserUploadsPkeyConnect>>
  /** A `UserUploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserUploadsUploadIdFkeyUserUploadsCreateInput>>
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserUploadNodeIdDelete>>
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserUploadUserUploadsPkeyDelete>>
  /** Flag indicating whether all other `userUpload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userUpload` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UploadOnUserUploadForUserUploadsUploadIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userUpload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserUploadOnUserUploadForUserUploadsUploadIdFkeyUsingUserUploadsPkeyUpdate>>
}

/** The `upload` to be created by this mutation. */
export type UserUploadsUploadIdFkeyUploadsCreateInput = {
  bucket: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename: Scalars['String']['input']
  filesize: Scalars['Int']['input']
  filetype: Scalars['String']['input']
  key: Scalars['String']['input']
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** The `userUpload` to be created by this mutation. */
export type UserUploadsUploadIdFkeyUserUploadsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserUploadsUploadIdFkeyInput>
  user?: InputMaybe<UserUploadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** Input for the nested mutation of `user` in the `UserUploadInput` mutation. */
export type UserUploadsUserIdFkeyInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserNodeIdConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByRowId?: InputMaybe<UserUsersPkeyConnect>
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectBySlug?: InputMaybe<UserUsersSlugUkeyConnect>
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<UserUploadsUserIdFkeyUsersCreateInput>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserNodeIdDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<UserUsersPkeyDelete>
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteBySlug?: InputMaybe<UserUsersSlugUkeyDelete>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserUploadOnUserUploadForUserUploadsUserIdFkeyNodeIdUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByRowId?: InputMaybe<UserOnUserUploadForUserUploadsUserIdFkeyUsingUsersPkeyUpdate>
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateBySlug?: InputMaybe<UserOnUserUploadForUserUploadsUserIdFkeyUsingUsersSlugUkeyUpdate>
}

/** Input for the nested mutation of `userUpload` in the `UserInput` mutation. */
export type UserUploadsUserIdFkeyInverseInput = {
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserUploadNodeIdConnect>>
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  connectByRowId?: InputMaybe<Array<UserUploadUserUploadsPkeyConnect>>
  /** A `UserUploadInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<UserUploadsUserIdFkeyUserUploadsCreateInput>>
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserUploadNodeIdDelete>>
  /** The primary key(s) for `userUpload` for the far side of the relationship. */
  deleteByRowId?: InputMaybe<Array<UserUploadUserUploadsPkeyDelete>>
  /** Flag indicating whether all other `userUpload` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']['input']>
  /** The primary key(s) and patch data for `userUpload` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserOnUserUploadForUserUploadsUserIdFkeyNodeIdUpdate>>
  /** The primary key(s) and patch data for `userUpload` for the far side of the relationship. */
  updateByRowId?: InputMaybe<Array<UserUploadOnUserUploadForUserUploadsUserIdFkeyUsingUserUploadsPkeyUpdate>>
}

/** The `userUpload` to be created by this mutation. */
export type UserUploadsUserIdFkeyUserUploadsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name: Scalars['String']['input']
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UserUploadsUserIdFkeyInput>
}

/** The `user` to be created by this mutation. */
export type UserUploadsUserIdFkeyUsersCreateInput = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** The fields on `user` to look up the row to connect. */
export type UserUsersPkeyConnect = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to delete. */
export type UserUsersPkeyDelete = {
  rowId: Scalars['UUID']['input']
}

/** The fields on `user` to look up the row to connect. */
export type UserUsersSlugUkeyConnect = {
  slug: Scalars['String']['input']
}

/** The fields on `user` to look up the row to delete. */
export type UserUsersSlugUkeyDelete = {
  slug: Scalars['String']['input']
}

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection'
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>
  /** A list of `User` objects. */
  nodes: Array<User>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int']['output']
}

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>
  /** The `User` at the end of the edge. */
  node: User
}

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  BirthdateAtAsc = 'BIRTHDATE_AT_ASC',
  BirthdateAtDesc = 'BIRTHDATE_AT_DESC',
  ClinicianByUserIdCharmIdAsc = 'CLINICIAN_BY_USER_ID__CHARM_ID_ASC',
  ClinicianByUserIdCharmIdDesc = 'CLINICIAN_BY_USER_ID__CHARM_ID_DESC',
  ClinicianByUserIdCreatedAtAsc = 'CLINICIAN_BY_USER_ID__CREATED_AT_ASC',
  ClinicianByUserIdCreatedAtDesc = 'CLINICIAN_BY_USER_ID__CREATED_AT_DESC',
  ClinicianByUserIdEmployeeTypeAsc = 'CLINICIAN_BY_USER_ID__EMPLOYEE_TYPE_ASC',
  ClinicianByUserIdEmployeeTypeDesc = 'CLINICIAN_BY_USER_ID__EMPLOYEE_TYPE_DESC',
  ClinicianByUserIdIdAsc = 'CLINICIAN_BY_USER_ID__ID_ASC',
  ClinicianByUserIdIdDesc = 'CLINICIAN_BY_USER_ID__ID_DESC',
  ClinicianByUserIdIntroductionAsc = 'CLINICIAN_BY_USER_ID__INTRODUCTION_ASC',
  ClinicianByUserIdIntroductionDesc = 'CLINICIAN_BY_USER_ID__INTRODUCTION_DESC',
  ClinicianByUserIdSlugAsc = 'CLINICIAN_BY_USER_ID__SLUG_ASC',
  ClinicianByUserIdSlugDesc = 'CLINICIAN_BY_USER_ID__SLUG_DESC',
  ClinicianByUserIdSlugPublicAsc = 'CLINICIAN_BY_USER_ID__SLUG_PUBLIC_ASC',
  ClinicianByUserIdSlugPublicDesc = 'CLINICIAN_BY_USER_ID__SLUG_PUBLIC_DESC',
  ClinicianByUserIdUpdatedAtAsc = 'CLINICIAN_BY_USER_ID__UPDATED_AT_ASC',
  ClinicianByUserIdUpdatedAtDesc = 'CLINICIAN_BY_USER_ID__UPDATED_AT_DESC',
  ClinicianByUserIdUserIdAsc = 'CLINICIAN_BY_USER_ID__USER_ID_ASC',
  ClinicianByUserIdUserIdDesc = 'CLINICIAN_BY_USER_ID__USER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsAdminAsc = 'IS_ADMIN_ASC',
  IsAdminDesc = 'IS_ADMIN_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  LeadByUserIdConvertedAtAsc = 'LEAD_BY_USER_ID__CONVERTED_AT_ASC',
  LeadByUserIdConvertedAtDesc = 'LEAD_BY_USER_ID__CONVERTED_AT_DESC',
  LeadByUserIdCreatedAtAsc = 'LEAD_BY_USER_ID__CREATED_AT_ASC',
  LeadByUserIdCreatedAtDesc = 'LEAD_BY_USER_ID__CREATED_AT_DESC',
  LeadByUserIdIdAsc = 'LEAD_BY_USER_ID__ID_ASC',
  LeadByUserIdIdDesc = 'LEAD_BY_USER_ID__ID_DESC',
  LeadByUserIdOptInAtAsc = 'LEAD_BY_USER_ID__OPT_IN_AT_ASC',
  LeadByUserIdOptInAtDesc = 'LEAD_BY_USER_ID__OPT_IN_AT_DESC',
  LeadByUserIdOptInMethodAsc = 'LEAD_BY_USER_ID__OPT_IN_METHOD_ASC',
  LeadByUserIdOptInMethodDesc = 'LEAD_BY_USER_ID__OPT_IN_METHOD_DESC',
  LeadByUserIdReferralPartnerIdAsc = 'LEAD_BY_USER_ID__REFERRAL_PARTNER_ID_ASC',
  LeadByUserIdReferralPartnerIdDesc = 'LEAD_BY_USER_ID__REFERRAL_PARTNER_ID_DESC',
  LeadByUserIdReferralPartnerSourceIdAsc = 'LEAD_BY_USER_ID__REFERRAL_PARTNER_SOURCE_ID_ASC',
  LeadByUserIdReferralPartnerSourceIdDesc = 'LEAD_BY_USER_ID__REFERRAL_PARTNER_SOURCE_ID_DESC',
  LeadByUserIdSlugAsc = 'LEAD_BY_USER_ID__SLUG_ASC',
  LeadByUserIdSlugDesc = 'LEAD_BY_USER_ID__SLUG_DESC',
  LeadByUserIdSourceAsc = 'LEAD_BY_USER_ID__SOURCE_ASC',
  LeadByUserIdSourceDesc = 'LEAD_BY_USER_ID__SOURCE_DESC',
  LeadByUserIdStatusAsc = 'LEAD_BY_USER_ID__STATUS_ASC',
  LeadByUserIdStatusDesc = 'LEAD_BY_USER_ID__STATUS_DESC',
  LeadByUserIdUpdatedAtAsc = 'LEAD_BY_USER_ID__UPDATED_AT_ASC',
  LeadByUserIdUpdatedAtDesc = 'LEAD_BY_USER_ID__UPDATED_AT_DESC',
  LeadByUserIdUserIdAsc = 'LEAD_BY_USER_ID__USER_ID_ASC',
  LeadByUserIdUserIdDesc = 'LEAD_BY_USER_ID__USER_ID_DESC',
  LeadByUserIdZohoIdAsc = 'LEAD_BY_USER_ID__ZOHO_ID_ASC',
  LeadByUserIdZohoIdDesc = 'LEAD_BY_USER_ID__ZOHO_ID_DESC',
  MiddleNameAsc = 'MIDDLE_NAME_ASC',
  MiddleNameDesc = 'MIDDLE_NAME_DESC',
  Natural = 'NATURAL',
  PatientByUserIdCharmIdAsc = 'PATIENT_BY_USER_ID__CHARM_ID_ASC',
  PatientByUserIdCharmIdDesc = 'PATIENT_BY_USER_ID__CHARM_ID_DESC',
  PatientByUserIdCharmRecordIdAsc = 'PATIENT_BY_USER_ID__CHARM_RECORD_ID_ASC',
  PatientByUserIdCharmRecordIdDesc = 'PATIENT_BY_USER_ID__CHARM_RECORD_ID_DESC',
  PatientByUserIdCreatedAtAsc = 'PATIENT_BY_USER_ID__CREATED_AT_ASC',
  PatientByUserIdCreatedAtDesc = 'PATIENT_BY_USER_ID__CREATED_AT_DESC',
  PatientByUserIdIdAsc = 'PATIENT_BY_USER_ID__ID_ASC',
  PatientByUserIdIdDesc = 'PATIENT_BY_USER_ID__ID_DESC',
  PatientByUserIdSlugAsc = 'PATIENT_BY_USER_ID__SLUG_ASC',
  PatientByUserIdSlugDesc = 'PATIENT_BY_USER_ID__SLUG_DESC',
  PatientByUserIdUpdatedAtAsc = 'PATIENT_BY_USER_ID__UPDATED_AT_ASC',
  PatientByUserIdUpdatedAtDesc = 'PATIENT_BY_USER_ID__UPDATED_AT_DESC',
  PatientByUserIdUserIdAsc = 'PATIENT_BY_USER_ID__USER_ID_ASC',
  PatientByUserIdUserIdDesc = 'PATIENT_BY_USER_ID__USER_ID_DESC',
  PatientByUserIdZohoIdAsc = 'PATIENT_BY_USER_ID__ZOHO_ID_ASC',
  PatientByUserIdZohoIdDesc = 'PATIENT_BY_USER_ID__ZOHO_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UploadsByUploaderIdCountAsc = 'UPLOADS_BY_UPLOADER_ID__COUNT_ASC',
  UploadsByUploaderIdCountDesc = 'UPLOADS_BY_UPLOADER_ID__COUNT_DESC',
  UserAddressesByUserIdCountAsc = 'USER_ADDRESSES_BY_USER_ID__COUNT_ASC',
  UserAddressesByUserIdCountDesc = 'USER_ADDRESSES_BY_USER_ID__COUNT_DESC',
  UserChildrenByUserIdCountAsc = 'USER_CHILDREN_BY_USER_ID__COUNT_ASC',
  UserChildrenByUserIdCountDesc = 'USER_CHILDREN_BY_USER_ID__COUNT_DESC',
  UserInsurancesByUserIdCountAsc = 'USER_INSURANCES_BY_USER_ID__COUNT_ASC',
  UserInsurancesByUserIdCountDesc = 'USER_INSURANCES_BY_USER_ID__COUNT_DESC',
  UserLanguagesByUserIdCountAsc = 'USER_LANGUAGES_BY_USER_ID__COUNT_ASC',
  UserLanguagesByUserIdCountDesc = 'USER_LANGUAGES_BY_USER_ID__COUNT_DESC',
  UserPaymentMethodsByUserIdCountAsc = 'USER_PAYMENT_METHODS_BY_USER_ID__COUNT_ASC',
  UserPaymentMethodsByUserIdCountDesc = 'USER_PAYMENT_METHODS_BY_USER_ID__COUNT_DESC',
  UserPaymentProvidersByUserIdCountAsc = 'USER_PAYMENT_PROVIDERS_BY_USER_ID__COUNT_ASC',
  UserPaymentProvidersByUserIdCountDesc = 'USER_PAYMENT_PROVIDERS_BY_USER_ID__COUNT_DESC',
  UserPhonesByUserIdCountAsc = 'USER_PHONES_BY_USER_ID__COUNT_ASC',
  UserPhonesByUserIdCountDesc = 'USER_PHONES_BY_USER_ID__COUNT_DESC',
  UserPoliciesByUserIdCountAsc = 'USER_POLICIES_BY_USER_ID__COUNT_ASC',
  UserPoliciesByUserIdCountDesc = 'USER_POLICIES_BY_USER_ID__COUNT_DESC',
  UserUploadsByUserIdCountAsc = 'USER_UPLOADS_BY_USER_ID__COUNT_ASC',
  UserUploadsByUserIdCountDesc = 'USER_UPLOADS_BY_USER_ID__COUNT_DESC',
  VerifiedAtAsc = 'VERIFIED_AT_ASC',
  VerifiedAtDesc = 'VERIFIED_AT_DESC'
}

/** An object where the defined keys will be set on the `address` being updated. */
export type UpdateAddressOnUserAddressForUserAddressesAddressIdFkeyPatch = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  stateOrProvince?: InputMaybe<Scalars['String']['input']>
  street1?: InputMaybe<Scalars['String']['input']>
  street2?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userAddresses?: InputMaybe<UserAddressesAddressIdFkeyInverseInput>
}

/** An object where the defined keys will be set on the `appointment` being updated. */
export type UpdateAppointmentOnAppointmentForAppointmentsClinicianIdFkeyPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  status?: InputMaybe<AppointmentsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `appointment` being updated. */
export type UpdateAppointmentOnAppointmentForAppointmentsPatientIdFkeyPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  status?: InputMaybe<AppointmentsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `appointment` being updated. */
export type UpdateAppointmentOnAppointmentForAppointmentsServiceIdFkeyPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  status?: InputMaybe<AppointmentsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
  userChildId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `appointment` being updated. */
export type UpdateAppointmentOnAppointmentForAppointmentsUserChildIdFkeyPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  clinician?: InputMaybe<AppointmentsClinicianIdFkeyInput>
  clinicianId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  notes?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<AppointmentsPatientIdFkeyInput>
  patientId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  selectionMethod?: InputMaybe<AppointmentsSelectionMethod>
  service?: InputMaybe<AppointmentsServiceIdFkeyInput>
  serviceId?: InputMaybe<Scalars['UUID']['input']>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  status?: InputMaybe<AppointmentsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userChild?: InputMaybe<AppointmentsUserChildIdFkeyInput>
}

/** An object where the defined keys will be set on the `clinicianAvailability` being updated. */
export type UpdateClinicianAvailabilityOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch = {
  clinician?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  endsAt?: InputMaybe<Scalars['Datetime']['input']>
  googleCalendarEventId?: InputMaybe<Scalars['String']['input']>
  isExclusive?: InputMaybe<Scalars['Boolean']['input']>
  recurDuration?: InputMaybe<IntervalInput>
  recurEvery?: InputMaybe<IntervalInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  startsAt?: InputMaybe<Scalars['Datetime']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `clinician` being updated. */
export type UpdateClinicianOnAppointmentForAppointmentsClinicianIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `clinician` being updated. */
export type UpdateClinicianOnClinicianAvailabilityForClinicianAvailabilitiesClinicianIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `clinician` being updated. */
export type UpdateClinicianOnClinicianForCliniciansUserIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsClinicianIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  clinicianAvailabilities?: InputMaybe<ClinicianAvailabilitiesClinicianIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  employeeType?: InputMaybe<EmployeeType>
  introduction?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<CliniciansUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `insuranceProvider` being updated. */
export type UpdateInsuranceProviderOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyPatch = {
  charmId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  payerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userInsurances?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInverseInput>
}

/** An object where the defined keys will be set on the `lead` being updated. */
export type UpdateLeadOnLeadForLeadsReferralPartnerIdFkeyPatch = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<LeadsSource>
  status?: InputMaybe<LeadsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** An object where the defined keys will be set on the `lead` being updated. */
export type UpdateLeadOnLeadForLeadsReferralPartnerSourceIdFkeyPatch = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<LeadsSource>
  status?: InputMaybe<LeadsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** An object where the defined keys will be set on the `lead` being updated. */
export type UpdateLeadOnLeadForLeadsUserIdFkeyPatch = {
  convertedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  optInAt?: InputMaybe<Scalars['Datetime']['input']>
  optInMethod?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<LeadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  referralPartnerSource?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInput>
  referralPartnerSourceId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<LeadsSource>
  status?: InputMaybe<LeadsStatus>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<LeadsUserIdFkeyInput>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** An object where the defined keys will be set on the `patient` being updated. */
export type UpdatePatientOnAppointmentForAppointmentsPatientIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsPatientIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<PatientsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** An object where the defined keys will be set on the `patient` being updated. */
export type UpdatePatientOnPatientForPatientsUserIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsPatientIdFkeyInverseInput>
  charmId?: InputMaybe<Scalars['String']['input']>
  charmRecordId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<PatientsUserIdFkeyInput>
  zohoId?: InputMaybe<Scalars['String']['input']>
}

/** An object where the defined keys will be set on the `policy` being updated. */
export type UpdatePolicyOnUserPolicyForUserPoliciesPolicyIdFkeyPatch = {
  bodyEn?: InputMaybe<Scalars['String']['input']>
  bodyEs?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<PolicyType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  userPolicies?: InputMaybe<UserPoliciesPolicyIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `referralPartner` being updated. */
export type UpdateReferralPartnerOnLeadForLeadsReferralPartnerIdFkeyPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ReferralPartnerType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `referralPartner` being updated. */
export type UpdateReferralPartnerOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ReferralPartnerType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `referralPartner` being updated. */
export type UpdateReferralPartnerOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyPatch = {
  config?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartnerSources?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInverseInput>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  slugPublic?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<ReferralPartnerType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `referralPartnerSource` being updated. */
export type UpdateReferralPartnerSourceOnLeadForLeadsReferralPartnerSourceIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `referralPartnerSource` being updated. */
export type UpdateReferralPartnerSourceOnReferralPartnerSourceForReferralPartnerSourcesReferralPartnerIdFkeyPatch = {
  description?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  leads?: InputMaybe<LeadsReferralPartnerSourceIdFkeyInverseInput>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<ReferralPartnerSourcesReferralPartnerIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `referralPartnerUpload` being updated. */
export type UpdateReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsReferralPartnerIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `referralPartnerUpload` being updated. */
export type UpdateReferralPartnerUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  referralPartner?: InputMaybe<ReferralPartnerUploadsReferralPartnerIdFkeyInput>
  referralPartnerId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInput>
}

/** An object where the defined keys will be set on the `service` being updated. */
export type UpdateServiceOnAppointmentForAppointmentsServiceIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsServiceIdFkeyInverseInput>
  charmServiceId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  duration?: InputMaybe<IntervalInput>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['BigFloat']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `upload` being updated. */
export type UpdateUploadOnReferralPartnerUploadForReferralPartnerUploadsUploadIdFkeyPatch = {
  bucket?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Int']['input']>
  filetype?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** An object where the defined keys will be set on the `upload` being updated. */
export type UpdateUploadOnUploadForUploadsUploaderIdFkeyPatch = {
  bucket?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Int']['input']>
  filetype?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** An object where the defined keys will be set on the `upload` being updated. */
export type UpdateUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyPatch = {
  bucket?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Int']['input']>
  filetype?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** An object where the defined keys will be set on the `upload` being updated. */
export type UpdateUploadOnUserUploadForUserUploadsUploadIdFkeyPatch = {
  bucket?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  filename?: InputMaybe<Scalars['String']['input']>
  filesize?: InputMaybe<Scalars['Int']['input']>
  filetype?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  referralPartnerUploads?: InputMaybe<ReferralPartnerUploadsUploadIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploaderId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UploadsUploaderIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUploadIdFkeyInverseInput>
}

/** An object where the defined keys will be set on the `userAddress` being updated. */
export type UpdateUserAddressOnUserAddressForUserAddressesAddressIdFkeyPatch = {
  address?: InputMaybe<UserAddressesAddressIdFkeyInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserAddressesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `userAddress` being updated. */
export type UpdateUserAddressOnUserAddressForUserAddressesUserIdFkeyPatch = {
  address?: InputMaybe<UserAddressesAddressIdFkeyInput>
  addressId?: InputMaybe<Scalars['UUID']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserAddressesUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `userChild` being updated. */
export type UpdateUserChildOnAppointmentForAppointmentsUserChildIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsUserChildIdFkeyInverseInput>
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  dueAt?: InputMaybe<Scalars['Date']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserChildrenUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `userChild` being updated. */
export type UpdateUserChildOnUserChildForUserChildrenUserIdFkeyPatch = {
  appointments?: InputMaybe<AppointmentsUserChildIdFkeyInverseInput>
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  dueAt?: InputMaybe<Scalars['Date']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserChildrenUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `userInsurance` being updated. */
export type UpdateUserInsuranceOnUserInsuranceForUserInsurancesInsuranceProviderIdFkeyPatch = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  memberId?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationship>
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type?: InputMaybe<UserInsuranceType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** An object where the defined keys will be set on the `userInsurance` being updated. */
export type UpdateUserInsuranceOnUserInsuranceForUserInsurancesUserIdFkeyPatch = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  memberId?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationship>
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type?: InputMaybe<UserInsuranceType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** An object where the defined keys will be set on the `userInsurance` being updated. */
export type UpdateUserInsuranceOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyPatch = {
  category?: InputMaybe<UserInsuranceCategory>
  charmId?: InputMaybe<Scalars['String']['input']>
  comments?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  groupId?: InputMaybe<Scalars['String']['input']>
  insuranceProvider?: InputMaybe<UserInsurancesInsuranceProviderIdFkeyInput>
  insuranceProviderId?: InputMaybe<Scalars['UUID']['input']>
  memberId?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCity?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressCountry?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressPostalCode?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStateOrProvince?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet1?: InputMaybe<Scalars['String']['input']>
  policyHolderAddressStreet2?: InputMaybe<Scalars['String']['input']>
  policyHolderBirthdateAt?: InputMaybe<Scalars['Date']['input']>
  policyHolderFirstName?: InputMaybe<Scalars['String']['input']>
  policyHolderGender?: InputMaybe<Scalars['String']['input']>
  policyHolderHomePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderLastName?: InputMaybe<Scalars['String']['input']>
  policyHolderMobilePhone?: InputMaybe<Scalars['String']['input']>
  policyHolderRelationship?: InputMaybe<UserInsurancePolicyHolderRelationship>
  policyHolderSsn?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type?: InputMaybe<UserInsuranceType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserInsurancesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
  userInsuranceUploads?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInverseInput>
  validAt?: InputMaybe<Scalars['Date']['input']>
}

/** An object where the defined keys will be set on the `userInsuranceUpload` being updated. */
export type UpdateUserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUploadIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInput>
  userInsurance?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInput>
  userInsuranceId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `userInsuranceUpload` being updated. */
export type UpdateUserInsuranceUploadOnUserInsuranceUploadForUserInsuranceUploadsUserInsuranceIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserInsuranceUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  userInsurance?: InputMaybe<UserInsuranceUploadsUserInsuranceIdFkeyInput>
}

/** An object where the defined keys will be set on the `userLanguage` being updated. */
export type UpdateUserLanguageOnUserLanguageForUserLanguagesUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserLanguagesUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnClinicianForCliniciansUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnLeadForLeadsUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPatientForPatientsUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUploadForUploadsUploaderIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserAddressForUserAddressesUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserChildForUserChildrenUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserInsuranceForUserInsurancesUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserLanguageForUserLanguagesUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserPhoneForUserPhonesUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserPolicyForUserPoliciesUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserUploadForUserUploadsUserIdFkeyPatch = {
  birthdateAt?: InputMaybe<Scalars['Date']['input']>
  clinician?: InputMaybe<CliniciansUserIdFkeyInverseInput>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserGender>
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadsUserIdFkeyInverseInput>
  middleName?: InputMaybe<Scalars['String']['input']>
  patient?: InputMaybe<PatientsUserIdFkeyInverseInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  uploads?: InputMaybe<UploadsUploaderIdFkeyInverseInput>
  userAddresses?: InputMaybe<UserAddressesUserIdFkeyInverseInput>
  userChildren?: InputMaybe<UserChildrenUserIdFkeyInverseInput>
  userInsurances?: InputMaybe<UserInsurancesUserIdFkeyInverseInput>
  userLanguages?: InputMaybe<UserLanguagesUserIdFkeyInverseInput>
  userPaymentMethods?: InputMaybe<UserPaymentMethodsUserIdFkeyInverseInput>
  userPaymentProviders?: InputMaybe<UserPaymentProvidersUserIdFkeyInverseInput>
  userPhones?: InputMaybe<UserPhonesUserIdFkeyInverseInput>
  userPolicies?: InputMaybe<UserPoliciesUserIdFkeyInverseInput>
  userUploads?: InputMaybe<UserUploadsUserIdFkeyInverseInput>
  verifiedAt?: InputMaybe<Scalars['Datetime']['input']>
}

/** An object where the defined keys will be set on the `userPaymentMethod` being updated. */
export type UpdateUserPaymentMethodOnUserPaymentMethodForUserPaymentMethodsUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  methodId?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<PaymentProviders>
  providerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentMethodsUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `userPaymentProvider` being updated. */
export type UpdateUserPaymentProviderOnUserPaymentProviderForUserPaymentProvidersUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  provider?: InputMaybe<PaymentProviders>
  providerId?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  slug?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPaymentProvidersUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `userPhone` being updated. */
export type UpdateUserPhoneOnUserPhoneForUserPhonesUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  type?: InputMaybe<UserPhonesType>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPhonesUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `userPolicy` being updated. */
export type UpdateUserPolicyOnUserPolicyForUserPoliciesPolicyIdFkeyPatch = {
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  policy?: InputMaybe<UserPoliciesPolicyIdFkeyInput>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPoliciesUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `userPolicy` being updated. */
export type UpdateUserPolicyOnUserPolicyForUserPoliciesUserIdFkeyPatch = {
  acceptedAt?: InputMaybe<Scalars['Datetime']['input']>
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  policy?: InputMaybe<UserPoliciesPolicyIdFkeyInput>
  policyId?: InputMaybe<Scalars['UUID']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  user?: InputMaybe<UserPoliciesUserIdFkeyInput>
}

/** An object where the defined keys will be set on the `userUpload` being updated. */
export type UpdateUserUploadOnUserUploadForUserUploadsUploadIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserUploadsUploadIdFkeyInput>
  user?: InputMaybe<UserUploadsUserIdFkeyInput>
  userId?: InputMaybe<Scalars['UUID']['input']>
}

/** An object where the defined keys will be set on the `userUpload` being updated. */
export type UpdateUserUploadOnUserUploadForUserUploadsUserIdFkeyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  rowId?: InputMaybe<Scalars['UUID']['input']>
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>
  upload?: InputMaybe<UserUploadsUploadIdFkeyInput>
  uploadId?: InputMaybe<Scalars['UUID']['input']>
  user?: InputMaybe<UserUploadsUserIdFkeyInput>
}
